// @flow
import k from "./keys";

export default {
  [k._]: `:`,
  [k._1]: `(`,
  [k._2]: `)`,
  [k.LIGHT]: `အလင်း`,
  [k.ANGEL]: `နတ်`,
  [k.DARK]: `မှောင်`,
  [k.DEMON]: `မကောင်းဆိုးဝါး`,
  [k.SELECT_ALL]: `အားလုံးကိုရွေးပါ`,
  [k.DESELECT_ALL]: `အားလုံးကိုမရွေးပါ`,
  [k.ALSBVYETHVN]: `alsbvyethvn`,
  [k.ALASKA]: `alaska`,
  [k.BSKJFH_KSJLHFVKLFSJB]: `bskjfh ksjlhfvklfsjb`,
  [k.CPQWHG_SKUGBHOWSFVJH]: `cpqwhg skugbhowsfvjh`,
  [k.DWQEFHKDVB_LASHDVSDALN_SJBVKSF]: `dwqefhkdvb lashdvsdaln sjbvksfjbv`,
  [k.SDV_ASODJHVSF_SLDHGVKSUFGV]: `sdv ;asodjhvsf sldhgvksufgv`,
  [k.KJSBFV]: `kjsbfv`,
  [k.POWQJIF]: `powqjif`,
  [k.XCUYWE]: `xcuywe`,
  [k.POIQRF]: `poiqrf`,
  [k.LABEL]: `တံဆိပ်`,
  [k.NONE]: `မရှိပါ`,
  [k.SYSTEM]: `စနစ်`,
  [k._3]: `0`,
  [k.CHECKBOX]: `အမှန်ခြစ်`,
  [k.LOADING_CHART]: `ဇယားကိုတင်နေသည်`,
  [k.ADD_A_CHART]: `+ ဇယားထည့်ပါ`,
  [k.CREATED_BY]: `ဖန်တီးသူ:`,
  [k.DELETE_DASHBOARD]: `ဒက်ရှ်ဘုတ်ကိုဖျက်ပါ`,
  [k.ARE_YOU_SURE_YOU_WANT_TO_DELET]: `သင်ဖျက်ချင်သည်မှာသေချာပါသလား`,
  [k.PINNED_CHARTS_WILL_NOT_BE_DELE]: `တပ်ထားသောဇယားများကိုမဖျက်ပါ။`,
  [k.CANCEL]: `ပယ်ဖျက်ပါ`,
  [k.DELETE]: `ဖျက်ပါ`,
  [k.DASHBOARD]: `ဒက်ရှ်ဘုတ်`,
  [k.CREATE_NEW]: `+ အသစ်ဖန်တီးပါ`,
  [k.REFRESH_DASHBOARD]: `ဒက်ရှ်ဘုတ်ကိုအသစ်တင်ပါ`,
  [k.DELETE_DASHBOARD1]: `ဒက်ရှ်ဘုတ်ကိုဖျက်ပါ`,
  [k.BUTTON]: `ခလုတ်`,
  [k.NO_DASHBOARD_SELECTED]: `ဒက်ရှ်ဘုတ်မရွေးရသေးပါ`,
  [k.SELECT]: `ရွေးချယ်ပါ`,
  [k.ADDBUTTON]: `addButton`,
  [k.U_B_ADD]: `\u002B ထည့်ပါ`,
  [k._4]: ``,
  [k._5]: `-`,
  [k.YOU_ARE_NOT_AUTHORIZED_CLICK]: `သင်ခွင့်ပြုချက်မရှိပါ။ အသေးစိတ်ကြည့်ရန် ဤနေရာကိုနှိပ်ပါ။`,
  [k.VIEW_REMAINING_SIGNATORIES]: `လက်မှတ်ထိုးသူများကိုကြည့်ရန်`,
  [k.ADD]: `ထည့်ပါ`,
  [k.ARE_YOU_SURE_YOU_WANT_TO_CANCE]: `သင်အတည်ပြုမှုကိုပယ်ဖျက်ချင်သည်မှာသေချာပါသလား? ၎င်းသည် စစ်ဆေးစာရင်းအကွက်များကို လွှတ်ပေးပြီး အခြေအနေကိုပြောင်းလဲပြီး ယခင်အတည်ပြုမှုကို ပယ်ဖျက်ပါမည်။`,
  [k.PLEASE_ENTER_A_COMMENT]: `မှတ်ချက်ထည့်ပါ`,
  [k.NO]: `မဟုတ်ပါ`,
  [k.YES]: `ဟုတ်ပါသည်`,
  [k.CANCELLATION]: `ပယ်ဖျက်ခြင်း -`,
  [k.HIDE]: `ဖျောက်ပါ`,
  [k.SHOW]: `ပြပါ`,
  [k.LINE_THROUGH]: `မျဉ်းဖြတ်ထားသည်`,
  [k.INCOMPLETE]: `မပြီးသေးပါ`,
  [k.CONFIGURE_AD_HOC_SIGNATURE]: `အထူးလက်မှတ်ကိုပြင်ဆင်ပါ`,
  [k.NUMBER_OF_SIGNATORIES]: `လက်မှတ်ထိုးသူအရေအတွက်`,
  [k.USERS]: `အသုံးပြုသူများ`,
  [k.GROUPS]: `အုပ်စုများ`,
  [k.CONFIRM]: `အတည်ပြုပါ`,
  [k.REQUEST_APPROVAL]: `အတည်ပြုမှုတောင်းခံပါ`,
  [k.ADD_SIGNATURE]: `+ လက်မှတ်ထည့်ပါ`,
  [k.APPLY_YOUR_SIGNATURE]: `သင့်လက်မှတ်ထည့်ပါ`,
  [k.TYPE]: `အမျိုးအစား`,
  [k.APPROVAL]: `အတည်ပြုမှု`,
  [k.REJECTION]: `ငြင်းပယ်ခြင်း`,
  [k.EMAIL_ID]: `အီးမေးလ်အိုင်ဒီ`,
  [k.OTP_SENT_AGAIN_PLEASE_CHECK_Y]: `OTP ကိုထပ်မံပို့ပြီးပါပြီ။ သင့်အီးမေးလ်ကိုစစ်ဆေးပါ။`,
  [k.OTP_SENT_TO_THE_MENTIONED_EMAI]: `OTP ကိုဖော်ပြထားသောအီးမေးလ်လိပ်စာသို့ပို့ပြီးပါပြီ။`,
  [k.RESEND]: `ထပ်မံပို့ပါ`,
  [k.PASSWORD]: `စကားဝှက်`,
  [k.OTP]: `OTP`,
  [k.INCORRECT_OTP]: `OTP မှားယွင်းနေသည်`,
  [k.GENERATE_OTP]: `OTP ထုတ်ယူပါ`,
  [k.APPROVAL1]: `အတည်ပြုမှု`,
  [k.COMMENT]: `မှတ်ချက်`,
  [k.UPLOAD_YOUR_OWN_SIGNATURE]: `သင့်လက်မှတ်ကိုတင်ပါ`,
  [k.ATTACH_FILE]: `ဖိုင်တွဲပါ`,
  [k.USE_SYSTEM_GENERATED_SIGNATURE]: `စနစ်ထုတ်လက်မှတ်ကိုသုံးပါ`,
  [k.CONFIRM_AND_SIGN]: `အတည်ပြုပြီး လက်မှတ်ထိုးပါ`,
  [k.RED]: `အနီရောင်`,
  [k.ENTER_EMAIL]: `အီးမေးလ်ထည့်ပါ`,
  [k.UPLOAD_NEW]: `အသစ်တင်ပါ`,
  [k.UPLOAD]: `တင်ပါ`,
  [k.BY]: `အားဖြင့်:`,
  [k.YOU]: `သင်`,
  [k.ID]: `ID:`,
  [k.MEMBERS]: `အဖွဲ့ဝင်များ`,
  [k.MEMBER]: `အဖွဲ့ဝင်`,
  [k.USER]: `user-`,
  [k.GROUP]: `group-`,
  [k.REMOVE_SELECTED_USER]: `ရွေးထားသောအသုံးပြုသူကိုဖယ်ရှားပါ`,
  [k.LIST]: `စာရင်း`,
  [k.USER1]: `အသုံးပြုသူ`,
  [k.GROUP1]: `အုပ်စု`,
  [k.LINK]: `လင့်ခ်`,
  [k.ENTER_USER_S_EMAIL]: `အသုံးပြုသူ၏အီးမေးလ်ထည့်ပါ`,
  [k.ADD_NEW_USER]: `အသစ်ထည့်ပါ`,
  [k.SELECT_USERS]: `အသုံးပြုသူများရွေးပါ`,
  [k.ENTER_VALID_EMAIL]: `မှန်ကန်သောအီးမေးလ်ထည့်ပါ`,
  [k.TOGGLEUSERDROPDOWN]: `toggleUserDropdown`,
  [k.REMOVEUSER]: `removeUser`,
  [k.DECREMENT]: `လျှော့ချပါ`,
  [k.NO_USER_SELECTED]: `အသုံးပြုသူမရွေးရသေးပါ`,
  [k.ADD1]: `ထည့်ပါ`,
  [k.ENTER_TITLE]: `ခေါင်းစဉ်ထည့်ပါ`,
  [k.SEARCH]: `ရှာပါ`,
  [k.SHOWING_RESULTS_SEARCH_TO_FIND]: `ရလဒ် ၁၂ ခုပြနေသည်။ အခြားသူများကိုရှာရန် ရှာဖွေပါ။`,
  [k.PRIVATE]: `ပုဂ္ဂလိက`,
  [k.LOADING]: `တင်နေသည်...`,
  [k.CREATE]: `+ ဖန်တီးပါ`,
  [k.REMOVE]: `ဖယ်ရှားပါ`,
  [k.ARE_YOU_SURE_YOU_WANT_TO_REMOV]: `သင်ဖယ်ရှားချင်သည်မှာသေချာပါသလား`,
  [k.FROM_THE_CHECKLIST]: `စစ်ဆေးစာရင်းမှ`,
  [k.CONVERSATION]: `ဆွေးနွေးမှု`,
  [k.VIEW_ALL_FIELDS]: `အကွက်အားလုံးကြည့်ပါ`,
  [k.UPDATE]: `အသစ်ပြင်ပါ`,
  [k._7]: `#`,
  [k.NO_TITLE]: `ခေါင်းစဉ်မရှိပါ`,
  [k.MAKE_AS_CURRENT_REVISION]: `လက်ရှိပြင်ဆင်ချက်အဖြစ်သတ်မှတ်ပါ`,
  [k.ARE_YOU_SURE_YOU_WANT_TO_MAKE]: `သင်သတ်မှတ်ချင်သည်မှာသေချာပါသလား`,
  [k.AS_THE_CURRENT_REVISION]: `လက်ရှိပြင်ဆင်ချက်အဖြစ်`,
  [k.CURRENT_REVISION]: `လက်ရှိပြင်ဆင်ချက်`,
  [k.CURRENTREVISION]: `currentRevision`,
  [k.CURRENT]: `လက်ရှိ`,
  [k.MAKE_CURRENT_REVISION]: `လက်ရှိပြင်ဆင်ချက်အဖြစ်သတ်မှတ်ပါ`,
  [k.MAKE_CURRENT]: `လက်ရှိအဖြစ်သတ်မှတ်ပါ`,
  [k.VIEWING_NOW]: `ယခုကြည့်နေသည်`,
  [k.NO_TITLE1]: `ခေါင်းစဉ်မရှိပါ`,
  [k.DONE]: `ပြီးပါပြီ`,
  [k.MORE]: `နောက်ထပ်`,
  [k.UNIFIZE_UNIFIZEBLUE]: `unifize_unifizeBlue`,
  [k.CREATE_NEW1]: `အသစ်ဖန်တီးပါ`,
  [k.DOCUMENT]: `စာရွက်စာတမ်း`,
  [k.ENTER_TITLE1]: `ခေါင်းစဉ်ထည့်ပါ`,
  [k.NOTE_YOUR_DOCUMENT_WILL_BE_SH]: `မှတ်ချက်- သင့်စာရွက်စာတမ်းကို ဤဆွေးနွေးမှုတွင်ပါဝင်သူအားလုံးနှင့်မျှဝေပါမည်။`,
  [k.CREATE1]: `ဖန်တီးပါ`,
  [k.FILEICONS]: `fileIcons`,
  [k.ARE_YOU_SURE_YOU_WANT_TO_DELET1]: `သင်ဖျက်ချင်သည်မှာသေချာပါသလား "`,
  [k.INLINE_BLOCK]: `inline-block`,
  [k._9]: `.`,
  [k._10]: `"`,
  [k.ARE_YOU_SURE_YOU_WANT_TO_REMOV1]: `ဤဖိုင်ကိုဖယ်ရှားချင်သည်မှာသေချာပါသလား?`,
  [k.REMOVE_FROM_CHECKLIST]: `စစ်ဆေးစာရင်းမှဖယ်ရှားပါ`,
  [k.FROM_UNIFIZE_FILE_STORE]: `Unifize ဖိုင်သိုလှောင်ရာမှ`,
  [k.UPLOADING_FILE]: `ဖိုင်တင်နေသည်...`,
  [k.OTHERS]: `အခြားများ`,
  [k.PREVIEW]: `ကြိုတင်ကြည့်ရှုမှု`,
  [k.EDIT]: `ပြင်ဆင်ပါ`,
  [k.FILECONTAINER]: `fileContainer`,
  [k.FILENAME]: `ဖိုင်အမည်`,
  [k._11]: `|`,
  [k.UPLOADED_ON]: `တင်သွင်းသည့်နေ့:`,
  [k.NO_PREVIEW_AVAILABLE]: `ကြိုတင်ကြည့်ရှုမှုမရှိပါ`,
  [k.CHECKLIST]: `စစ်ဆေးစာရင်း`,
  [k.PICK_SOURCE]: `ရင်းမြစ်ရွေးပါ`,
  [k.UNIFIZE_FILE_STORE]: `Unifize ဖိုင်သိုလှောင်ရာ`,
  [k.COMPUTER]: `ကွန်ပျူတာ`,
  [k.NO_SOURCE_SELECTED]: `ရင်းမြစ်မရွေးရသေးပါ`,
  [k._12]: `,`,
  [k.SELECT_FORM]: `+ ဖောင်ရွေးပါ`,
  [k.AUTO_SELECT_ALL_REVISIONS]: `ပြင်ဆင်ချက်အားလုံးကိုအလိုအလျောက်ရွေးပါ`,
  [k.SELECT_MANUALLY]: `ကိုယ်တိုင်ရွေးပါ`,
  [k.BACK]: `နောက်သို့`,
  [k.AUTO_SELECT_ALL_REVISIONS_IS]: `ပြင်ဆင်ချက်အားလုံးကိုအလိုအလျောက်ရွေးခြင်းသည်`,
  [k.EDIT_SELECTED_REVISION_S]: `ရွေးထားသောပြင်ဆင်ချက်(များ)ကိုပြင်ပါ`,
  [k.ALL_REVISIONS]: `ပြင်ဆင်ချက်အားလုံး`,
  [k.SELECT_REVISIONS]: `ပြင်ဆင်ချက်များရွေးပါ`,
  [k.REMOVE_LINK_OR_REASSIGN_REVISI]: `လင့်ခ်ဖယ်ရှားပါ သို့မဟုတ် ပြင်ဆင်ချက်များပြန်လည်သတ်မှတ်ပါ?`,
  [k.THIS_CONVERSATION_HAS_MULTIPLE]: `ဤဆွေးနွေးမှုတွင် ပြင်ဆင်ချက်များစွာရှိသည်။ ၎င်းတို့အားလုံး၏လင့်ခ်ကိုဖယ်ရှားချင်ပါသလား?`,
  [k.REASSIGN_REVISIONS]: `ပြင်ဆင်ချက်များပြန်လည်သတ်မှတ်ပါ`,
  [k.REMOVE_LINK]: `လင့်ခ်ဖယ်ရှားပါ`,
  [k.ADDCONVERSATIONBUTTON]: `addConversationButton`,
  [k.AUTO_SELECT_CURRENT_REVISION]: `လက်ရှိပြင်ဆင်ချက်ကိုအလိုအလျောက်ရွေးပါ`,
  [k.AUTO_SELECT_CURRENT_REVISION_I]: `လက်ရှိပြင်ဆင်ချက်ကိုအလိုအလျောက်ရွေးပါ`,
  [k.EDIT_SELECTED_REVISION]: `ရွေးထားသောပြင်ဆင်ချက်ကိုပြင်ပါ`,
  [k.SELECT_REVISION]: `ပြင်ဆင်ချက်ရွေးပါ`,
  [k.NEW_ITEM]: `အသစ်ဖန်တီးပါ`,
  [k.ITEM]: `item "`,
  [k.SELECT_CHECKLIST_FIELDS]: `စစ်ဆေးစာရင်းများရွေးပါ`,
  [k.CREATE_VERSION]: `ပြင်ဆင်ချက်အသစ်ဖန်တီးပါ`,
  [k.CREATE_NEW_REVISION]: `ပြင်ဆင်ချက်အသစ်ဖန်တီးပါ`,
  [k.ARE_YOU_SURE_YOU_WANT_TO_CREAT]: `သင်သတ်မှတ်ချင်သည်မှာသေချာပါသလား?`,
  [k.CANCELLERS]: `ပြင်ဆင်ချက်များပြန်လည်သတ်မှတ်ပါ`,
  [k.ALLOWED_CANCELLERS]: `ပြင်ဆင်ချက်များပြန်လည်သတ်မှတ်ပါ`,
  [k.ALLOWED_SIGNATORIES]: `ပြင်ဆင်ချက်များပြန်လည်သတ်မှတ်ပါ`,
  [k.ROLES]: `အကြောင်းအရာ`,
  [k.FIELDS]: `အကွက်အားလုံး`,
  [k.SPECIFIC_USERS]: `အကြောင်းအရာများ`,
  [k.SELECT_THE_DATA_TO_COPY_TO_NEW]: `အသစ်ဖန်တီးပါ`,
  [k.CHECKLIST_AND_FORM_DATA]: `စစ်ဆေးစာရင်းနှင့်ဖောင်ရွေးပါ`,
  [k.SELECT_FIELDS]: `အကွက်အားလုံးရွေးပါ`,
  [k.REVISION_NOTES]: `ပြင်ဆင်ချက်မှတ်ချက်`,
  [k.WHY_ARE_YOU_MAKING_THIS_REVISI]: `ဘာကြောင့်ဤပြင်ဆင်ချက်ကိုဖန်တီးပါသလဲ?`,
  [k.CREATE_REVISION]: `ပြင်ဆင်ချက်ဖန်တီးပါ`,
  [k.REVISION]: `ပြင်ဆင်ချက်`,
  [k.CREATE_REVISION1]: `ပြင်ဆင်ချက်ဖန်တီးပါ`,
  [k.CONVERSATION1]: `ဆွေးနွေးမှု`,
  [k.NO_MATCHING_RESULTS]: `မကိုက်ညီများစွာရှိပါသည်။`,
  [k.ADD_NEW_USER1]: `+ အသစ်ဖန်တီးပါ`,
  [k.CHECKLISTREMOVE]: `checklistRemove`,
  [k.UPLOAD_NEW_VERSION]: `ဖိုင်တင်နေသည်...`,
  [k.DOWNLOAD]: `ဒေါင်းလုပ်ပါ`,
  [k.MMM_DD_YYYY]: `MMM DD, YYYY`,
  [k.NOT_ASSIGNED]: `မလုပ်ပါ`,
  [k.SEND_AN_EMAIL_TO_CONVERSATION]: `ဆွေးနွေးမှုသို့အီးမေးလ်တင်ပါ`,
  [k.FILES]: `ဖိုင်များ`,
  [k.DATA]: `အကူအညီ`,
  [k.INFO]: `အကူအညီ`,
  [k.CHECKLIST1]: `စစ်ဆေးစာရင်း`,
  [k.JSON_FOR_ADOBE]: `JSON for Adobe`,
  [k.JSON_FOR_PDFGENERATORAPI]: `JSON for PDFGeneratorAPI`,
  [k.SAVE]: `သိမ်းပါ`,
  [k.REFRESH]: `ပြန်လည်စစ်ဆေးပါ`,
  [k.TO_SEE_LATEST_CHECKLIST_DATA]: `ပြင်ဆင်ချက်စာရင်းအကူအညီကိုကြည့်ပါ`,
  [k.CREATOR]: `ဖန်တီးပါ`,
  [k.DATE_CREATED]: `ဖန်တီးသည့်နေ့`,
  [k.MMM_DD_YYYY_HH_MM_A]: `MMM DD, YYYY hh:mm a`,
  [k.AGE]: `အရာရှည်`,
  [k.DAYS]: `ရက်များ`,
  [k.DAYS1]: `ရက်များ`,
  [k.PARENT1]: `Parent:`,
  [k.CHILD]: `, Child:`,
  [k.LEAVE_CONVERSATION]: `ဆွေးနွေးမှုကိုရပ်ပါ`,
  [k.PUBLIC]: `ပိုက်ဆိုး`,
  [k.HIDE_CHAT_CONTENT]: `ဆွေးနွေးမှုအကူအညီကိုရပ်ပါ`,
  [k.HIDE_EVERYTHING]: `အကူအညီအားလုံးကိုရပ်ပါ`,
  [k.ADD_NEW_FIELDS]: `အသစ်ဖန်တီးပါ`,
  [k.PRIVACY_SETTINGS]: `ပိုက်ဆိုးအကူအညီ`,
  [k.NORMAL]: `အသုံးပြုသူ`,
  [k.MAKE_PRIVATE]: `ပိုက်ဆိုးအကူအညီ`,
  [k.ONLY_PARTICIPANTS_CAN_ACCESS_T]: `Only participants can access these records`,
  [k.HIDE_ONLY_CHAT_CONTENT]: `ဆွေးနွေးမှုအကူအညီကိုရပ်ပါ`,
  [k.ONLY_THE_CONTENTS_OF_THE_CONVE]: `မှတ်တမ်း၏အကြောင်းအရာများသာဖုံးကွယ်ထားပါမည်။ မှတ်တမ်း၏ခေါင်းစဉ်၊ အခြေအနေနှင့် ပိုင်ဆိုင်သူများကို အခြားသူများကြားရပါမည်။`,
  [k.CONVERSATIONS_WILL_BE_VISIBLE]: `မှတ်တမ်းများကို ပါဝင်သူများ၊ အုပ်ချုပ်သူ(များ)၊
              နှင့် ဖြူးဖြူးပြုထားသူများသာကြားရပါမည်။`,
  [k.REMINDERS]: `မှတ်ချက်များ`,
  [k.REMINDERS1]: `မှတ်ချက်များ`,
  [k.WHATSAPP]: `whatsapp`,
  [k.ON]: `On`,
  [k.OFF]: `Off`,
  [k.LEFTHANDLE]: `leftHandle`,
  [k.DOWNLOAD_PROHIBITED]: `ဒေါင်းလုပ်ပါ`,
  [k.DOWNLOADING_FILES_IS_PROHIBITE]: `ဒေါင်းလုပ်ပါ`,
  [k.WE_RE_SORRY_SOMETHING_S_GONE]: `မှားနေပါတယ်။`,
  [k.OUR_TEAM_HAS_BEEN_NOTIFIED_BU]: `ကျွန်ုပ်တို့၏အဖွဲ့အစည်းကိုသတိပြုခဲ့ပါသည်၊ သို့သော်`,
  [k.LET_US_KNOW]: `let us know`,
  [k.WHAT_HAPPENED]: `what happened.`,
  [k.BROWSER]: `Browser:`,
  [k.VERSION]: `Version:`,
  [k.UID]: `UID:`,
  [k.URL]: `URL:`,
  [k.ORG]: `Org:`,
  [k.TRY_AGAIN]: `Try again`,
  [k.CHROME]: `Chrome`,
  [k.FIREFOX]: `Firefox`,
  [k.MICROSOFT_INTERNET_EXPLORER]: `Microsoft Internet Explorer`,
  [k.SAFARI]: `Safari`,
  [k.EDGE]: `Edge`,
  [k.OPERA]: `Opera`,
  [k.COULD_NOT_FETCH_CHAT_ROOMS]: `ဆွေးနွေးခန်းများကို ရယူနိုင်ခြင်းမရှိ:`,
  [k.RETRY]: `ပြန်လည်စစ်ပါ`,
  [k._13]: `+`,
  [k.SCROLLCOLUMN_D]: `scrollColumn2d`,
  [k.HOME]: `ပိုက်ဆိုး`,
  [k.WELCOME_BACK]: `ကျေးဇူးတင်ပါတယ်!`,
  [k.LOADING_USER]: `အသုံးပြုသူကိုဖြည့်စွက်ပါ...`,
  [k.YOUR_HOME_SCREEN_HAS_NOT_BEEN]: `ပိုက်ဆိုးမရပါ`,
  [k.UNIFIZE_HOME_NOT_SET_UP]: `Unifize အိမ်ကိုဖွဲ့စည်းထားခြင်းမရှိ`,
  [k.CONTACT_YOUR_ORG_ADMIN_TO_SET]: `သင့်အဖွဲ့အစည်းအုပ်ချုပ်သူကိုဆက်သွယ်ပြီး သင့်Unifize အိမ်ကိုဖွဲ့စည်းပါ`,
  [k.HERE_S_WHAT_S_GOING_ON_AT]: `ဤနေရာတွင် ဘာဖြစ်နေသလဲ`,
  [k.CLOSE1]: `ပိတ်ပါ`,
  [k.SKIP_INVITE]: `ဖိတ်ကြားခြင်းကိုကျော်ပါ`,
  [k.DO_NOT_ADD_CREATOR_AS_OWNER]: `ဖန်တီးသူကို ပိုင်ရှင်အဖြစ်ထည့်ပါနဲ့`,
  [k.DO_NOT_ADD_CREATOR_AS_PARTICIP]: `ဖန်တီးသူကို ပါဝင်သူအဖြစ်ထည့်ပါနဲ့`,
  [k.DO_NOT_SEND_CONFIRMATION_TO_SE]: `အတည်ပြုချက်ကို ပို့ပါနဲ့`,
  [k.DISABLE_AUTO_NUMBER]: `အလိုအလျောက်နံပါတ်ကိုပိတ်ပါ`,
  [k.CONVERT_TO_FEED]: `ဖြစ်ရပ်အဖြစ်ပြောင်းပါ`,
  [k.SLA_IN_DAYS_AUTO_FILL_DUE_DAT]: `ရက်ပေါင်းအတွင်း SLA (အလိုအလျောက်ပြီးစီးရက်စွဲဖြည့်ပါ)`,
  [k.EMAILS_SENT_HERE_WILL_START_A]: `ဤနေရာတွင် ပို့သောအီးမေးလ်များသည် အသစ်ဖြစ်ရပ်ကိုစတင်ပါ`,
  [k.DO_NOT_SHOW_THIS_PROCESS_IN]: `ဤလုပ်ငန်းစဉ်ကို + NEW တွင်ပြပါနဲ့`,
  [k.DO_NOT_INVITE_SENDER_TO_CONVER]: `ပို့သူကို ဆွေးနွေးမှုသို့ဖိတ်ကြားပါနဲ့`,
  [k.NEXT_COUNT]: `နောက်ထပ်နံပါတ်`,
  [k.NOTIFY_GROUPS]: `အဖွဲ့အစည်းများကိုသတိပေးပါ`,
  [k.UNIFIZE_HOME_NOT_SET_UP]: `Unifize အိမ်ကိုဖွဲ့စည်းထားခြင်းမရှိ`,
  [k.CONTACT_YOUR_ORG_ADMIN_TO_SET]: `သင့်အဖွဲ့အစည်းအုပ်ချုပ်သူကိုဆက်သွယ်ပြီး သင့်Unifize အိမ်ကိုဖွဲ့စည်းပါ`,
  [k.HERE_S_WHAT_S_GOING_ON_AT]: `ဤနေရာတွင် ဘာဖြစ်နေသလဲ`,
  [k.CLOSE1]: `ပိတ်ပါ`,
  [k.SKIP_INVITE]: `ဖိတ်ကြားခြင်းကိုကျော်ပါ`,
  [k.DO_NOT_ADD_CREATOR_AS_OWNER]: `ဖန်တီးသူကို ပိုင်ရှင်အဖြစ်ထည့်ပါနဲ့`,
  [k.DO_NOT_ADD_CREATOR_AS_PARTICIP]: `ဖန်တီးသူကို ပါဝင်သူအဖြစ်ထည့်ပါနဲ့`,
  [k.DO_NOT_SEND_CONFIRMATION_TO_SE]: `ပို့သူကို အတည်ပြုချက်ကို ပို့ပါနဲ့`,
  [k.DISABLE_AUTO_NUMBER]: `အလိုအလျောက်နံပါတ်ကိုပိတ်ပါ`,
  [k.CONVERT_TO_FEED]: `ဖြစ်ရပ်အဖြစ်ပြောင်းပါ`,
  [k.SLA_IN_DAYS_AUTO_FILL_DUE_DAT]: `ရက်ပေါင်းအတွင်း SLA (အလိုအလျောက်ပြီးစီးရက်စွဲဖြည့်ပါ)`,
  [k.EMAILS_SENT_HERE_WILL_START_A]: `ဤနေရာတွင် မီးရေးမှာ အသစ်ဖြစ်ရပ်ကိုစတင်ပါ`,
  [k.DO_NOT_SHOW_THIS_PROCESS_IN]: `ဤလုပ်ငန်းစဉ်ကို + NEW တွင်ပြပါနဲ့`,
  [k.DO_NOT_INVITE_SENDER_TO_CONVER]: `ပို့သူကို ဆွေးနွေးမှုသို့ဖိတ်ကြားပါနဲ့`,
  [k.NEXT_COUNT]: `နောက်ထပ်နံပါတ်`,
  [k.NOTIFY_GROUPS]: `အဖွဲ့အစည်းများကိုသတိပေးပါ`,
  [k.ENABLE_PAGINATION_IN_PROCESS_T]: `လုပ်ငန်းစာရင်းတွင် ပိုက်ဆိုးပါ`,
  [k.ENABLE_PAGINATION_IN_REPORTS]: `အစီရင်ခံစာရင်းများတွင် စာမျက်နှာပြောင်းခြင်းကို ဖွဲ့စည်းပါ`,
  [k.ALLOW_ADHOC_ARCHIVING]: `အထူးသိမ်းဆည်းခြင်းကို ခွင့်ပြုပါ`,
  [k.ADD_FIELD]: `အကွက်ထည့်ပါ`,
  [k.FIELD1]: `အကွက်`,
  [k.DOWNLOAD_SAMPLE_CSV]: `CSV နမူနာကို ဒေါင်းလုပ်ပါ`,
  [k.ADD_FIELD1]: `အကွက်ထည့်ပါ`,
  [k.BEHAVIOR]: `အပြုအမူ`,
  [k.MANDATORY_IF_NOT_HIDDEN]: `ဖျောက်ထားခြင်းမရှိပါက အရေးကြီး`,
  [k.VALUE]: `တန်ဖိုး`,
  [k.CONDITION]: `အခြေအနေ`,
  [k.FORM_DATA]: `ဖောင်ဒေတာ`,
  [k.CHECKLIST_DATA]: `စစ်ဆေးစာရင်းဒေတာ`,
  [k.CONVERSATION_DATA]: `ဆွေးနွေးမှုဒေတာ`,
  [k.SHOW_UNTIL_CONDITION_MET]: `အခြေအနေပြီးစီးသည့်အထိ ပြပါ`,
  [k.HIDDEN_UNTIL_CONDITION_MET]: `အခြေအနေပြီးစီးသည့်အထိ ဖျောက်ထားပါ`,
  [k.MANDATORY_UNTIL_CONDITION_MET]: `အခြေအနေပြီးစီးသည့်အထိ အရေးကြီး`,
  [k.DISABLE_UNTIL_CONDITION_MET]: `အခြေအနေပြီးစီးသည့်အထိ ပိတ်ထားပါ`,
  [k.COPY]: `ကူးယူ`,
  [k.ADD_CONDITION_AND]: `+ အခြေအနေ (AND) ထည့်ပါ`,
  [k.ADD_NEW_CONDITION]: `+ အခြေအနေအသစ် ထည့်ပါ`,
  [k.DELETE_FIELD]: `အကွက်ဖျက်ပါ`,
  [k._17]: `?`,
  [k.FIELDNAMEINPUT]: `fieldNameInput-`,
  [k.FIELDSETTINGS]: `အကွက်ဆက်တင်များ`,
  [k.FORM]: `ဖောင်`,
  [k.NOT_ALLOWED]: `ခွင့်မပြုပါ`,
  [k.OLDSETTINGS]: `အဟောင်းဆက်တင်များ`,
  [k.PROMPT_WHOM]: `ဘယ်သူကိုသတိပေးမလဲ`,
  [k.WHEN]: `အချိန်`,
  [k.CREATE_RULES_TO_PROMPT_USERS_T]: `ဤအဆင့်ကိုပြီးစီးရန် အသုံးပြုသူများကိုသတိပေးရန် စည်းမျဉ်းများဖန်တီးပါዋ သတ်မှတ်ထားသောအသုံးပြုသူများသည် ဤအကွက်များကို ဆွေးနွေးမှုအတွင်း တွေ့မြင်နိုင်ပါသည်။`,
  [k.CREATE_NEW_RULE]: `စည်းမျဉ်းအသစ်ဖန်တီးပါ`,
  [k.AUTO_ARCHIVE]: `အလိုအလျောက်သိမ်းဆည်းပါ`,
  [k.SEND_MESSAGE]: `စာပို့ပါ`,
  [k.CHANGE_STATUS_TO]: `အခြေအနေပြောင်းပါ`,
  [k.ADD_PARTICIPANTS]: `ပါဝင်သူများထည့်ပါ`,
  [k.REMOVE_PARTICIPANTS]: `ပါဝင်သူများဖယ်ရှားပါ`,
  [k.UPDATE_PRIVACY]: `ကိုယ်ရေးအချက်အလက်ကိုအသစ်ပြင်ပါ`,
  [k.WHITELIST]: `အဖြူစာရင်း`,
  [k.DON_T_CHANGE]: `မပြောင်းပါနဲ့`,
  [k.MAKE_PUBLIC]: `အများသုံးအဖြစ်ပြောင်းပါ`,
  [k.UNARCHIVE]: `သိမ်းဆည်းမှုမှထုတ်ပါ`,
  [k.IS_NOT_SUPPORTED]: `မပံ့ပိုးပါ`,
  [k.GET_SIGNATURE_OF_ANY]: `မည်သူ့လက်မှတ်မဆိုရယူပါ`,
  [k.USER_S]: `အသုံးပြုသူ(များ)`,
  [k.SELECT_AD_HOC]: `အထူးရွေးချယ်ပါ`,
  [k.WHO_CAN_CANCEL]: `ဘယ်သူပယ်ဖျက်နိုင်သလဲ`,
  [k.WHEN_CAN_THEY_CANCEL]: `ဘယ်အချိန်မှာသူတို့ပယ်ဖျက်နိုင်သလဲ`,
  [k.HIDE_WHEN_INACTIVE]: `မသုံးလျှင်ဖျောက်ပါ`,
  [k.DISABLE_WHEN_INACTIVE]: `မသုံးလျှင်ပိတ်ပါ`,
  [k.CONTINUE_TO_LOCK_FIELDS_UNDER]: `ယခင်အတည်ပြုမှုအောက်တွင် အကွက်များကိုဆက်လက်ပိတ်ထားပါ`,
  [k.LOCK_CHECKLIST_FIELDS_DURING_A]: `အတည်ပြုမှု/ငြင်းပယ်မှုအတွင်းနှင့်နောက်ပိုင်းတွင် စစ်ဆေးစာရင်းအကွက်များကိုပိတ်ထားပါ:`,
  [k.LOCK_STATUS_PREVENT_USERS_FRO]: `အခြေအနေကိုပိတ်ထားပါ (အသုံးပြုသူများအခြေအနေပြောင်းလဲခြင်းကိုတားဆီးပါ)`,
  [k.CHANGE_OWNER_TO]: `ပိုင်ရှင်ပြောင်းပါ`,
  [k.SEND_A_MESSAGE]: `စာတစ်စောင်ပို့ပါ`,
  [k.MARK_REVISION_AS_CURRENT]: `ပြင်ဆင်ချက်ကိုလက်ရှိအဖြစ်သတ်မှတ်ပါ`,
  [k.CANCEL_ALL_PREVIOUS_APPROVALS]: `ယခင်အတည်ပြုမှုအားလုံးကိုပယ်ဖျက်ပါ (အဆင့်လိုက်အတွင်း)`,
  [k.SELECT_CHECKLIST_FIELD]: `စစ်ဆေးစာရင်းအကွက်ရွေးပါ`,
  [k.DELETED_FIELD]: `ဖျက်ထားသောအကွက်`,
  [k.PROCESS]: `လုပ်ငန်းစဉ်`,
  [k.EMBEDDED_FIELDS]: `ထည့်သွင်းထားသောအကွက်များ`,
  [k.ADD_EMBEDED_FIELD]: `ထည့်သွင်းအကွက်ထည့်ပါ`,
  [k.ONLY_ALLOW_CREATING_NEW_CONVER]: `ဆွေးနွေးမှုအသစ်ဖန်တီးခြင်းသာခွင့်ပြုပါ`,
  [k.ONLY_ALLOW_SELECTING_EXISTING]: `ရှိပြီးသားဆွေးနွေးမှုများသာရွေးခွင့်ပြုပါ`,
  [k.ALLOW_BOTH_SELECTING_AND_CREAT]: `ရွေးခြင်းနှင့်ဖန်တီးခြင်းနှစ်မျိုးလုံးခွင့်ပြုပါ`,
  [k.ALLOW_MULTIPLE]: `တစ်ခါထက်ပိုခွင့်ပြုပါ`,
  [k.ALLOW_ARCHIVED_CONVERSATIONS]: `သိမ်းဆည်းထားသောဆွေးနွေးမှုများခွင့်ပြုပါ`,
  [k.SHOW_FIELD_NAMES_IN_PREVIEW]: `ကြိုတင်ကြည့်ရှုမှုတွင်အကွက်အမည်များပြပါ`,
  [k.SHOW_STATUS_DUE_DATE]: `အခြေအနေ၊ သတ်မှတ်ထားသည့်နေ့စွဲပြပါ`,
  [k.AUTO_FILL_RELATED_CONVERSATION]: `ဆက်စပ်ဆွေးနွေးမှုကိုအလိုအလျောက်ဖြည့်ပါ`,
  [k.SUPRESS_TITLE_HYPERLINK_TO_THE]: `မှတ်တမ်းအမည်လင့်ခ်ကိုဖျောက်ထားပါ`,
  [k.SORTBY]: `စီပါ:`,
  [k.CREATED_DATE]: `ဖန်တီးသည့်နေ့`,
  [k.ADDED_DATE]: `ထည့်သွင်းသည့်နေ့`,
  [k.SELECT_EXISTING_BY]: `ရှိပြီးသားဖြင့်ရွေးပါ`,
  [k.TITLE]: `ခေါင်းစဉ်`,
  [k.PLACEHOLDER]: `အစားထိုးစာသား`,
  [k.ALLOW_OFFICE_INTEGRATION]: `Office 365 ပေါင်းစပ်ခွင့်ပြုပါ`,
  [k.YOU_MUST_SELECT_A_DEFAULT_FOLD]: `ဖိုင်တင်ရန် သို့မဟုတ် ဖန်တီးရန် sharepoint/office365 တွင် မူရင်းဖိုလ်ဒါရွေးရမည်။`,
  [k.AUTHENTICATE_AND_SELECT_FOLDER]: `အတည်ပြု၍ ဖိုလ်ဒါရွေးပါ`,
  [k.VIEW]: `ကြည့်ပါ`,
  [k.FOLDER]: `ဖိုလ်ဒါ`,
  [k.CONSUMPTION_OPTIONS]: `သုံးစွဲမှုရွေးချယ်စရာများ:`,
  [k.ALLOW_SINGLE]: `တစ်ခုတည်းခွင့်ပြုပါ`,
  [k.PREVIEW_OPTIONS]: `ကြိုတင်ကြည့်ရှုမှုရွေးချယ်စရာများ:`,
  [k.SHOW_FULL_PREVIEW]: `ကြည့်ရှုမှုအပြည့်ပြပါ`,
  [k.SORT_BY]: `စီပါ:`,
  [k.DATE]: `နေ့စွဲ`,
  [k.NAME]: `အမည်`,
  [k.DEFAULT_FILE]: `မူရင်းဖိုင်:`,
  [k.SUPPRESS_NOTIFICATIONS_ON_DEFA]: `မူရင်းတန်ဖိုးများအတွက်အသိပေးချက်များဖျောက်ထားပါ`,
  [k.FILE_UPLOAD_OPTIONS]: `ဖိုင်တင်ရန်ရွေးချယ်စရာများ:`,
  [k.UPLOAD_FROM_COMPUTER]: `ကွန်ပျူတာမှတင်ပါ`,
  [k.OFFICE_ONEDRIVE_SHAREPOI]: `Office 365 OneDrive / Sharepoint`,
  [k.FOLDER_PATH]: `ဖိုလ်ဒါလမ်းကြောင်း`,
  [k.THE_CREATED_FILE_CAN_BE_EDITED]: `ဖန်တီးထားသောဖိုင်ကို chatroom အဖွဲဝင်များပြင်နိုင်သည်`,
  [k.ADD_A_FORM]: `+ ဖောင်ထည့်ပါ`,
  [k.AUTO_FILL_RELATED_CONVERSATION1]: `ဆက်စပ်ဆွေးနွေးမှုများအလိုအလျောက်ဖြည့်ပါ`,
  [k.SHOW_COMPRESSED_PREVIEW]: `ဖိသိပ်ထားသောကြည့်ရှုမှုပြပါ`,
  [k.SHOW_STATUS_OWNER_AND_DUE_DAT]: `အခြေအနေ၊ ပိုင်ရှင်နှင့် သတ်မှတ်ထားသည့်နေ့စွဲပြပါ`,
  [k.SUPPRESS_TITLE_HYPERLINK_TO_TH]: `မှတ်တမ်းအမည်လင့်ခ်ကိုဖျောက်ထားပါ`,
  [k.LINKED_FIELD_RELATION]: `ချိတ်ဆက်ထားသောအကွက်ဆက်နွယ်မှု:`,
  [k.CHILD1]: `ကလေး`,
  [k.PARENT2]: `မိဘ`,
  [k.CHILD2]: `ကလေး`,
  [k.OTHER_OPTIONS]: `အခြားရွေးချယ်စရာများ:`,
  [k.ALLOW_ONLY_SELECTING]: `ရွေးချယ်ခြင်းသာခွင့်ပြုပါ`,
  [k.ALLOW_SELECTING_AND_CREATING]: `ရွေးချယ်ခြင်းနှင့်ဖန်တီးခြင်းခွင့်ပြုပါ`,
  [k.ALLOW_ONLY_CREATING]: `ဖန်တီးခြင်းသာခွင့်ပြုပါ`,
  [k.ONLY_SHOW_LINKED_FIELDS]: `ချိတ်ဆက်ထားသောအကွက်များသာပြပါ`,
  [k.REVISIONS]: `ပြင်ဆင်ချက်များ:`,
  [k.ALLOW_MANUAL_REVISION_LINKING]: `ပြင်ဆင်ချက်လင့်ခ်ကိုကိုယ်တိုင်ချိတ်ဆက်ခွင့်ပြုပါ`,
  [k.THERE_ARE_NO_REVISIONS]: `ပြင်ဆင်ချက်မရှိပါ`,
  [k.CREATED]: `ဖန်တီးပြီး`,
  [k.MAX]: `အများဆုံး`,
  [k.MIN]: `အနည်းဆုံး`,
  [k.MAX_VALUE_SHOULD_BE_MORE_THAN]: `အများဆုံးတန်ဖိုးသည် အနည်းဆုံးထက်ပိုရမည်။`,
  [k.STEP]: `အဆင့်`,
  [k.MINIMUM_PLACES_TO_DISPLAY_AFTE]: `ဒဿမအနောက်တွင် ပြသရန်အနည်းဆုံးနေရာများ (သတ်မှတ်ထားသည့်အရေအတွက်ထက်နည်းသော်လည်း အပျောက်အလင်းအနံ့ပြပါ)`,
  [k.IF_THE_USER_ENTERS_MORE_DIGITS]: `အသုံးပြုသူသည် ဒဿမအနောက်တွင် ပိုမိုသောဂဏန်းများထည့်ပါက:`,
  [k.DON_T_ROUND_OFF_OR_TRUNCATE]: `မလုံးဝိုင်းပါနှင့်၊ မဖြတ်ပါနှင့်`,
  [k.ROUND_OFF_WHEN_DISPLAYING_BUT]: `ပြသသည့်အခါလုံးဝိုင်းပါ၊ ထည့်သည့်အတိုင်းသိမ်းပါ`,
  [k.DEFAULT_VALUE]: `မူရင်းတန်ဖိုး`,
  [k.SUPPRESS_NOTIFICATIONS_FOR_DEF]: `မူရင်းတန်ဖိုးများအတွက်အသိပေးချက်များဖျောက်ထားပါ`,
  [k.TYPE1]: `အမျိုးအစား`,
  [k.UNIFIZEPDF]: `unifizePdf`,
  [k.UNIFIZE_US]: `unifize.us`,
  [k.DELETED_FIELD1]: `(ဖျက်ထားသောအကွက်)!`,
  [k.CHECKLIST_FIELD_WHERE_NATIVE_F]: `မူရင်းဖိုင်တည်ရှိရာစစ်ဆေးစာရင်းအကွက်`,
  [k.UPLOAD_TEMPLATE]: `ပုံစံတင်ပါ`,
  [k.DOWNLOAD1]: `ဒေါင်းလုပ်`,
  [k.FETCHING]: `ယူနေသည်`,
  [k.UPLOAD_TEMPLATE1]: `ပုံစံတင်ပါ`,
  [k.CLICK_ON_STITCH_TO_CREATE_A_P]: `(PDF ဖန်တီးရန် Stitch ကိုနှိပ်ပါ)`,
  [k.STITCH]: `+ Stitch`,
  [k.BUTTON_TEXT_OPTIONAL]: `ခလုတ်စာသား (ရွေးချယ်နိုင်သည်)`,
  [k.NAME_OF_SAVED_REPORTS_OPTIONA]: `သိမ်းထားသောအစီရင်ခံစာအမည် (ရွေးချယ်နိုင်သည်)`,
  [k.PREVIEW_OPTIONS1]: `ကြိုတင်ကြည့်ရှုမှုရွေးချယ်စရာများ`,
  [k.UPLOAD_TO_ANOTHER_FILE_FIELD]: `အခြားဖိုင်အကွက်သို့တင်ပါ:`,
  [k.DON_T_ATTACH_FILE_TO_CHECKLIST]: `ဖိုင်ကိုစစ်ဆေးစာရင်းတွင်မတွဲပါနှင့်`,
  [k.ATTACH_LATEST_VERSION_ONLY]: `နောက်ဆုံးဗားရှင်းသာတွဲပါ`,
  [k.ATTACH_ALL_VERSIONS]: `ဗားရှင်းအားလုံးတွဲပါ`,
  [k.SORT_BY1]: `စီပါ`,
  [k.DATE_ADDED]: `ထည့်သွင်းသည့်နေ့`,
  [k.SEARCH_USERS]: `အသုံးပြုသူများရှာပါ`,
  [k.OPEN_BY_DEFAULT_FOR]: `မူရင်းအားဖြင့်ဖွင့်ထားသည်`,
  [k.OPTIONS]: `ရွေးချယ်စရာများ`,
  [k.ADD_OPTIONS_DYNAMICALLY]: `ရွေးချယ်စရာများကိုအလိုအလျောက်ထည့်ပါ`,
  [k.DEFAULT1]: `မူရင်း`,
  [k.ALPHABETICAL]: `အက္ခရာစဉ်`,
  [k.PENDINGVALUE]: `ဆိုင်းငံ့ထားသောတန်ဖိုး`,
  [k.COMPLETEDVALUE]: `ပြီးဆုံးသောတန်ဖိုး`,
  [k.SELECT_A_STATUS]: `အခြေအနေရွေးပါ`,
  [k.TRIANGLEDOWN]: `triangleDown`,
  [k.MULTILINE]: `ကြောင်းများစွာ`,
  [k.USER2]: `အသုံးပြုသူ`,
  [k.MULTIPLE]: `တစ်ခါထက်ပိုသော`,
  [k.SELECT_A_FORM_TO_ADD_CONDITION]: `အခြေအနေထည့်ရန်ဖောင်ရွေးပါ`,
  [k.UNSTYLED]: `ပုံစံမရှိသော`,
  [k.D_AUTO_LAYOUT]: `2D အလိုအလျောက်အပြင်အဆင်`,
  [k.MAXIMUM_FIELD_WIDTH_SMALLER_W]: `အကွက်အကျယ်အများဆုံး (အကျယ်သေးသည့်အခါ တစ်တန်းတွင်အကွက်များပိုရနိုင်သည်)`,
  [k.FORCE_START_ON_A_NEW_ROW]: `တန်းအသစ်တွင်စတင်ရန်အတင်းအကျပေးပါ`,
  [k.X]: `1x`,
  [k.X1]: `2x`,
  [k.X2]: `3x`,
  [k.MAX_WIDTH]: `အကျယ်အများဆုံး`,
  [k.CONDITIONS]: `အခြေအနေများ`,
  [k.PROMPTS]: `သတိပေးချက်များ`,
  [k.LAYOUT]: `အပြင်အဆင်`,
  [k.FORM_CONDITIONS]: `ဖောင်အခြေအနေများ`,
  [k.CANCEL_CHANGES]: `ပြောင်းလဲမှုများပယ်ဖျက်ပါ`,
  [k.UPDATE_FIELD_SETTINGS]: `အကွက်ဆက်တင်များအသစ်ပြင်ပါ`,
  [k.RESOLVE_AND_UPDATE]: `ဖြေရှင်းပြီး အသစ်ပြင်ပါ`,
  [k.ME1]: `ကျွန်ုပ်`,
  [k.ADDFIELDS]: `addFields`,
  [k.HOLLOWPLUSCIRCLE]: `hollowPlusCircle`,
  [k.ADD_FIELDS]: `အကွက်များထည့်ပါ`,
  [k.THE_CHECKLIST_HAS_NOT_BEEN_CON]: `စစ်ဆေးစာရင်းကိုမသတ်မှတ်ရသေးပါ။`,
  [k.USE_THE_ADD_FIELD_BUTTON_TO_ST]: `စစ်ဆေးစာရင်းဖန်တီးရန် သို့မဟုတ် excel sheet တင်ရန် Add Field ခလုတ်ကိုသုံးပါ။`,
  [k.CHECKLIST_LAYOUT_DEFAULTS]: `စစ်ဆေးစာရင်းအပြင်အဆင်မူရင်းတန်ဖိုးများ`,
  [k.CHECKLIST_OPEN_BY_DEFAULT]: `စစ်ဆေးစာရင်းကိုမူရင်းအားဖြင့်ဖွင့်ထားမလား?`,
  [k.WEB_APP]: `ဝက်ဘ်အပ်ပလီကေးရှင်းတွင်`,
  [k.UNIFIZE_LITE_ON_WEB]: `Unifize Lite ဝက်ဘ်တွင်`,
  [k.UNIFIZE_LITE_ON_MOBILE_NAVIGA]: `Unifize Lite မိုဘိုင်းတွင် (ဆွေးနွေးမှုဖွင့်သောအခါ စစ်ဆေးစာရင်းသို့သွားပါ)`,
  [k.DEFAULT_CHECKLIST_WIDTH_ON_UNI]: `Unifize ဝက်ဘ်အပ်တွင် စစ်ဆေးစာရင်းအကျယ်မူရင်းတန်ဖိုး`,
  [k.SINGLE_COLUMN]: `တစ်တန်း`,
  [k.DOUBLE_COLUMN]: `နှစ်တန်း`,
  [k.TRIPLE_COLUMN]: `သုံးတန်း`,
  [k.SPLIT_AVAILABLE_SCREEN_SPACE_I]: `မျက်နှာပြင်အကျယ်ကို ၅၀% ဆွေးနွေးမှု၊ ၅၀% စစ်ဆေးစာရင်းအဖြစ်ခွဲပါ`,
  [k.ONLY_THE_CONTENTS_OF_THE_CONVE1]: `ဆွေးနွေးမှုအကြောင်းအရာသာဖျောက်ထားမည်၊ အခြားအချက်အလက်များသည်လည်းတစ်စုံတစ်ယောက်အားလုံးမြင်နိုင်သည်`,
  [k.CONVERSATIONS_WILL_BE_VISIBLE1]: `ဆွေးနွေးမှုများသည် ပါဝင်သူများ၊ အုပ်ချုပ်သူနှင့် အဖြူစာရင်းဝင်များသာမြင်နိုင်သည်`,
  [k.PRIVACY_SETTINGS_DON_T_APPLY_T]: `ကိုယ်ရေးအချက်အလက်ဆက်တင်များသည် အဖြူစာရင်းဝင်များအတွက်မသက်ဆိုင်ပါ`,
  [k.MAKE_PRIVATE1]: `ပုဂ္ဂလိကအဖြစ်ပြောင်းပါ`,
  [k.ONLY_PARTICIAPNTS_CAN_ACCESS_T]: `ပါဝင်သူများသာဤဆွေးနွေးမှုများကိုဝင်ရောက်နိုင်သည်`,
  [k.PRIVATE_CONVERSATIONS_CAN_ONLY]: `ပုဂ္ဂလိကဆွေးနွေးမှုများကို လုပ်ငန်းစဉ်ပိုင်ရှင်သာပြင်နိုင်သည်`,
  [k.AUTO_REMIND_IN]: `အလိုအလျောက်သတိပေးပါ`,
  [k.ALLOW_PARTICIPANTS_TO_DISABLE]: `ပါဝင်သူများပိတ်ခွင့်ပြုပါ`,
  [k.REMINDER_MESSAGE]: `သတိပေးစာ`,
  [k.SELECT_VALUE]: `တန်ဖိုးရွေးပါ`,
  [k.ADD_AUTO_REMINDER]: `အလိုအလျောက်သတိပေးချက်ထည့်ပါ`,
  [k.DESCRIPTION]: `ဖော်ပြချက်`,
  [k.PARTICIPANTS]: `ပါဝင်သူများ`,
  [k.OWNER]: `ပိုင်ရှင်`,
  [k.FORM_OWNERS]: `ဖောင်ပိုင်ရှင်များ`,
  [k.PROCESS_OWNERS]: `လုပ်ငန်းစဉ်ပိုင်ရှင်များ`,
  [k.TAB]: `တပ်`,
  [k.NOTIFICATION_SETTINGS]: `အသိပေးချက်ဆက်တင်များ`,
  [k.EXIT_PROCESS_EDITOR]: `လုပ်ငန်းစဉ်တည်းဖြတ်မှုမှထွက်ပါ`,
  [k.ENTER_A_TITLE_FOR_THIS_PROCESS]: `ဤလုပ်ငန်းစဉ်အတွက် ခေါင်းစဉ်ထည့်ပါ`,
  [k.SAVEPROCESSTEMPLATEBUTTON]: `လုပ်ငန်းစဉ်ပုံစံသိမ်းရန်ခလုတ်`,
  [k.DEFINE_NEW_PROCESS_TEMPLATE]: `လုပ်ငန်းစဉ်ပုံစံအသစ်သတ်မှတ်ပါ`,
  [k.CREATE_PROCESS]: `လုပ်ငန်းစဉ်ဖန်တီးပါ`,
  [k.SAVE_CHANGES]: `ပြောင်းလဲမှုများသိမ်းပါ`,
  [k.EXPORT_FIELDS_JSON]: `အကွက်များကို JSON အဖြစ်ထုတ်ယူပါ`,
  [k.SAVE_AND_GO_TO]: `သိမ်းပြီးသွားပါ`,
  [k.TEAM]: `အဖွဲ့`,
  [k.STATUS]: `အခြေအနေ`,
  [k.DELETED_FIELDS]: `ဖျက်ထားသောအကွက်များ`,
  [k.ADVANCED_PROCESS_SETTINGS]: `အဆင့်မြင့်လုပ်ငန်းစဉ်ဆက်တင်များ`,
  [k.DEFAULT_FORM_COLOUR]: `ဖောင်အရောင်မူရင်းတန်ဖိုး`,
  [k.DETAILS]: `အသေးစိတ်`,
  [k.EXIT_FORM_EDITOR]: `ဖောင်တည်းဖြတ်မှုမှထွက်ပါ`,
  [k.CREATE_FORM]: `ဖောင်ဖန်တီးပါ`,
  [k.REPORTS]: `အစီရင်ခံစာများ`,
  [k.FORMS]: `ဖောင်များ`,
  [k._18]: `>`,
  [k.TO]: `သို့`,
  [k.FILTERS_APPLIED]: `အသုံးပြုထားသောစစ်ထုတ်မှုများ:`,
  [k.SORTED_BY]: `စီထားသည်:`,
  [k.CLEAR_ALL]: `အားလုံးရှင်းပါ`,
  [k.SHARE]: `မျှဝေပါ`,
  [k.RESULTS]: `ရလဒ်များ`,
  [k.SAVE_AS]: `အဖြစ်သိမ်းပါ`,
  [k.ASCENDING]: `တက်လျှောက်`,
  [k.DESCENDING]: `ဆင်းလျှောက်`,
  [k.TO_ARRANGE_DRAG_UP_OR_DOWN]: `စီရန် အပေါ်သို့/အောက်သို့ ဆွဲပါ`,
  [k.FILTER_NAME]: `စစ်ထုတ်မှုအမည်`,
  [k.ORDER]: `အမိန့်`,
  [k.PARAMETERS]: `ပါရာမီတာများ`,
  [k.SORT_BY2]: `စီပါ`,
  [k.FILTER_VALUES]: `စစ်ထုတ်တန်ဖိုးများ`,
  [k.SELECT_DATE]: `နေ့စွဲရွေးပါ`,
  [k.FILTER_BY]: `ဖြင့်စစ်ထုတ်ပါ`,
  [k.AFTER]: `နောက်`,
  [k.BEFORE]: `မတိုင်မီ`,
  [k.FILTER]: `စစ်ထုတ်ပါ`,
  [k.USERFILTER]: `အသုံးပြုသူစစ်ထုတ်မှု`,
  [k.THERE_ARE_NO_FORMS_THAT_MATCHE]: `ဤစစ်ထုတ်မှုများနှင့်ကိုက်ညီသောဖောင်များမရှိပါ`,
  [k._19]: `_`,
  [k.DELETE_FORM]: `ဖောင်ဖျက်ပါ`,
  [k.FORM_NAME]: `ဖောင်အမည်`,
  [k.CREATED_AT]: `ဖန်တီးသည့်အချိန်`,
  [k.UPDATED_AT]: `အသစ်ပြင်သည့်အချိန်`,
  [k.CREATED_BY1]: `ဖန်တီးသူ`,
  [k.NEW]: `အသစ်`,
  [k.MANAGE]: `စီမံပါ`,
  [k.PROCESSES]: `လုပ်ငန်းစဉ်များ`,
  [k.EDIT1]: `ပြင်ဆင်ပါ`,
  [k.DESCRIPTION1]: `ဖော်ပြချက်:`,
  [k.REPORT]: `အစီရင်ခံစာ:`,
  [k.CREATE_NEW_CHART]: `ဇယားအသစ်ဖန်တီးပါ`,
  [k.CHARTS_FOR_THIS_REPORT]: `ဤအစီရင်ခံစာအတွက် ဇယားများ`,
  [k.MULTIPLE_VALUE_CALCULATION]: `တန်ဖိုးများစွာတွက်ချက်ခြင်း`,
  [k.IF_A_FIELD_CONTAINS_MULTIPLE_V]: `အကွက်တစ်ခုတွင် ဆွေးနွေးမှုတစ်ခုလျှင် တန်ဖိုးများစွာပါဝင်ပါက၊ y-ဝင်ရိုးစုစုပေါင်းသည် ဘာကိုကိုယ်စားပြုမည်ကိုရွေးပါ`,
  [k.Y_AXIS_SHOWS_TOTAL_CONVERSATIO]: `Y-ဝင်ရိုးသည် ဆွေးနွေးမှုစုစုပေါင်းအရေအတွက်ကိုပြသည် (တစ်ခုချင်းစီအလေးပေးခြင်း)`,
  [k.Y_AXIS_SHOWS_TOTAL_VALUE_COUNT]: `Y-ဝင်ရိုးသည် တန်ဖိုးစုစုပေါင်းအရေအတွက်ကိုပြသည် (တန်ဖိုးတစ်ခုချင်းစီအလေးပေးခြင်း)`,
  [k.PRIMARY_Y_AXIS_LABEL]: `ပထမအကြိမ် Y-ဝင်ရိုးတံဆိပ်`,
  [k.SECONDARY_Y_AXIS_LABEL]: `ဒုတိယ Y-ဝင်ရိုးတံဆိပ်`,
  [k.CHART_TYPE]: `ဇယားအမျိုးအစား`,
  [k.PRIMARY_FIELD]: `ပထမအကြိမ်အကွက်`,
  [k.PRIMARYRECORD]: `ပထမအကြိမ်မှတ်တမ်း`,
  [k.PRIMARY_RECORD]: `ပထမအကြိမ်မှတ်တမ်း`,
  [k.MULTIPLE_VALUES]: `တန်ဖိုးများစွာ`,
  [k.ADD_COMPARISON]: `+ နှိုင်းယှဉ်မှုထည့်ပါ`,
  [k.ADD_TRENDLINE]: `လမ်းကြောင်းလိုင်းထည့်ပါ`,
  [k.SELECT_ABOVE_FIELDS_TO_ENABLE]: `ဤအထက်အကွက်များရွေးပါမှ ဤကိုဖွင့်နိုင်သည်`,
  [k.TRENDLINE_LABEL]: `လမ်းကြောင်းလိုင်းတံဆိပ်`,
  [k.TRENDLINE_COLOR]: `လမ်းကြောင်းလိုင်းအရောင်`,
  [k.HIDE1]: `ဖျောက်ပါ`,
  [k.OF]: `၏`,
  [k.SELECT_FIELD]: `အကွက်ရွေးပါ`,
  [k.ARE_YOU_SURE_YOU_WANT_TO_DELET2]: `သင်ဖျက်ချင်သည်မှာသေချာပါသလား "`,
  [k._20]: `"`,
  [k.GROUP_BY]: `အုပ်စုဖြင့်`,
  [k.ADD_TREND_LINE]: `လမ်းကြောင်းလိုင်းထည့်ပါ`,
  [k.PERCENT]: `ရာခိုင်နှုန်း`,
  [k.PPM]: `PPM`,
  [k.SHOW_AS_PERCENT_OF_OTHER_VALUE]: `အခြားတန်ဖိုး၏ ရာခိုင်နှုန်းအဖြစ်ပြပါ`,
  [k.SERIES1]: `စီးရီး #`,
  [k.SUMMARY_TYPE]: `အကျဉ်းချုပ်အမျိုးအစား`,
  [k.X_AXIS]: `x-ဝင်ရိုး`,
  [k.UNTITLED_CHART]: `ခေါင်းစဉ်မရှိသောဇယား`,
  [k.ADVANCED_SETTINGS]: `အဆင့်မြင့်ဆက်တင်များ`,
  [k.PLEASE_FILL_MANDATORY_FIELDS]: `လိုအပ်သောအကွက်များဖြည့်ပါ`,
  [k.SUBMIT]: `တင်ပြပါ`,
  [k.CHART1]: `ဇယား`,
  [k.SELECT_A_COMPARISON_CHART]: `နှိုင်းယှဉ်ဇယားရွေးပါ`,
  [k.FORM1]: `(ဖောင်:`,
  [k.FIELD2]: `) (အကွက်:`,
  [k.COMMONCHECKLIST]: `ပုံမှန်စစ်ဆေးစာရင်း`,
  [k.MULTIPLE_VALUE_FIELD]: `တန်ဖိုးများစွာပါဝင်သောအကွက်`,
  [k.STATUS1]: `အခြေအနေ`,
  [k.CREATED1]: `ဖန်တီးပြီး`,
  [k.COMPLETED]: `ပြီးဆုံးသည်`,
  [k.ADD_COLUMN]: `ကော်လံထည့်ပါ`,
  [k.SELECT_FORM1]: `ဖောင်ရွေးပါ`,
  [k.THE_COUNT_WILL_REPRESENT_THE_T]: `ဤအရေအတွက်သည် ဤဖောင်၏ အကြိမ်ရေစုစုပေါင်းကို ကိုယ်စားပြုမည်`,
  [k.X_AXIS1]: `(x-ဝင်ရိုး)`,
  [k.PRIMARY_FIELDS_ARE_THE_MAIN_UN]: `ပထမအကြိမ်အကွက်များသည် ဇယားအတွက် အဓိကဒေတာဖြစ်သည်`,
  [k.GROUP_BY_FIELD]: `အုပ်စုဖြင့်အကွက်`,
  [k.OPTIONAL]: `(ရွေးချယ်နိုင်သည်)`,
  [k.GROUP_BY_FIELD_TYPE_IS_APPLIED]: `အုပ်စုဖြင့်အကွက်အမျိုးအစားသည် ပထမအကြိမ်အကွက်များတွင် အသုံးပြုသည်`,
  [k.ADVANCED_SETTINGS1]: `အဆင့်မြင့်ဆက်တင်များ`,
  [k.IF_A_FIELD_CONTAINS_MULTIPLE_V1]: `အကွက်တစ်ခုတွင် ဆွေးနွေးမှုတစ်ခုလျှင် တန်ဖိုးများစွာပါဝင်ပါက၊ y-ဝင်ရိုးစုစုပေါင်းသည် ဘာကိုကိုယ်စားပြုမည်ကိုရွေးပါ`,
  [k.Y_AXIS_LABEL]: `Y-ဝင်ရိုးတံဆိပ်`,
  [k.SAVE_CHANGES1]: `ပြောင်းလဲမှုများသိမ်းပါ`,
  [k.CREATE_CHART]: `ဇယားဖန်တီးပါ`,
  [k.LABEL_FOR_Y_AXIS_OF_THE_CHART]: `ဇယား၏ Y-ဝင်ရိုးအတွက် တံဆိပ်`,
  [k.IF_A_FIELD_CONTAINS_MULTIPLE_V2]: `အကွက်တစ်ခုတွင် ဆွေးနွေးမှုတစ်ခုလျှင် တန်ဖိုးများစွာပါဝင်ပါက၊ y-ဝင်ရိုးစုစုပေါင်းသည် ဘာကိုကိုယ်စားပြုမည်ကိုရွေးပါ`,
  [k.CREATE_AND_SAVE]: `ဖန်တီးပြီး သိမ်းပါ`,
  [k.Y_AXIS_SHOWS_TOTAL_CONVERSATIO1]: `Y-ဝင်ရိုးသည် ဆွေးနွေးမှုစုစုပေါင်းအရေအတွက်ကိုပြသည် (တစ်ခုချင်းစီအလေးပေးခြင်း)`,
  [k.ENTER_THE_TITLE_OF_YOUR_CHART]: `သင့်ဇယားအတွက် ခေါင်းစဉ်ထည့်ပါ`,
  [k.NUMERIC_CHECKLIST_FIELD]: `ဂဏန်းစစ်ဆေးစာရင်းအကွက်`,
  [k.THIS_FIELD_WILL_CONTAIN_THE_NU]: `ဤအကွက်တွင် ဂဏန်းဒေတာပါဝင်မည်၊ ဥပမာ- ငွေပမာဏ၊ စုစုပေါင်းအချိန် သို့မဟုတ်ယူနစ်များ`,
  [k.IF_A_FIELD_CONTAINS_MULTPLE_VA]: `အကွက်တစ်ခုတွင် ဆွေးနွေးမှုတစ်ခုလျှင် တန်ဖိုးများစွာပါဝင်ပါက၊ y-ဝင်ရိုးစုစုပေါင်းသည် ဘာကိုကိုယ်စားပြုမည်ကိုရွေးပါ`,
  [k.DAILY]: `နေ့စဉ်`,
  [k.WEEKLY]: `အပတ်စဉ်`,
  [k.MONTHLY]: `လစဉ်`,
  [k.YEARLY]: `နှစ်စဉ်`,
  [k.MMM_DD_YYYY1]: `MMM DD YYYY`,
  [k.LAST]: `နောက်ဆုံး`,
  [k.TIME_INTERVAL_FREQUENCY]: `အချိန်အကြာအဝေး (ကြိမ်နှုန်း)`,
  [k.THE_INTERVAL_AT_WHICH_THE_NUME]: `အထက်ဖော်ပြပါ ဂဏန်းတန်ဖိုးသည် မည်သည့်အကြာအဝေးဖြင့် ထပ်မံဖြစ်ပေါ်မည်ကိုရွေးပါ`,
  [k.TIME_PERIOD]: `အချိန်ကာလ`,
  [k.SELECT_A_TIME_FRAME_OR_A_DATE]: `ဇယားအတွက် အချိန်ကာလ သို့မဟုတ် နေ့စွဲအပိုင်းရွေးပါ`,
  [k.COLUMN1]: `ကော်လံ`,
  [k.SHOW_A_COLUMN_FOR_EACH_OF_THE]: `အောက်ပါအတွက် တစ်ခုချင်းစီအတွက် ကော်လံပြပါ`,
  [k.FIELDS_OF_THE_CHART]: `ဇယားအကွက်များ`,
  [k.CHART_TITLE]: `ဇယားခေါင်းစဉ်`,
  [k.WHAT_DOES_THIS_CHART_REPRESENT]: `ဤဇယားသည် ဘာကိုကိုယ်စားပြုသည်?`,
  [k.SELECT_A_CHART_FOR]: `အတွက် ဇယားရွေးပါ`,
  [k.SAVE_AS1]: `အဖြစ်သိမ်းပါ`,
  [k.DO_YOU_WANT_TO_DELETE]: `ဖျက်ချင်ပါသလား "`,
  [k.ENTER_REPORT_TITLE]: `အစီရင်ခံစာခေါင်းစဉ်ထည့်ပါ`,
  [k.SAVE_AS_REPORT]: `အစီရင်ခံစာအဖြစ်သိမ်းပါ`,
  [k.EDIT_REPORT_TITLE]: `အစီရင်ခံစာခေါင်းစဉ်ပြင်ပါ`,
  [k.EDIT2]: `ပြင်ဆင်ပါ`,
  [k.REPORT_NAME]: `အစီရင်ခံစာအမည်`,
  [k.STRING1]: `စာသား`,
  [k.APPLY_BULK_CHANGES]: `အစုလိုက်ပြောင်းလဲမှုများအသုံးပြုပါ`,
  [k.ARE_YOU_SURE_YOU_WANT_TO_APPLY]: `အစုလိုက်ပြောင်းလဲမှုများကို ဆွေးနွေးမှုများစွာတွင် အသုံးပြုချင်သည်မှာသေချာပါသလား?`,
  [k.REPEAT_LAST_ACTION_TO_ALL]: `နောက်ဆုံးလုပ်ဆောင်မှုအားလုံးထပ်မံလုပ်ပါ`,
  [k.REPLACE_ALL]: `အားလုံးအစားထိုးပါ`,
  [k.ALL]: `အားလုံး`,
  [k.RECORDS]: `မှတ်တမ်းများ`,
  [k.DATE1]: `နေ့စွဲ`,
  [k.CUSTOMIZE_VIEW]: `မြင်ကွင်းကိုစိတ်ကြိုက်ပြင်ဆင်ပါ`,
  [k.DOWNLOAD_AS_CSV]: `CSV အဖြစ်ဒေါင်းလုပ်ပါ`,
  [k.DOWNLOAD_AS_XLSX]: `XLSX အဖြစ်ဒေါင်းလုပ်ပါ`,
  [k.DOWNLOAD_WITH_FILES]: `ဖိုင်များနှင့်အတူဒေါင်းလုပ်ပါ`,
  [k.DOWNLOAD_AS_JSON_BETA]: `JSON (beta) အဖြစ်ဒေါင်းလုပ်ပါ`,
  [k.YOU_WILL_RECEIVE_AN_EMAIL_ON]: `သင်အီးမေးလ်တစ်စောင်လက်ခံရရှိပါမည်`,
  [k.ONCE_THE_IMPORT_IS_DON]: `တင်သွင်းမှုပြီးဆုံးသည်နှင့်`,
  [k.SUBMIT1]: `တင်ပြပါ`,
  [k.UPLOAD_CSV]: `CSV တင်ပါ`,
  [k.SELECT_CSV_FILE]: `CSV ဖိုင်ရွေးပါ`,
  [k.LOADING_RESULTS]: `ရလဒ်များတင်နေသည်`,
  [k.SHOW_ALL_REVISIONS]: `ပြင်ဆင်ချက်အားလုံးပြပါ`,
  [k.NEW1]: `အသစ်`,
  [k.CUSTOMIZE_TABLE_VIEW]: `ဇယားမြင်ကွင်းကိုစိတ်ကြိုက်ပြင်ဆင်ပါ`,
  [k.COLUMN_TITLE]: `ကော်လံခေါင်းစဉ်`,
  [k.RESET]: `ပြန်လည်သတ်မှတ်ပါ`,
  [k.APPLY]: `အသုံးပြုပါ`,
  [k.SAVEAS]: `အဖြစ်သိမ်းပါ`,
  [k.EMBEDDED_FIELDS1]: `ထည့်သွင်းထားသောအကွက်များ`,
  [k.EXPANSION]: `ချဲ့ထွင်မှု`,
  [k.FILTER_BY_VALUE]: `တန်ဖိုးဖြင့်စစ်ထုတ်ပါ`,
  [k.MONTHS]: `လများ`,
  [k.YEARS]: `နှစ်များ`,
  [k.DATE_RANGE]: `နေ့စွဲအပိုင်း`,
  [k.FORM2]: `ဖောင်`,
  [k.EXPAND]: `ချဲ့ပါ`,
  [k.PRIORITY]: `ဦးစားပေးမှု`,
  [k.LOW]: `နိမ့်`,
  [k.NORMAL1]: `ပုံမှန်`,
  [k.HIGH]: `မြင့်`,
  [k.CRITICAL]: `အရေးကြီး`,
  [k.SELECT_ALL1]: `အားလုံးရွေးပါ`,
  [k.SELECT_NONE]: `မရွေးပါနဲ့`,
  [k.MAPPED_TO]: `ချိတ်ဆက်ထားသည်`,
  [k.PENDING]: `ဆိုင်းငံ့ထားသည်`,
  [k.COMPLETE]: `ပြီးဆုံးသည်`,
  [k.INCLUDE]: `ပါဝင်သည်`,
  [k.ARCHIVED]: `သိမ်းဆည်းထားသည်`,
  [k.CANCELLED]: `ပယ်ဖျက်ထားသည်`,
  [k.THERE_ARE_NO_PROCESSES_THAT_MA]: `ဤဖိုင်တာများနှင့်ကိုက်ညီသောပြုပြင်မှုများမရှိပါ`,
  [k.RESIZING]: `ပြင်ဆင်ပါ`,
  [k._24]: "ပြင်ဆင်ပါ",
  [k.NO_VALUE]: `မရှိပါ`,
  [k.CURRENTCHATROOMTITLE]: `currentChatroomTitle`,
  [k.C]: `C`,
  [k.CARETUP]: `caretUp`,
  [k.MAKE_AS_CURRENT]: `Make as current`,
  [k.ARRAY]: `Array`,
  [k.EDITPENCIL]: `editPencil`,
  [k.NO_DESCRIPTION]: `မရှိပါ`,
  [k.DISABLED1]: `ပိတ်ထားသည်`,
  [k.PARENT3]: `အဖွဲ့အစည်း`,
  [k.NO_PARENT]: `မရှိပါ`,
  [k.UPDATE_STATUS]: `အခြေအနေပြင်ဆင်ပါ:`,
  [k.CARETDOWN]: `caretDown`,
  [k.UNTITLED_CONVERSATION]: `မော်ဒယ်မရှိပါ`,
  [k.PAGE]: `စာမျက်နှာ`,
  [k.GO_TO_PAGE]: `| စာမျက်နှာသို့သွားပါ:`,
  [k.BACK_TO_REPORT]: `အကြောင်းအရာများဖန်တီးပါ`,
  [k.CREATE_ANOTHER_CHART]: `အကြောင်းအရာများဖန်တီးပါ`,
  [k.OWNER1]: `အကြောင်းအရာများဖန်တီးပါ`,
  [k.DUEDATE]: `နောက်ဆုံးနေ့စွဲ`,
  [k._28]: `↑`,
  [k._29]: `↓`,
  [k.PROCESS_NAME]: `ပြုပြင်မှုခေါင်းစဉ်`,
  [k.ACTIVE_INSTANCES]: `အသုံးပြုထားသည်`,
  [k.TOTAL_INSTANCES]: `အားလုံး`,
  [k.CREATED_BY2]: `ဖန်တီးသည်`,
  [k.EDIT_PROCESS]: `ပြုပြင်မှုပြင်ဆင်ပါ`,
  [k.DELETE_PROCESS]: `ဖျက်ပါ`,
  [k.DRAFT]: `ဖန်တီးထားသည်`,
  [k.DELETE_PROCESS1]: `ဖျက်ပါ`,
  [k.ALL_ASSOCIATED_CONVERSATIONS]: `? ပယ်ဖျက်ထားသည်`,
  [k.FETCHING_USER_AND_ORG_DETAILS]: `သုံးစွဲသူနှင့်အဖွဲ့အစည်းအကူအညီပြုပါ`,
  [k.INTEGRATION_NOT_FOUND]: `အင်တာနှင့်ကိုမတွေ့ရှိပါ!`,
  [k.WHAT_CAN]: `ဘာကိုယ်တိုင်းလဲမှာ`,
  [k.DO]: `လုပ်နိုင်သလိုပါလဲ`,
  [k.ALLOW]: `ခွင့်ပြုပါ`,
  [k.DENY]: `ငြင်းပယ်ပါ`,
  [k.HTTPS_CDN_BFLDR_COM_H_O_W]: `https://cdn.bfldr.com/5H442O3W/at/pl546j-7le8zk-6gwiyo/Slack_Mark.svg?auto=webp&format=svg`,
  [k.SLACK]: `Slack`,
  [k.MICROSOFT]: `Microsoft 365`,
  [k.MICROSOFT_ADMIN]: `Microsoft 365 Admin`,
  [k.CREATE_CONVERSATIONS_ON_UNIFIZ]: `သင့်အားဖွင့်လိုသည့်အတွက် Unifize တွင်အကြောင်းအရာများဖန်တီးပါ။`,
  [k.FORWARD_MESSAGES_TO_UNIFIZE_ON]: `သင့်အားဖွင့်လိုသည့်အတွက် Unifize တွင်အကြောင်းအရာများဖန်တီးပါ။`,
  [k.NETWORK_ERROR_LOOKS_LIKE_YOU]: `ကွန်ပြူတာအမှားအယွေဖြစ်သည်။ သင့်အားအကြောင်းအရာများဖန်တီးပါ :(`,
  [k.CLICK_HERE_TO_TRY_AGAIN]: `ထိုးနှိပ်သည့်အကြောင်းအရာများဖန်တီးပါ`,
  [k.EMAIL1]: `အီးမေး`,
  [k.CREATING]: `ဖန်တီးပါ`,
  [k.ORG1]: `အကြောင်းအရာများဖန်တီးပါ...`,
  [k.YOUR_ORG_IS_READY_YOU_WILL_BE]: `သင့်အားအကြောင်းအရာများဖန်တီးပါ။ သင့်အားအကြောင်းအရာများဖန်တီးပါ။`,
  [k.ERROR_CREATING_YOUR_ORG]: `သင့်အားအကြောင်းအရာများဖန်တီးပါ`,
  [k.SOMEONE_FROM_UNIFIZE_WILL_SOON]: `သင့်အားအကြောင်းအရာများဖန်တီးပါ။ သင့်အားအကြောင်းအရာများဖန်တီးပါ။`,
  [k.ORG_NAME]: `အကြောင်းအရာများဖန်တီးပါ`,
  [k.EMAIL_ADDRESS]: `အီးမေးလိပ်စား`,
  [k.AT_LEAST_CHARACTERS]: `အနည်းဆုံး 8 လုံးဖြစ်သည်`,
  [k.A_MIXTURE_OF_LETTERS_AND_NUMBE]: `အကြောင်းအရာများဖန်တီးပါ။`,
  [k.INCLUSION_OF_AT_LEAST_ONE_UPPE]: `အနည်းဆုံး 1 လုံးဖြစ်သည်`,
  [k.CONFIRM_PASSWORD]: `အတည်ပြုပါသည်`,
  [k.FIRST_NAME]: `အမည်`,
  [k.LAST_NAME]: `နာမည်`,
  [k.PLEASE_VERIFY_YOUR_EMAIL_ADDRE]: `အီးမေးလိပ်စာကိုပြင်ဆင်ပါ။`,
  [k.CLICK_ON_THE_LINK_WE_SENT_TO]: `အကြောင်းအရာများဖန်တီးပါ။`,
  [k.TO_CREATE_YOUR_ORG]: `အကြောင်းအရာများဖန်တီးပါ။`,
  [k.DIDN_T_RECEIVE_AN_EMAIL]: `အကြောင်းအရာများဖန်တီးပါ။`,
  [k.RESEND_EMAIL]: `အကြောင်းအရာများဖန်တီးပါ။`,
  [k.STEP_OF]: `Step 1 of 3`,
  [k.SIGN_UP]: `အကြောင်းအရာများဖန်တီးပါ။`,
  [k.SPEED_UP_YOUR_PROCESSES_BY_X]: `အကြောင်းအရာများဖန်တီးပါ။`,
  [k.STEP_OF1]: `Step 2 of 3`,
  [k.CREATE_ACCOUNT]: `အကြောင်းအရာများဖန်တီးပါ။`,
  [k.SIGN_IN]: `အကြောင်းအရာများဖန်တီးပါ။`,
  [k.YOU_HAVE_ALREADY_USED_THIS_EMA]: `အကြောင်းအရာများဖန်တီးပါ။`,
  [k.STEP_OF2]: `Step 3 of 3`,
  [k.SIGN_OUT]: `အကြောင်းအရာများဖန်တီးပါ။`,
  [k.LAST_STEP]: `အကြောင်းအရာများဖန်တီးပါ။`,
  [k.INVITE_YOUR_COLLABORATORS]: `သင့်အဖွဲ့အစည်းများကိုဖိတ်ကြားပါ`,
  [k.NO_MORE_SILOS_INVITE_UP_TO]: `အကြောင်းအရာများဖန်တီးပါ။`,
  [k.STAGE_INFO_HEADER]: `အဆင့်အချက်အလက်များခေါင်းစဉ်:`,
  [k.STAGE]: `အဆင့်:`,
  [k.THIS_LINK_IS_NOT_VALID]: `ဤလင့်ခ်ကိုမသုံးနိုင်ပါ`,
  [k.NEXT]: `နောက်ထပ်`,
  [k.BY_SIGNING_UP_I_AGREE_TO_THE]: `စာရင်းသွင်းသည့်အခါ Unifize ကိုကာကွယ်ရေးမူဝါဒနှင့်ဝန်ဆောင်မှုစည်းမျဉ်းများကိုကိုယ်တိုင်သဘောတူပါ။`,
  [k.CENTER_SECTION]: `အလယ်ပိုင်းခန့်`,
  [k.RIGHT_SECTION]: `ညာဘက်ခန့်`,
  [k.ADD_SECTION]: `+ ခန့်သစ်ထပ်ထည့်`,
  [k.SELECT_FROM_EXISTING_TILES]: `ရှိပြီးသားတိုင်းများမှရွေးချယ်`,
  [k.CREATE_NEW_TILE]: `တိုင်းသစ်ဖန်တီး`,
  [k.CONVERSATIONS]: `အကြောင်းအရာများ`,
  [k.MY_CONVERSATION_CHART]: `ကျွန်ုပ်၏အကြောင်းအရာများချတ်`,
  [k.MY_RECORD_CHART]: `ကျွန်ုပ်၏မှတ်တမ်းဇယား`,
  [k.START_NEW]: `စတင်သစ်`,
  [k.PIN_A_DASHBOARD_CHART]: `ဒါရှ်ဘုတ်ချတ်ကိုကပ်`,
  [k.NAME2]: `အမည်`,
  [k.DO_YOU_WANT_TO_DELETE1]: `သင်ကိုယ်တိုင်ဖျက်ပါမည်မှာ`,
  [k.ADD_NEW_TILE]: `+ တိုင်းသစ်ထပ်ထည့်`,
  [k.SUB_TITLE]: `အမည်ပိုင်`,
  [k.FILTERS]: `စစ်ထုတ်မှုများ`,
  [k.SELECT_AT_LEAST_ONE]: `(အနည်းဆုံး တစ်ခုကိုရွေးချယ်)`,
  [k.UNREAD]: `မဖတ်ရသေး`,
  [k.I_OWN]: `ကျွန်ုပ်ပိုင်`,
  [k.BLUECROSS]: `blueCross`,
  [k.EVERYONE]: `အားလုံး`,
  [k.BELONGS_TO_ROLE]: "အခန်းကဏ္ဍသို့ပါဝင်သည်",
  [k.EVERYONE1]: `အားလုံး`,
  [k.BUTTON_TEXT]: `ခလုတ်စားပါ`,
  [k.WHEN_EMPTY]: `အားလုံးမရှိပါသည်မှာ`,
  [k.TILE_COLOR]: `အားလုံးအရေအတွက်`,
  [k.SELECT_A_CHART]: `ချတ်ချင်းကိုရွေးပါ`,
  [k.DON_T_SHOW_TILE]: `အားလုံးကိုမရွေးပါ`,
  [k.SHOW_A_MESSAGE]: `အားလုံးကိုမကြားပါ`,
  [k.EXCLUDE_PROCESS]: `အားလုံးကိုမရွေးပါ`,
  [k.INCLUDE_PROCESS]: `အားလုံးကိုရွေးပါ`,
  [k.COLUMNS]: `ကောက်ဝဲများ`,
  [k.OVERDUE]: `အကြွင်းအသစ်ထည့်ပါ`,
  [k.TILE_TYPE_CONVERSATIONS]: `အားလုံးအသစ်ထည့်ပါ: ချတ်ချင်းမှတဆင့်လုပ်ငန်း`,
  [k.TILE_TYPE_MY_CONVERSATION_CHA]: `အားလုံးအသစ်ထည့်ပါ: ချတ်ချင်းမှတဆင့်လုပ်ငန်း`,
  [k.TILE_TYPE_MY_RECORD_CHART]: `အကွက်အမျိုးအစား- ကျွန်ုပ်၏မှတ်တမ်းဇယား`,
  [k.TILE_TYPE_START_NEW]: `အားလုံးအသစ်ထည့်ပါ: စတင်အသုံးပြုရန်လင့်ခ်ကိုနှိပ်ပါ`,
  [k.TILE_TYPE_DASHBOARD_CHART]: `အားလုံးအသစ်ထည့်ပါ: စတင်အသုံးပြုရန်လင့်ခ်ကိုနှိပ်ပါ`,
  [k.SECTION1]: `အားလုံး:`,
  [k.ADD_USER_SEGMENT]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.AND_USER]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.SHOW_TO]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.AND_USER1]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.AGE1]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.SELECT_TIMEPERIOD]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.SELECTED]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.SELECT_GROUP]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.SELECT_VALUES]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.CREATE_NEW_USER_SEGMENT]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.OTHERS1]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.ENABLE_HOME_SCREEN]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.ARE_YOU_SURE_YOU_WANT_TO_DISAB]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.INTEGRATION]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.DISABLE]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.ARE_YOU_SURE_YOU_WANT_TO_DISCO]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.INTEGRATION_YOU_COULD]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.YOU_CANNOT_UNDO_THIS_ACTION_C]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.DISCONNECT]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.HEADING]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.INTEGRATION1]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.INTEGRATE]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.GLOBAL_OR_PRIVILEGED_ADMINIST]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.NO_APPS_FOUND]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.ORG_SETTINGS]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.HOME_SCREEN1]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.ORG_DETAILS1]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.ROLE_MANAGEMENT1]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.APPS]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.DELETE_ROLE]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.ARE_YOU_SURE_YOU_WANT_TO_DELET3]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.DELETE_ORG_DOMAIN]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.ARE_YOU_SURE_YOU_WANT_TO_DELET4]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.ORG_DOMAIN]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.EMAIL_PREFIX]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.ALLOW_CLONING]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.SYSTEM_PROMPT]: `စီစဉ်မှုကိုလုပ်ငန်းရည်မှန်းချက်`,
  [k.SYSTEM_PROMPT_DESCRIPTION]: `ဤပရော့ပ်သည် အက်ပ်တစ်ခုလုံးတွင် AI ပြုမူပုံကို ထိန်းချုပ်သည်`,
  [k.ORG_DESCRIPTION]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.ORG_DESCRIBER_VIDEO_PASTE_IFR]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.ADD_USER]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.MEMBERS1]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.ADD_USERS]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.ADD_A_NEW_ROLE]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.FUNCTIONALITY]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.SERVICE_PROVIDER_ENTITY_ID]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.AUTHORIZATION_CALLBACK_URL]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.HUGE_PARAGRAPH_HERE]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.YES_LOGOUT_ALL_USERS]: `အားလုံးအသစ်ထည့်ပါ`,
  [k.ARE_YOU_SURE_YOU_WANT_TO_DISAB1]: `သင် SSO ကိုပိတ်ချင်သည်မှာသေချာပါသလား?`,
  [k.ENTER_NEW_PASSWORD]: `စကားဝှက်အသစ်ထည့်ပါ`,
  [k.CONFIRM_NEW_PASSWORD]: `စကားဝှက်အသစ်အတည်ပြုပါ`,
  [k.DISABLE_SSO]: `SSO ကိုပိတ်ပါ`,
  [k.DOMAIN1]: `ဒိုမိန်း`,
  [k._31]: `*`,
  [k.ENTITY_ID]: `Entity ID`,
  [k.SSO_URL]: `SSO URL`,
  [k.CERTIFICATE]: `လက်မှတ်`,
  [k.ADD_CERTIFICATE]: `လက်မှတ်ထည့်ပါ`,
  [k.MUST_START_WITH_BEGIN_CE]: `'-----BEGIN CERTIFICATE-----' ဖြင့်စတင်ရမည်၊ '-----END CERTIFICATE-----' ဖြင့်ဆုံးရမည်`,
  [k.PAGE_NOT_FOUND]: `၄၀၄ စာမျက်နှာမတွေ့ပါ`,
  [k.WELCOME_BACK1]: `ပြန်လာကြိုဆိုပါတယ်`,
  [k._32]: `!`,
  [k.LOG_IN]: `လော့ဂ်အင်ဝင်ပါ`,
  [k.TO_USE_THE_FULL]: `အက်ပ်၏အပြည့်အစုံကိုအသုံးပြုရန်`,
  [k.LOG_IN1]: `လော့ဂ်အင်ဝင်ပါ`,
  [k.SIGN_UP1]: `စာရင်းသွင်းပါ`,
  [k.DRIVE_PROCESS_THROUGH_CONVERSA]: `ဆွေးနွေးမှုမှတဆင့်လုပ်ငန်းစဉ်ကိုမောင်းနှင်ပါ`,
  [k.UNIFIZE_INCREASES_YOUR_TEAM]: `Unifize သည် သင့်အဖွဲ့၏`,
  [k.S_EFFICIENCY_BY_UP_TO_X_BY]: `၏ ထိရောက်မှုကို ၁၀ ဆထိတိုးမြှင့်ပေးသည်၊ ဆွေးနွေးများကိုလုပ်ငန်းရည်မှန်းချက်များနှင့်ချိတ်ဆက်ခြင်းဖြင့်။`,
  [k.SIGN_UP_FAILED]: `စာရင်းသွင်းမှုမအောင်မြင်ပါ!`,
  [k.CLICK_HERE_TO]: `ဤနေရာကိုနှိပ်ပါ`,
  [k.RESEND1]: `ပြန်လည်ပို့ပါ`,
  [k.VERIFICATION_EMAIL_SENT]: `အတည်ပြုအီးမေးလ်ပို့ပြီးပါပြီ`,
  [k.AN_EMAIL_HAS_BEEN_SENT_TO]: `အီးမေးလ်တစ်စောင်ပို့ပြီးပါပြီ`,
  [k.PLEASE_OPEN_YOUR_EMA]: `။ သင့်အီးမေးလ်ကိုဖွင့်ပြီး Unifize တွင် စတင်အသုံးပြုရန်လင့်ခ်ကိုနှိပ်ပါ။`,
  [k.OR]: `သို့မဟုတ်`,
  [k.CHATROOM_HEADER]: `ချတ်ချင်းချယ်ပါ`,
  [k.CLICK_HERE_TO_SIGN_UP_OR_LOG_I]: `ဤနေရာကိုနှိပ်ပါသို့သင်စာရင်းသွင်းပါသို့လော့ဂ်အင်ဝင်ပါ`,
  [k.HEADER]: `ခေါင်းချင်း`,
  [k.INPUT]: `ထည့်ပါ`,
  [k.YOU_NEED_TO_LOG_IN_TO_DO_THAT]: `သင်သည်ဤလားကိုလော့ဂ်အင်ဝင်ပါလို့လော့ဂ်အင်ဝင်ပါသည်`,
  [k.HISTORY]: `သမိုင်း`,
  [k.PANEL]: `အဆိုပါ`,
  [k.PLUSCIRCLE]: `ပုံမှန်ပါ`,
  [k.FILE]: `ဖိုင်`,
  [k.MANAGE_FILE_VIEW]: `ဖိုင်အမြင့်ကိုစီစဉ်ပါ`,
  [k.CREATEPROCESSTEMPLATE]: `အလုပ်အကိုင်ကိုစီစဉ်ပါ`,
  [k.REMOVECIRCLE]: `ဖျက်ပါ`,
  [k.CLEAR_ALL1]: `အားလုံးဖျက်ပါ`,
  [k.OPTION_NOT_FOUND]: `ရွေးချယ်မှုမရှိပါ`,
  [k.ADD_NEW_OPTION]: `အသစ်ရွေးချယ်ပါ`,
  [k.NEW_OPTION]: `အသစ်ရွေးချယ်ပါ`,
  [k.EMAIL_NOTIFICATIONS]: `အီးမေးလ်အသစ်ထည့်ပါ`,
  [k.SELECT_YOUR_PREFERED_NOTIFICAT]: `သင့်အဖွဲ့ကိုအသစ်ထည့်ပါ`,
  [k.NOTIFICATIONS]: `အသစ်ထည့်ပါ`,
  [k.EVERYTHING]: `အားလုံး:`,
  [k.ALL_UPDATES_AND_MESSAGES]: `အားလုံးအသစ်ထည့်ပါပြီးအသစ်ထည့်ပါ`,
  [k.FOR_CONVERSATIONS_YOU_ARE_A_PA]: `သင့်အကြွင်းအသစ်ထည့်ပါပြီးအားလုံးအသစ်ထည့်ပါ`,
  [k.YOU_WILL_BE_NOTI]: `၊ သင့်အီးမေးလ်ကိုဖွင့်ပြီးပါပြီ`,
  [k.ALL_COMMENTS]: `အားလုံးအသစ်ထည့်ပါပြီးအားလုံးအသစ်ထည့်ပါ`,
  [k.AND_MESSAGES]: `အားလုံးအသစ်ထည့်ပါပြီးအားလုံးအသစ်ထည့်ပါ`,
  [k.YOU_VE_BEEN_ADDED]: `အားလုံးအသစ်ထည့်ပါပြီးအားလုံးအသစ်ထည့်ပါ`,
  [k.TO_A_CONVERSATION]: `အားလုံးအသစ်ထည့်ပါပြီးအားလုံးအသစ်ထည့်ပါ`,
  [k.ALL_STATUS_UPDATES]: `အားလုံးအသစ်ထည့်ပါပြီးအားလုံးအသစ်ထည့်ပါ`,
  [k.INCLUDING_WHEN_CONVERSATIONS]: `အားလုံးအသစ်ထည့်ပါပြီးအားလုံးအသစ်ထည့်ပါ`,
  [k.WHEN_THE_CONVERSATION_IS]: `အားလုံးအသစ်ထည့်ပါပြီးအားလုံးအသစ်ထည့်ပါ`,
  [k.OVERDUE1]: `အားလုံးအသစ်ထည့်ပါပြီးအားလုံးအသစ်ထည့်ပါ`,
  [k.AND_OTHER]: `နှင့်အခြား`,
  [k.ANY_OWNER_CHANGE]: `အားလုံးပြောင်းသူကိုပြောင်းပါ`,
  [k.OR_ASSIGNMENT]: `သို့မဟုတ်အကျင်းပြောင်းပါ`,
  [k.WHEN_YOU_VE_BEEN]: `သင့်အီးမေးလ်ကိုဖွင့်ပြီးပါပြီးပါပြီ`,
  [k.MENTIONED]: `@ကိုဖွင့်ပြီးပါ`,
  [k.IN_A_CONVERSATION]: `အကြွင်းအသစ်ထည့်ပါ`,
  [k.IMPORTANT]: `အသိအမှတ်:`,
  [k.STATUS_UPDATES_REMINDERS_AND]: `အားလုံးအသစ်ထည့်ပါပြီးအားလုံးအသစ်ထည့်ပါ`,
  [k.FOR_CONVERSATIONS_YOU_ARE_A_PA1]: `သင့်အကြွင်းအသစ်ထည့်ပါပြီးအားလုံးအသစ်ထည့်ပါ`,
  [k.YOU_WILL_BE_NOTIFI]: `သင့်အီးမေးလ်ကိုဖွင့်ပြီးပါပြီ`,
  [k.ALL_STATUS_UPDATES1]: `အားလုံးအသစ်ထည့်ပါပြီးအားလုံးအသစ်ထည့်ပါ`,
  [k.INCLUDING_WHEN_CONVERSATIONS1]: `၏ အားလုံးအသစ်ထည့်ပါပြီးအားလုံးအသစ်ထည့်ပါ`,
  [k.AND_OTHER_REMIND]: `နှင့်အခြား
              အသိအမှတ်ပါ`,
  [k.CRITICAL1]: `အသိအမှတ်:`,
  [k.CRITICAL_UPDATES_AND_MENTIONS]: `အသိအမှတ်အားလုံးအသစ်ထည့်ပါပြီးအားလုံးအသစ်ထည့်ပါ`,
  [k.YOU_VE_BEEN_ASSIGNED_AS_THE_OW]: `သင့်အကြွင်းအသစ်ထည့်ပါပြီးအားလုံးအသစ်ထည့်ပါ`,
  [k.OF_A_CONVERSATIO]: `သင့်အကြွင်းအသစ်ထည့်ပါပြီးအားလုံးအသစ်ထည့်ပါ`,
  [k.YOU_VE_BEEN]: `သင့်အကြွင်းအသစ်ထည့်ပါပြီးအားလုံးအသစ်ထည့်ပါ`,
  [k.NOTHING_NOT_RECOMMENDED]: `အားလုံးအသစ်ထည့်ပါပြီးအားလုံးအသစ်ထည့်ပါ`,
  [k.YOU_WILL_NOT_BE_NOTIFIED_VIA_E]: `သင့်အီးမေးလ်ကိုဖွင့်ပြီးပါပြီးပါပြီ။ ဤသို့သင့်အကြွင်းအသစ်ထည့်ပါပြီးအားလုံးအသစ်ထည့်ပါပြီးအားလုံးအသစ်ထည့်ပါ`,
  [k.SORT]: `အစီစဉ်`,
  [k.FILTER_VALUES1]: `စီစဉ်တည်းများ`,
  [k.SEARCH1]: `ရှာပါ`,
  [k.BLUETICK]: `အနှုန်းအနှုန်း`,
  [k.CREATE_NEW_STATUS]: `+ အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.ENTER_STATUS_TITLE]: `အသစ်အားလုံးအသစ်ထည့်ပါပြီးအားလုံးအသစ်ထည့်ပါ`,
  [k.ACTIVERADIOBUTTON]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.DEFAULTRADIOBUTTON]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.MAP_TO_PENDING]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.MAP_TO_COMPLETE]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.DISABLE_UNTIL_APPROVED]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.DELETETRASH]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.CIRCLEDOWN]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.HIDE_UNTIL_CONDITION_MET]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.ENABLE_UNTIL_CONDITION_MET]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.STATUS_TYPE]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.ARCHIVE_BEHAVIOR]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.IGNORE_ARCHIVING]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.AUTO_UNARCHIVE]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.STATUS_SETTINGS]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.YOU_NEED_TO_HAVE_AT_LEAST_ONE]: `သင့်အကြွင်းအသစ်ထည့်ပါ`,
  [k.PENDING2]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.AND]: `နှင့်`,
  [k.COMPLETED1]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.EACH]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.OK]: `အိုက်အိုက်`,
  [k._34]: `✕`,
  [k.THERE_IS_A_NEW_VERSION_OF_THE]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.ACCESS_DENIED]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.CONTACT_US]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.LOOKS_LIKE_YOUR_EMAIL_IS_NOT_V]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.AN_EMAIL_HAS_BEEN_SENT_TO_YOUR]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.STILL_HAVING_TROUBLES]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.FORGOT_YOUR_PASSWORD]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.ENTER_THE_EMAIL_ADDRESS_YOU_US]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.SEND_LINK]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.PASSWORD1]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.LOADING1]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.LOADING_CONVERSATIONS_FOR]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.UNABLE_TO_LOGIN]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.CONTINUE_IN_APP]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.HEY_THERE_LOOKS_LIKE_YOU_RE_T]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.CONTINUE_WITH_UNIFIZE_MOBILE_A]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.ABOUT_US]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.RESET_YOUR_PASSWORD]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.YOU_HAVE_CLICKED_ON_A_PASSWORD]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.ENTER_A_NEW_PASSWORD]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.AND_OTHER]: `နှင့်အခြား`,
  [k.ANY_OWNER_CHANGE]: `အကြွင်းအသစ်ထည့်ပါ`,
  [k.OR_ASSIGNMENT]: `သို့သောအသစ်ထည့်ပါ`,
  [k.WHEN_YOU_VE_BEEN]: `သင့်အကြွင်းအသစ်ထည့်ပါ`,
  [k.MENTIONED]: `@ကြည့်ပါ`,
  [k.IN_A_CONVERSATION]: `အကြွင်းအသစ်ထည့်ပါ`,
  [k.IMPORTANT]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.STATUS_UPDATES_REMINDERS_AND]: `အသစ်အားလုံးအသစ်ထည့်ပါ, သတ်မှတ်ချက်များနှင့် @ကြည့်ပါ`,
  [k.FOR_CONVERSATIONS_YOU_ARE_A_PA1]: `သင့်အကြွင်းအသစ်ထည့်ပါ,`,
  [k.YOU_WILL_BE_NOTIFI]: `သင့်အကြွင်းအသစ်ထည့်ပါ
            သို့သောအသစ်ထည့်ပါအားလုံးအသစ်ထည့်ပါအားလုံးအသစ်ထည့်ပါ:`,
  [k.ALL_STATUS_UPDATES1]: `အားလုံးအသစ်ထည့်ပါအားလုံးအသစ်ထည့်ပါ`,
  [k.INCLUDING_WHEN_CONVERSATIONS1]: `, အားလုံးအသစ်ထည့်ပါအားလုံးအသစ်ထည့်ပါ
              အားလုံးအသစ်ထည့်ပါအားလုံးအသစ်ထည့်ပါ`,
  [k.AND_OTHER_REMIND]: `နှင့်အခြား
              သတ်မှတ်ချက်များ`,
  [k.CRITICAL1]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.CRITICAL_UPDATES_AND_MENTIONS]: `အသစ်အားလုံးအသစ်ထည့်ပါ သို့သော @ကြည့်ပါ`,
  [k.YOU_VE_BEEN_ASSIGNED_AS_THE_OW]: `သင့်အကြွင်းအသစ်ထည့်ပါ`,
  [k.OF_A_CONVERSATIO]: `အကြွင်းအသစ်ထည့်ပါ`,
  [k.YOU_VE_BEEN]: `သင့်အကြွင်းအသစ်ထည့်ပါ`,
  [k.NOTHING_NOT_RECOMMENDED]: `အားလုံးအသစ်ထည့်ပါ (အသို့သောမသို့သော)`,
  [k.YOU_WILL_NOT_BE_NOTIFIED_VIA_E]: `သင့်အီးမေးလ်ကိုဖွင့်ပြီးပါပြီးပါပြီ။ ဤသို့သင့်အကြွင်းအသစ်ထည့်ပါပြီးအားလုံးအသစ်ထည့်ပါပြီးအားလုံးအသစ်ထည့်ပါ`,
  [k.SORT]: `အစီစဉ်`,
  [k.FILTER_VALUES1]: `စီစဉ်တည်းများ`,
  [k.SEARCH1]: `ရှာပါ`,
  [k.BLUETICK]: `အနှုန်းအနှုန်း`,
  [k.CREATE_NEW_STATUS]: `+ အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.ENTER_STATUS_TITLE]: `အသစ်အားလုံးအသစ်ထည့်ပါပြီးအားလုံးအသစ်ထည့်ပါ`,
  [k.ACTIVERADIOBUTTON]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.DEFAULTRADIOBUTTON]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.MAP_TO_PENDING]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.MAP_TO_COMPLETE]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.DISABLE_UNTIL_APPROVED]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.DELETETRASH]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.CIRCLEDOWN]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.HIDE_UNTIL_CONDITION_MET]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.ENABLE_UNTIL_CONDITION_MET]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.STATUS_TYPE]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.ARCHIVE_BEHAVIOR]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.IGNORE_ARCHIVING]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.AUTO_UNARCHIVE]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.STATUS_SETTINGS]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.YOU_NEED_TO_HAVE_AT_LEAST_ONE]: `သင့်အကြွင်းအသစ်ထည့်ပါ`,
  [k.PENDING2]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.AND]: `နှင့်`,
  [k.COMPLETED1]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.EACH]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.OK]: `အိုက်အိုက်`,
  [k._34]: `✕`,
  [k.THERE_IS_A_NEW_VERSION_OF_THE]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.ACCESS_DENIED]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.CONTACT_US]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.LOOKS_LIKE_YOUR_EMAIL_IS_NOT_V]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.AN_EMAIL_HAS_BEEN_SENT_TO_YOUR]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.STILL_HAVING_TROUBLES]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.FORGOT_YOUR_PASSWORD]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.ENTER_THE_EMAIL_ADDRESS_YOU_US]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.SEND_LINK]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.PASSWORD1]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.LOADING1]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.LOADING_CONVERSATIONS_FOR]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.UNABLE_TO_LOGIN]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.CONTINUE_IN_APP]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.HEY_THERE_LOOKS_LIKE_YOU_RE_T]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.CONTINUE_WITH_UNIFIZE_MOBILE_A]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.ABOUT_US]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.RESET_YOUR_PASSWORD]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.YOU_HAVE_CLICKED_ON_A_PASSWORD]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.ENTER_A_NEW_PASSWORD]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.RESET_MY_PASSWORD]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.PASSWORD_RESET]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.RESET_LINK_SENT]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.AND_OTHER]: `နှင့်အခြား`,
  [k.ANY_OWNER_CHANGE]: `အခြားပိုင်ရှင်းခြင်း`,
  [k.OR_ASSIGNMENT]: `သို့မဟုတ်အခြား`,
  [k.WHEN_YOU_VE_BEEN]: `သင့်ကိုယ်တိုင်းအသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.MENTIONED]: `@ကိုယ်တိုင်းအသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.IN_A_CONVERSATION]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.IMPORTANT]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.STATUS_UPDATES_REMINDERS_AND]: `အသစ်အားလုံးအသစ်ထည့်ပါ, အသစ်အားလုံးအသစ်ထည့်ပါ နှင့် @ကိုယ်တိုင်းအသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.FOR_CONVERSATIONS_YOU_ARE_A_PA1]: `သင့်ကိုယ်တိုင်းအသစ်အားလုံးအသစ်ထည့်ပါ,`,
  [k.YOU_WILL_BE_NOTIFI]: `သင့်ကိုယ်တိုင်းအသစ်အားလုံးအသစ်ထည့်ပါ
            သို့မဟုတ်အခြားပိုင်ရှင်းခြင်းအသစ်ထည့်ပါ:`,
  [k.ALL_STATUS_UPDATES1]: `အသစ်အားလုံးအသစ်ထည့်ပါ`,
  [k.INCLUDING_WHEN_CONVERSATIONS1]: `, အပြန်အလှန်များ
              ပြီးစီးသည့်အခါ`,
  [k.AND_OTHER_REMIND]: `နှင့်အခြား
              အတိတ်အမှတ်များ`,
  [k.CRITICAL1]: `အရေးပါသည်:`,
  [k.CRITICAL_UPDATES_AND_MENTIONS]: `အရေးပါသည့် အပြောင်းအလဲများ နှင့် @ကိုယ်တိုင်း`,
  [k.YOU_VE_BEEN_ASSIGNED_AS_THE_OW]: `သင့်ကိုယ်တိုင်းအပြန်အလှန်တစ်ခု၏ ပိုင်ရှင်အဖြစ် သတ်မှတ်ခံရသည်`,
  [k.OF_A_CONVERSATIO]: `အပြန်အလှန်တစ်ခု၏`,
  [k.YOU_VE_BEEN]: `သင့်ကိုယ်တိုင်း`,
  [k.NOTHING_NOT_RECOMMENDED]: `မည်သည့်အရာမျှ (မထောက်ပန်သည်)`,
  [k.YOU_WILL_NOT_BE_NOTIFIED_VIA_E]: `သင့်ကိုယ်တိုင်း အီးမေးလ်မှတစ်ဆင့် သတိပေးမည်မဟုတ်ပါ။ ဤသည်သင့်ကိုယ်တိုင်း ပါဝင်သည့် အရေးပါသည့် အပြန်အလှန်များကို မမြင်မြင်ပါနိုင်သည်။`,
  [k.SORT]: `အစီအစဉ်`,
  [k.FILTER_VALUES1]: `ဖြတ်ချက်များ`,
  [k.SEARCH1]: `ရှာဖွေ`,
  [k.BLUETICK]: `အပြာရောင်ခြစ်`,
  [k.CREATE_NEW_STATUS]: `+ အခြေအနေအသစ်ဖန်တီး`,
  [k.ENTER_STATUS_TITLE]: `အခြေအနေခေါင်းစဉ်ထည့်ပါ`,
  [k.ACTIVERADIOBUTTON]: `လုပ်ဆောင်နေသည့်ရေဒီယိုနှစ်`,
  [k.DEFAULTRADIOBUTTON]: `အမှတ်မထားရေဒီယိုနှစ်`,
  [k.MAP_TO_PENDING]: `Pending သို့ ပြောင်းပါ`,
  [k.MAP_TO_COMPLETE]: `Complete သို့ ပြောင်းပါ`,
  [k.DISABLE_UNTIL_APPROVED]: `အတည်ပြုချက်မှန်ထိ ပိတ်ပါ`,
  [k.DELETETRASH]: `အမှန်ပယ်ပါ`,
  [k.CIRCLEDOWN]: `အောက်သို့လှည့်ပါ`,
  [k.HIDE_UNTIL_CONDITION_MET]: `အခြေအနေပြည့်မှန်ထိ ဖုံးပါ`,
  [k.ENABLE_UNTIL_CONDITION_MET]: `အခြေအနေပြည့်မှန်ထိ ဖွင့်ပါ`,
  [k.STATUS_TYPE]: `အခြေအနေအမျိုးအစား`,
  [k.ARCHIVE_BEHAVIOR]: `အာကိုင်းပြုပုံပြမူ`,
  [k.IGNORE_ARCHIVING]: `အာကိုင်းပြုပုံပြမူကို မထီမဲ့ပါ`,
  [k.AUTO_UNARCHIVE]: `အာကိုင်းပြုပုံပြမူကို အလိုအလျောက် ဖွင့်ပါ`,
  [k.STATUS_SETTINGS]: `အခြေအနေအဆောက်အဦး`,
  [k.YOU_NEED_TO_HAVE_AT_LEAST_ONE]: `သင့်ကိုယ်တိုင်း အနည်းဆုံးတစ်ခုအား အခြေအနေအဆောက်အဦးတွင် ပြောင်းပါ`,
  [k.PENDING2]: `Pending`,
  [k.AND]: `နှင့်`,
  [k.COMPLETED1]: `Completed`,
  [k.EACH]: `အသီးသီး`,
  [k.OK]: `OK`,
  [k._34]: `✕`,
  [k.UPDATE_HAS_BEEN_RELEASED]: `အပ်ဒေးအသစ် ထုတ်ပြန်ပြီးပါပြီ။`,
  [k.THERE_IS_A_NEW_VERSION_OF_THE]: `ဤအပ်ပလီကေးရှိသည်။ ပြန်လည်သုံးပါ`,
  [k.ACCESS_DENIED]: `အာကသ်ပိတ်`,
  [k.CONTACT_US]: `ကျွန်ုပ်တို့နှင့် ဆက်သွယ်ပါ`,
  [k.LOOKS_LIKE_YOUR_EMAIL_IS_NOT_V]: `သင့်အီးမေးလ် အတည်ပြုခံရမှန်သည်`,
  [k.AN_EMAIL_HAS_BEEN_SENT_TO_YOUR]: `သင့်အကောင့်သို့ အီးမေးလ်တစ်ခု ပို့ခဲ့သည်။ သင့်အီးမေးလ်တွင် လင့်ချိတ်ကို ဖွင့်ပါ`,
  [k.STILL_HAVING_TROUBLES]: `အခက်အခဲများ ဆက်လက်ရှိနေပါသည်`,
  [k.FORGOT_YOUR_PASSWORD]: `သင့်စကားဝှက်ကို မေ့ပါ`,
  [k.ENTER_THE_EMAIL_ADDRESS_YOU_US]: `သင့်အကောင့်အတွက် အီးမေးလ်လိပ်စာ ရိုက်ထည့်ပါ။ သင့်အီးမေးလ်သို့ အချိန်အနည်းငယ်အတွင်း စကားဝှက်ပြန်လည်ပြုပြင်ရန် လင့်ချိတ်ပို့ခဲ့သည်`,
  [k.SEND_LINK]: `လင့်ချိတ်ပို့ပါ`,
  [k.PASSWORD1]: `စကားဝှက်`,
  [k.LOADING1]: `တင်နေဆဲ`,
  [k.LOADING_CONVERSATIONS_FOR]: `အပြန်အလှန်များ တင်နေဆဲ`,
  [k.UNABLE_TO_LOGIN]: `လုပ်ဆောင်နေဆဲ -`,
  [k.CONTINUE_IN_APP]: `အပ်ပလီကေးတွင် ဆက်လက်ပါ`,
  [k.HEY_THERE_LOOKS_LIKE_YOU_RE_T]: `ဟယ်သင့်ကို! သင့်ကိုယ်တိုင်း မိုဘိုင်းဖြင့် လုပ်ဆောင်နေဆဲဟု ထင်ပါသည်`,
  [k.CONTINUE_WITH_UNIFIZE_MOBILE_A]: `အပ်ပလီကေး မိုဘိုင်းအပ်ပလီကေးဖြင့် ဆက်လက်ပါ`,
  [k.ABOUT_US]: `ကျွန်ုပ်တို့အကြောင်း`,
  [k.RESET_YOUR_PASSWORD]: `သင့်စကားဝှက်ကို ပြန်လည်ပြုပြင်ပါ`,
  [k.YOU_HAVE_CLICKED_ON_A_PASSWORD]: `သင့်ကိုယ်တိုင်း စကားဝှက်ပြန်လည်ပြုပြင်ရန် လင့်ချိတ်တစ်ခုကို နှိပ်ခဲ့သည်`,
  [k.ENTER_A_NEW_PASSWORD]: `စကားဝှက်တစ်ခုသစ် ရိုက်ထည့်ပါ`,
  [k.RESET_MY_PASSWORD]: `ကျွန်ုပ့်စကားဝှက်ကို ပြန်လည်ပြုပြင်ပါ`,
  [k.PASSWORD_RESET]: `စကားဝှက်ပြန်လည်ပြုပြင်`,
  [k.RESET_LINK_SENT]: `ပြန်လည်ပြုပြင်ရန် လင့်ချိတ် ပို့ခဲ့သည်`,
  [k.RESET_INSTRUCTIONS_HAVE_BEEN_S]: `ပြန်လည်ပြုပြင်ရန် အမိန့်များ ပို့ခဲ့သည်`,
  [k.YOU_WILL_RECEIVE]: `. သင့်ကိုယ်တိုင်း အီးမေးလ်ကို အချိန်အနည်းငယ်အတွင်း ရရှိမည်`,
  [k.RESENT_INSTRUCTIONS]: `အမိန့်များ ပြန်လည်ပို့ပါ`,
  [k.PASSWORD_CHANGE_SUCCESSFUL]: `စကားဝှက်ပြန်လည်ပြုပြင်ရန် အောင်မြင်`,
  [k.YOUR_PASSWORD_HAS_BEEN_RESET_S]: `သင့်စကားဝှက် အောင်မြင်ပြန်လည်ပြုပြင်ခဲ့သည်`,
  [k.CONTINUE_TO_YOUR_UNIFIZE_APP]: `ကျွန်ုပ်တို့့အပ်ပလီကေးသို့ ဆက်လက်ပါ`,
  [k.SERVER_ERROR]: `ဆာဗာအမှား`,
  [k.RELOAD]: `ပြန်လည်တင်`,
  [k.LOGOUT]: `ထွက်ပြေး`,
  [k.XL]: `2xl`,
  [k.FORGOT_PASSWORD]: `စကားဝှက်ကို မေ့ပါ?`,
  [k.SIGN_UP_NOW]: `ယခုနှစ်ပါ!`,
  [k.THIS_EMAIL_ADDRESS_IS_NOT_VERI]: `ဤအီးမေးလ်လိပ်စာ အတည်ပြုခံရမှန်သည်`,
  [k.THE_USERNAME_OR_PASSWORD_IS_IN]: `အသုံးပြုသူအမည် သို့မဟုတ် စကားဝှက် မှားနေပါသည်`,
  [k.TOO_MANY_FAILED_LOGIN_ATTEMPTS]: `လုပ်ဆောင်နေဆဲ အကြိမ်များပြားပြီး နောက်တစ်ချိန်တွင် ပြန်လည်ကြိုးပမ်းပါ`,
  [k.SOMETHING_WENT_WRONG_TRY_AGAI]: `တစ်ခုတစ်ခု မှားနေပါသည်၊ နောက်တစ်ချိန်တွင် ပြန်လည်ကြိုးပမ်းပါ`,
  [k.PLEASE_CHECK_YOUR_INBOX]: `သင့်အီးမေးလ်အတွင်း စစ်ဆေးပါ`,
  [k.VERIFYING_YOUR_LINK]: `သင့်လင့်ချိတ် အတည်ပြုနေဆဲ`,
  [k.NO_CHARTS_FOUND]: `အချက်ပြများ တွေ့ရှိခဲ့သည်`,
  [k.REFRESH1]: `ပြန်လည်တင်`,
  [k.SELECT_FIELD1]: `အပိုင်းတစ်ခု ရွေးချယ်`,
  [k.TASKLIST]: `အလုပ်စာရင်း`,
  [k.MANDATORY1]: `အရေးကြီး`,
  [k.MANDATORY_FIELD_REMAINING]: `အရေးကြီးသော အပိုင်း ကျန်ရှိနေဆဲ`,
  [k.OPEN_CHECKLIST]: `စစ်ဆေးစာရင်း ဖွင့်`,
  [k.CARETLEFTFILLED]: `caretLeftFilled`,
  [k.CLICK_TO_ADD_DESCRIPTION]: `ဖော်ပြချက် ထည့်ရန် နှိပ်`,
  [k.VIEW_IN_ACTIVE_CHAT]: `လုပ်ဆောင်နေဆဲ အပြန်အလှန်တွင် ကြည့်`,
  [k.UNABLE_TO_PERFORM_ACTION]: `အလုပ်ဆောင်နေဆဲ မပြုနိုင်`,
  [k.YOU_SHOULD_NAVIGATE_TO_CONVERS]: `သင့်ကိုယ်တိုင်း အပြန်အလှန်သို့ သွားရန် လိုပါသည်`,
  [k.TO_PERFORM_THIS_ACTION]: `ဤအလုပ်ဆောင်နေဆဲ ပြုနိုင်ရန်`,
  [k.CONVERSATION_DIALOG]: `အပြန်အလှန်အင်း`,
  [k.CONVERSATION_DIALOG1]: `#conversation-dialog`,
  [k.DATEACTIVE]: `dateActive2`,
  [k.DATEACTIVE1]: `dateActive`,
  [k.FILES_FROM_UNIFIZE_CONVERSATIO]: `Unifize အပြန်အလှန်များမှ ဖိုင်များ`,
  [k.ATTACH_FILES_FROM_YOUR_COMPUTE]: `သင့်ကွန်ပျူတာမှ ဖိုင်များ တပ်`,
  [k.CC]: `Cc`,
  [k.BCC]: `Bcc`,
  [k.SUBJECT]: `အကြောင်း`,
  [k.SEND_AS_EMAIL]: `အီးမေးလ်အဖြစ် ပို့`,
  [k.DISCARD]: `ပယ်ဖျက်`,
  [k.SEND]: `ပို့`,
  [k.FILES_IN_CHATROOM]: `အပြန်အလှန်ခန်းတွင် ဖိုင်များ`,
  [k.ACCESS_REQUEST]: `အာကသ်တောင်းခံ`,
  [k.PEOPLE_HAVE_REQUESTED_TO_ACCES]: `လူများ ဤအပ်ပြန်အလှန်သို့ အာကသ်တောင်းခံနေဆဲ`,
  [k.ACCEPT]: `လက်ခံ`,
  [k.PEOPLE]: `လူများ`,
  [k.HAVE_REQUESTED_TO]: `အာကသ်တောင်းခံနေဆဲ`,
  [k.RESPOND]: `ဖြေကြေး`,
  [k.HAS_REQUESTED_TO_JOIN]: `ဤအပြန်အလှန်သို့ ပူးပေါင်းရန် တောင်းခံနေဆဲ`,
  [k.FAVOURITE]: `အကြိုက်`,
  [k._35]: `;`,
  [k.CHANGE_PROCESS_TYPE]: `လုပ်ငန်းစဉ်အမျိုးအစား ပြောင်း`,
  [k.TYPE2]: `type-`,
  [k.DAYS_OLD]: `ရက်ပေါင်း`,
  [k.LESS_THAN_A_DAY_OLD]: `တစ်ရက်ထက် နည်းပါသည်`,
  [k.LINK_COPIED]: `လင့်ချိတ် ကူးယူခဲ့သည်`,
  [k.CONVERSATION_LINK_HAS_BEEN_COP]: `အပြန်အလှန်လင့်ချိတ် ကူးယူခဲ့သည်`,
  [k.CONVERSATION_LINK]: `အပြန်အလှန်လင့်ချိတ်`,
  [k.DOWNLOAD_JSON]: `JSON ဒေါင်းလုပ်`,
  [k.FILES1]: `ဖိုင်များ (`,
  [k.NO_RESULTS_FOR]: `အနည်းဆုံး ရလဒ်များ မရှိ`,
  [k.EMAIL_ADDRESS_COPIED]: `အီးမေးလ်လိပ်စာ ကူးယူခဲ့သည်`,
  [k.USE_COPIED_EMAIL_ADDRESS_TO_FO]: `ကူးယူခဲ့သည် အီးမေးလ်လိပ်စာ ကို ဤအပြန်အလှန်သို့ စာပို့ရန် အသုံးပြု`,
  [k.FORWARD_MAIL_HERE]: `စာပို့ရန် ဤနေရာတွင်`,
  [k.PRIVACY]: `ပုဂ္ဂလိကအချက်`,
  [k.HIDE_EVERYTHING1]: `(အရာရာ ဖုံး)`,
  [k.HIDE_ONLY_CHAT_CONTENT1]: `(အပြန်အလှန်အားဖြင့် ဖုံး)`,
  [k.PROCESS_BUILDER]: `လုပ်ငန်းစဉ်တည်ဆောက်သူ`,
  [k.RELATED_CONVERSATIONS]: `ဆက်စပ်နေသော အပြန်အလှန်များ`,
  [k.MOREMENUFILLED]: `moreMenuFilled`,
  [k.MOREMENU]: `moreMenu`,
  [k.MORE2]: `ပိုပြီ`,
  [k.V]: `V`,
  [k.REVISIONS1]: `ပြင်ဆင်မှုများ`,
  [k.CHAT_INPUT]: `အပြန်အလှန်ထည့်`,
  [k.PLUS]: `ပိုပြီ`,
  [k.PLUSCHATICON]: `ပိုပြီအပြန်အလှန်အမှတ်တံဆိပ်`,
  [k.D]: `d`,
  [k.FORWARD_TO]: `ပို့ရန်`,
  [k.FORWARD]: `ပို့`,
  [k.UPLOAD_IMAGE]: `ရုပ်ပုံ တင်ရန်`,
  [k.ARE_YOU_SURE_YOU_WANT_TO_UPLOA]: `ဤရုပ်ပုံကို တင်ရန် သင့်ကို သေချာပါသလား`,
  [k.OWNER2]: `ပိုင်ရှင်`,
  [k.SELECTED1]: `ရွေးချယ်ထားသည်`,
  [k.RECENT]: `နောက်ဆုံး`,
  [k.ADD_LINK]: `လင့်ချိတ် ထည့်`,
  [k.ENTER_VALID_URL]: `မှန်ကန်သော URL ထည့်`,
  [k.MENTIONBUTTON]: `ဖော်ပြချက်နှိပ်`,
  [k.NO_RESULTS_FOUND]: `ရလဒ်များ မရှိ`,
  [k.EVERY_PARTICIPANT_OF_THE_CONV]: `(ဤအပြန်အလှန်၏ အားလုံးသော ပါဝင်သူ)`,
  [k.CURRENT_OWNER_OF_THE_CONVERSA]: `(ဤအပြန်အလှန်၏ လက်ရှိပိုင်ရှင်)`,
  [k.CREATOR_OF_THE_CONVERSATION]: `(ဤအပြန်အလှန်၏ ဖန်တီးသူ)`,
  [k.LOADING_MESSAGES]: `မှတ်ချက်များ တင်ရန်...`,
  [k.JOIN]: `ပူးပေါင်း`,
  [k.FULL_NAME_OPTIONAL]: `အမည်အပြည့် (ရွေးချယ်နိုင်)`,
  [k.EMAIL_ADDRESS1]: `အီးမေးလ်လိပ်စာ`,
  [k.SELECT_ROLE]: `အခန်းကဏ္ဍ ရွေး`,
  [k.SEND_INVITE]: `ဖိတ်ကြား ပို့`,
  [k.ADD_PARTICIPANTS_OR_GROUPS]: `ပါဝင်သူများ သို့မဟုတ် အဖွဲ့များ ထည့်`,
  [k.NAME_EMAIL_OR_GROUP]: `အမည်, အီးမေးလ် သို့မဟုတ် အဖွဲ့`,
  [k.INVITE]: `ဖိတ်ကြား "`,
  [k.NO_RESULTS_FOR1]: `အနည်းဆုံး ရလဒ်များ မရှိ "`,
  [k.TO_INVITE_SOMEONE_EXTERNALLY]: `ပြင်ပမှ သူတစ်ဦးကို ဖိတ်ကြားရန် သင့်ကို သူ၏ အီးမေးလ်လိပ်စာ ကို အသုံးပြုရန် လိုပါသည်。 ဥပမာ,`,
  [k.JOHN_DOE_ACME_COM]: `john.doe@acme.com`,
  [k.TO_CONVERSATION]: `မှတ်ချက် တင်ရန်`,
  [k.SEND_INVITES]: `ဖိတ်ကြားများ ပို့`,
  [k.PARTICIPANTS1]: `ပါဝင်သူများ`,
  [k.ADD_PARTICIPANTS_OR_GROUPS1]: `+ ပါဝင်သူများ သို့မဟုတ် အဖွဲ့များ ထည့်`,
  [k.PARTICIPANT]: `ပါဝင်သူ`,
  [k.CURVE]: `ကွေး`,
  [k.DELETED_USER]: `ဖျက်ပစ်ထားသော အသုံးပြုသူ`,
  [k.CHAT_WITH]: `အပြန်အလှန် ပြု`,
  [k.START_RELATED_CONVERSATION]: `ဆက်စပ်နေသော မှတ်ချက် စတင်`,
  [k.OTHER]: `အခြား`,
  [k.ADD_TO_CONVERSATION]: `မှတ်ချက်သို့ ထည့်`,
  [k.MEMBER1]: `အဖွဲ့ဝင်`,
  [k.UPLOAD_FILES]: `ဖိုင်များ တင်`,
  [k.FROM_PRIVATE_CONVERSATION]: `ပုဂ္ဂလိက အပြန်အလှန်မှ`,
  [k.START_PROCESS]: `လုပ်ငန်း စတင်`,
  [k.REMOVE_OWNER]: `ပိုင်ရှင် ဖယ်`,
  [k.INVITE1]: `ဖိတ်ကြား`,
  [k.INVITE_VIA_EMAIL]: `အီးမေးလ် ဖြင့် ဖိတ်ကြား`,
  [k.ASSIGN_OWNER]: `ပိုင်ရှင် ခန့်`,
  [k.NOOWNERACTIVE]: `ပိုင်ရှင် မရှိ`,
  [k.NOOWNER]: `ပိုင်ရှင် မရှိ`,
  [k.ASSIGN_OWNER1]: `ပိုင်ရှင် ခန့်`,
  [k.NO_OWNER]: `ပိုင်ရှင် မရှိ`,
  [k.MESSAGE]: `မှတ်ချက်`,
  [k.SET_PRIORITY]: `အရေးပါမှု သတ်မှတ်`,
  [k.SET_DUE_DATE]: `ကြာချိန် သတ်မှတ်`,
  [k.SET_PRIORITY_FOR_CONVERSATION]: `ဤမှတ်ချက်၏ အရေးပါမှု သတ်မှတ်`,
  [k.BOLD]: `အမှီသဟဲ`,
  [k.GRAY2]: `မှိုင်း.200`,
  [k.PRIORITY2]: `အရေးပါမှု:`,
  [k.FAILED_TO_UPLOAD]: `တင်ရန် မအောင်မြင်`,
  [k.UPLOADING]: `တင်နေဆဲ`,
  [k.RESTRICTED_ACCESS]: `ကန့်သတ်ထားသော အာကသ်`,
  [k.THE_CONVERSATION_YOU_ARE_TRYIN]: `သင် ကြိုးပမ်းနေဆဲ အပြန်အလှန် သည် သင်၏ အကောင့်သို့ ဖွင့်ပြန်မရန် ဖြစ်သည်။ သင်၏ အဖွဲ့ အုပ်ချုပ်သူသို့ ဆက်သွယ်ရန် လိုပါသည်`,
  [k.FAILED_TO_LOAD_THE_CHATROOM]: `အပြန်အလှန်ခန်း တင်ရန် မအောင်မြင်`,
  [k.CONVERSATION_NOT_FOUND]: `အပြန်အလှန် မတွေ့`,
  [k.DEFINE_NEW]: `အသစ် ဖွင့်`,
  [k.REVISIONS1]: `ပြင်ဆင်မှုများ`,
  [k.CHAT_INPUT]: `အပြန်အလှန်ထည့်`,
  [k.PLUS]: `ပလပ်`,
  [k.PLUSCHATICON]: `ပလပ်အပြန်အလှန်အမှတ်`,
  [k.D]: `ဒီ`,
  [k.FORWARD_TO]: `ရှေ့သို့ ပို့`,
  [k.FORWARD]: `ရှေ့သို့`,
  [k.UPLOAD_IMAGE]: `ရုပ်ပုံ တင်`,
  [k.ARE_YOU_SURE_YOU_WANT_TO_UPLOA]: `သင် ဤရုပ်ပုံကို တင်ရန် သေချာပါသလား`,
  [k.OWNER2]: `ပိုင်ရှင်`,
  [k.SELECTED1]: `ရွေးချယ်`,
  [k.RECENT]: `နောက်ဆုံး`,
  [k.ADD_LINK]: `လင့်ခ် ထည့်`,
  [k.ENTER_VALID_URL]: `မှန်ကန်သော URL ထည့်`,
  [k.MENTIONBUTTON]: `ဖော်ပြချက်နှိပ်တင်`,
  [k.NO_RESULTS_FOUND]: `ရလဒ်များ မတွေ့`,
  [k.EVERY_PARTICIPANT_OF_THE_CONV]: `(ဤအပြန်အလှန်၏ ပါဝင်သူများအားလုံး)`,
  [k.CURRENT_OWNER_OF_THE_CONVERSA]: `(ဤအပြန်အလှန်၏ လက်ရှိပိုင်ရှင်)`,
  [k.CREATOR_OF_THE_CONVERSATION]: `(ဤအပြန်အလှန်၏ ဖန်တီးသူ)`,
  [k.LOADING_MESSAGES]: `မှတ်ချက်များ တင်ရန်...`,
  [k.JOIN]: `ပူးပေါင်း`,
  [k.FULL_NAME_OPTIONAL]: `အမည်အပြည့် (ရွေးချယ်နိုင်)`,
  [k.EMAIL_ADDRESS1]: `အီးမေးလ်လိပ်စာ`,
  [k.SELECT_ROLE]: `အခန်းကဏ္ဍ ရွေး`,
  [k.SEND_INVITE]: `ဖိတ်ကြား ပို့`,
  [k.ADD_PARTICIPANTS_OR_GROUPS]: `ပါဝင်သူများ သို့မဟုတ် အဖွဲ့များ ထည့်`,
  [k.NAME_EMAIL_OR_GROUP]: `အမည်, အီးမေးလ် သို့မဟုတ် အဖွဲ့`,
  [k.INVITE]: `ဖိတ်ကြား "`,
  [k.NO_RESULTS_FOR1]: `အနည်းဆုံး ရလဒ်များ မရှိ "`,
  [k.TO_INVITE_SOMEONE_EXTERNALLY]: `ပြင်ပမှ သူတစ်ဦးကို ဖိတ်ကြားရန် သင့်ကို သူ၏ အီးမေးလ်လိပ်စာ ကို အသုံးပြုရန် လိုပါသည်。 ဥပမာ,`,
  [k.JOHN_DOE_ACME_COM]: `john.doe@acme.com`,
  [k.TO_CONVERSATION]: `မှတ်ချက် တင်ရန်`,
  [k.SEND_INVITES]: `ဖိတ်ကြားများ ပို့`,
  [k.PARTICIPANTS1]: `ပါဝင်သူများ`,
  [k.ADD_PARTICIPANTS_OR_GROUPS1]: `+ ပါဝင်သူများ သို့မဟုတ် အဖွဲ့များ ထည့်`,
  [k.PARTICIPANT]: `ပါဝင်သူ`,
  [k.CURVE]: `ကွေး`,
  [k.DELETED_USER]: `ဖျက်ပစ်ထားသော အသုံးပြုသူ`,
  [k.CHAT_WITH]: `အပြန်အလှန် ပြု`,
  [k.START_RELATED_CONVERSATION]: `ဆက်စပ်နေသော မှတ်ချက် စတင်`,
  [k.OTHER]: `အခြား`,
  [k.ADD_TO_CONVERSATION]: `မှတ်ချက်သို့ ထည့်`,
  [k.MEMBER1]: `အဖွဲ့ဝင်`,
  [k.UPLOAD_FILES]: `ဖိုင်များ တင်`,
  [k.FROM_PRIVATE_CONVERSATION]: `ပုဂ္ဂလိက အပြန်အလှန်မှ`,
  [k.START_PROCESS]: `လုပ်ငန်း စတင်`,
  [k.REMOVE_OWNER]: `ပိုင်ရှင် ဖယ်`,
  [k.INVITE1]: `ဖိတ်ကြား`,
  [k.INVITE_VIA_EMAIL]: `အီးမေးလ် ဖြင့် ဖိတ်ကြား`,
  [k.ASSIGN_OWNER]: `ပိုင်ရှင် ခန့်`,
  [k.NOOWNERACTIVE]: `ပိုင်ရှင် မရှိ`,
  [k.NOOWNER]: `ပိုင်ရှင် မရှိ`,
  [k.ASSIGN_OWNER1]: `ပိုင်ရှင် ခန့်`,
  [k.NO_OWNER]: `ပိုင်ရှင် မရှိ`,
  [k.MESSAGE]: `မှတ်ချက်`,
  [k.SET_PRIORITY]: `အရေးပါမှု သတ်မှတ်`,
  [k.SET_DUE_DATE]: `ကြာချိန် သတ်မှတ်`,
  [k.SET_PRIORITY_FOR_CONVERSATION]: `ဤမှတ်ချက်၏ အရေးပါမှု သတ်မှတ်`,
  [k.BOLD]: `အမှီသဟဲ`,
  [k.GRAY2]: `မှိုင်း.200`,
  [k.PRIORITY2]: `အရေးပါမှု:`,
  [k.FAILED_TO_UPLOAD]: `တင်ရန် မအောင်မြင်`,
  [k.UPLOADING]: `တင်နေဆဲ`,
  [k.RESTRICTED_ACCESS]: `ကန့်သတ်ထားသော အာကသ်`,
  [k.REVISIONS1]: `ပြုပြင်မှုများ`,
  [k.CHAT_INPUT]: `chat-input`,
  [k.PLUS]: `plus`,
  [k.PLUSCHATICON]: `plusChatIcon`,
  [k.D]: `d`,
  [k.FORWARD_TO]: `ရှေ့သို့ ပို့`,
  [k.FORWARD]: `ရှေ့သို့`,
  [k.UPLOAD_IMAGE]: `ရုပ်ပုံ တင်`,
  [k.ARE_YOU_SURE_YOU_WANT_TO_UPLOA]: `သင် ဤရုပ်ပုံကို တင်ရန် သေချာပါသလား`,
  [k.OWNER2]: `ပိုင်ရှင်`,
  [k.SELECTED1]: `ရွေးချယ်`,
  [k.RECENT]: `နောက်ဆုံး`,
  [k.ADD_LINK]: `လင့်ချိတ် ထည့်`,
  [k.ENTER_VALID_URL]: `မှန်ကန်သော URL ထည့်`,
  [k.MENTIONBUTTON]: `ဖော်ပြချက်နှိပ်တင်`,
  [k.NO_RESULTS_FOUND]: `ရလဒ်များ မရှိ`,
  [k.EVERY_PARTICIPANT_OF_THE_CONV]: `(ဤမှတ်ချက်၏ ပါဝင်သူများအားလုံး)`,
  [k.CURRENT_OWNER_OF_THE_CONVERSA]: `(ဤမှတ်ချက်၏ လက်ရှိ ပိုင်ရှင်)`,
  [k.CREATOR_OF_THE_CONVERSATION]: `(ဤမှတ်ချက်၏ ဖန်တီးသူ)`,
  [k.LOADING_MESSAGES]: `မှတ်ချက်များ တင်နေဆဲ...`,
  [k.JOIN]: `ပူးပေါင်း`,
  [k.FULL_NAME_OPTIONAL]: `အမည်အပြည့် (ရွေးချယ်နိုင်)`,
  [k.EMAIL_ADDRESS1]: `အီးမေးလ်လိပ်စာ`,
  [k.SELECT_ROLE]: `အခန်းကဏ္ဍ ရွေး`,
  [k.SEND_INVITE]: `ဖိတ်ကြား ပို့`,
  [k.ADD_PARTICIPANTS_OR_GROUPS]: `ပါဝင်သူများ သို့မဟုတ် အဖွဲ့များ ထည့်`,
  [k.NAME_EMAIL_OR_GROUP]: `အမည်, အီးမေးလ် သို့မဟုတ် အဖွဲ့`,
  [k.INVITE]: `ဖိတ်ကြား "`,
  [k.NO_RESULTS_FOR1]: `အနည်းဆုံး ရလဒ်များ မရှိ "`,
  [k.TO_INVITE_SOMEONE_EXTERNALLY]: `ပြင်ပမှ သူတစ်ဦးကို ဖိတ်ကြားရန် သင့်ကို သူ၏ အီးမေးလ်လိပ်စာ ကို အသုံးပြုရန် လိုပါသည်。 ဥပမာ,`,
  [k.JOHN_DOE_ACME_COM]: `john.doe@acme.com`,
  [k.TO_CONVERSATION]: `မှတ်ချက် တင်ရန်`,
  [k.SEND_INVITES]: `ဖိတ်ကြားများ ပို့`,
  [k.PARTICIPANTS1]: `ပါဝင်သူများ`,
  [k.ADD_PARTICIPANTS_OR_GROUPS1]: `+ ပါဝင်သူများ သို့မဟုတ် အဖွဲ့များ ထည့်`,
  [k.PARTICIPANT]: `ပါဝင်သူ`,
  [k.CURVE]: `ကွေး`,
  [k.DELETED_USER]: `ဖျက်ပစ်ထားသော အသုံးပြုသူ`,
  [k.CHAT_WITH]: `အပြန်အလှန် ပြု`,
  [k.START_RELATED_CONVERSATION]: `ဆက်စပ်နေသော မှတ်ချက် စတင်`,
  [k.OTHER]: `အခြား`,
  [k.ADD_TO_CONVERSATION]: `မှတ်ချက်သို့ ထည့်`,
  [k.MEMBER1]: `အဖွဲ့ဝင်`,
  [k.UPLOAD_FILES]: `ဖိုင်များ တင်`,
  [k.FROM_PRIVATE_CONVERSATION]: `ပုဂ္ဂလိက အပြန်အလှန်မှ`,
  [k.START_PROCESS]: `လုပ်ငန်း စတင်`,
  [k.REMOVE_OWNER]: `ပိုင်ရှင် ဖယ်`,
  [k.INVITE1]: `ဖိတ်ကြား`,
  [k.INVITE_VIA_EMAIL]: `အီးမေးလ် ဖြင့် ဖိတ်ကြား`,
  [k.ASSIGN_OWNER]: `ပိုင်ရှင် ခန့်`,
  [k.JOIN]: `ပူးပေါင်း`,
  [k.FULL_NAME_OPTIONAL]: `အမည်အပြည့် (ရွေးချယ်နိုင်)`,
  [k.EMAIL_ADDRESS1]: `အီးမေးလ်လိပ်စာ`,
  [k.SELECT_ROLE]: `အခန်းကဏ္ဍ ရွေး`,
  [k.SEND_INVITE]: `ဖိတ်ကြား ပို့`,
  [k.ADD_PARTICIPANTS_OR_GROUPS]: `ပါဝင်သူများ သို့မဟုတ် အဖွဲ့များ ထည့်`,
  [k.NAME_EMAIL_OR_GROUP]: `အမည်, အီးမေးလ် သို့မဟုတ် အဖွဲ့`,
  [k.INVITE]: `ဖိတ်ကြား "`,
  [k.X3]: `X`,
  [k.ADDITIONAL_COMMENTS]: `အကူအညီများ`,
  [k.SKIP]: `မရွေးချယ်`,
  [k.ARCHIVE]: `ကိုယ်စားလှယ်`,
  [k.THIS_CONVERSATION]: `ဤမှတ်ချက်`,
  [k.ARCHIVE1]: `ကိုယ်စားလှယ်`,
  [k.CROP_UPLOAD]: `ကိုယ်စားလှယ်`,
  [k.FILEINPUT]: `fileInput`,
  [k.BOOLEAN]: `ဖြေရှင်းမှု`,
  [k.DETAILS_OBJECTIVE]: `အကူအညီများ / ပုံမှန်`,
  [k.DUE_DATE]: `ပြီးခဲ့သည်`,
  [k.START_DIRECT_CONVERSATION]: `အပြန်အလှန် ပြုမှတ်ချက် စတင်`,
  [k.YOU_CANT_CHAT_WITH_YOURSELF]: `You cant chat with yourself`,
  [k.CHOOSE_USER_TO_CHAT_WITH]: `အသုံးပြုသူကို ရွေးချယ်`,
  [k.TO_INVITE_SOMEONE_EXTERNALLY1]: `ပြင်ပမှ သူတစ်ဦးကို ဖိတ်ကြားရန် သင့်ကို သူ၏ အီးမေးလ်လိပ်စာ ကို အသုံးပြုရန် လိုပါသည်。 ဥပမာ,`,
  [k.PARENTS]: `မိသားများ`,
  [k.CHILDREN]: `အဖွားများများ`,
  [k.OVERDUE2]: `ကြာချိန် (`,
  [k.COMPLETED2]: `ပြီးခဲ့သည် (`,
  [k.I]: `ကြာချိန်သည်`,
  [k.M_OWNER]: `ကြာချိန်သည် (`,
  [k.RELATED_CHILDREN]: `အဖွားများများ (`,
  [k.RELATED_PARENTS]: `မိသားများများ (`,
  [k.SHOWING]: `ပြသသည်`,
  [k.OPTION]: `ရွေးချယ်ရန်`,
  [k.I_M_THE_OWNER]: `ကြာချိန်သည်`,
  [k.RELATED]: `အဖွားများများ`,
  [k.DATEWARNING]: `ကြာချိန်သည်သည်သည်သည်သည်`,
  [k.COMPLETED3]: `ပြီးခဲ့သည်`,
  [k.INCOMPLETE1]: `မပြီးခဲ့သည်`,
  [k.RELATED1]: `အဖွားများများ`,
  [k.NO_LONGER_MATCHES_THE_LIST_F]: `ကြာချိန်သည်သည်သည်သည်သည်`,
  [k.SEND_A_DIRECT_MESSAGE]: `ကြာချိန်သည်`,
  [k.START_WITH_THIS_SOLUTION]: `ကြာချိန်သည်`,
  [k.NO_MATCHING_RESULTS1]: `ကြာချိန်သည်`,
  [k.THERE_WEREN_T_ANY_CONVERSATION]: `ကြာချိန်သည်`,
  [k.TRY_WIDENING_YOUR_SEARCH]: `ကြာချိန်သည်`,
  [k.CONGRATULATIONS]: `ကြာချိန်သည်`,
  [k.YOU_HAVE_UNREAD_CONVERSATION]: `ကြာချိန်သည်`,
  [k.TRY_APPLYING_OTHER_FILTERS]: `ကြာချိန်သည်`,
  [k.EDIT_FILTER]: `ကြာချိန်သည်`,
  [k.SAVE_FILTER]: `ကြာချိန်သည်`,
  [k.ERROR_EDITING_FILTER]: `ကြာချိန်သည်`,
  [k.FILTER_CANNOT_BE_SAVED]: `ကြာချိန်သည်`,
  [k.SORT_BY3]: `ကြာချိန်သည်`,
  [k.CUSTOM]: `ကြာချိန်သည်`,
  [k.VIEW_AND_SELECT_FROM_ALL_STATU]: `ကြာချိန်သည်`,
  [k.STATUS2]: `ကြာချိန်သည်`,
  [k.CLOSEFILTER]: `ကြာချိန်သည်`,
  [k.CLEAR]: `ကြာချိန်သည်`,
  [k.ALL_TYPES]: `ကြာချိန်သည်`,
  [k.SAVED_FILTERS]: `ကြာချိန်သည်`,
  [k.QUICK_FILTERED_LISTS]: `ကြာချိန်သည်`,
  [k.SUGGESTED]: `ကြာချိန်သည်`,
  [k.ALL_CONVERSATIONS]: `ကြာချိန်သည်`,
  [k.ALL_CONVERSATIONS1]: `ကြာချိန်သည်`,
  [k.FAVOURITES]: `ကြာချိန်သည်`,
  [k.FAVOURITES1]: `ကြာချိန်သည်`,
  [k.STAR]: `ကြာချိန်သည်`,
  [k.ACTIVEQUICKFILTER]: `ကြာချိန်သည်`,
  [k.DEFAULTQUICKFILTER]: `ကြာချိန်သည်`,
  [k.BACKARROW]: `ကြာချိန်သည်`,
  [k.CHANGE]: `ကြာချိန်သည်`,
  [k.CONVERSATION_TYPE_NOT_FOUND]: `ကြာချိန်သည်`,
  [k.ALL_PROCESSES]: `ကြာချိန်သည်`,
  [k.ALL_TASKS]: `ကြာချိန်သည်`,
  [k.ALL_APPROVALS]: `ကြာချိန်သည်`,
  [k.SEARCH_CONVERSATION]: `ကြာချိန်သည်`,
  [k.ADD_A_DEPARTMENT]: `ကြာချိန်သည်`,
  [k.SEARCH_FOR_DEPARTMENTS]: `ကြာချိန်သည်`,
  [k.NO_DEPARTMENT]: `ကြာချိန်သည်`,
  [k.CREATE_NEW_DEPARTMENT]: `ကြာချိန်သည်`,
  [k.ENTER_YOUR_DEPARTMENT]: `ကြာချိန်သည်`,
  [k.OBJECT1]: `ကြာချိန်သည်`,
  [k.CLONE1]: `ကြာချိန်သည်`,
  [k.ORGANISE]: `ကြာချိန်သည်`,
  [k.CREATE_NEW_FOLDER]: `ကြာချိန်သည်`,
  [k.NEW_FOLDER]: `ကြာချိန်သည်`,
  [k.MEDIUM]: `ကြာချိန်သည်`,
  [k.MOVE_HERE]: `ကြာချိန်သည်`,
  [k.ALL_ORG_FILES]: `ကြာချိန်သည်`,
  [k.MY_DRIVE]: `ကြာချိန်သည်`,
  [k.V1]: `ကြာချိန်သည်`,
  [k.CURRENT_VERSION]: `ကြာချိန်သည်`,
  [k.MAKE_CURRENT1]: `ကြာချိန်သည်`,
  [k.VERSION_HISTORY]: `ကြာချိန်သည်`,
  [k.PIN]: `ကြာချိန်သည်`,
  [k.TO_ACTIVE_CONVERSATION]: `ကြာချိန်သည်`,
  [k.PIN1]: `ကြာချိန်သည်`,
  [k.PIN_TO_ACTIVE_CONVERSATION]: `ကြာချိန်သည်`,
  [k.ORGANISE1]: `ကြာချိန်သည်`,
  [k.TRASH]: `ကြာချိန်သည်`,
  [k.SEE_RELATED_CONVERSATIONS]: `ကြာချိန်သည်`,
  [k.FILE_NAME]: `ကြာချိန်သည်`,
  [k.SIZE]: `ကြာချိန်သည်`,
  [k.LAST_MODIFIED]: `ကြာချိန်သည်`,
  [k.UPLOADED_BY]: `ကြာချိန်သည်`,
  [k.MY_FILES]: `ကြာချိန်သည်`,
  [k.ALL_FILES]: `ကြာချိန်သည်`,
  [k.PIN_CONVERSATION]: `ကြာချိန်သည်`,
  [k.PIN_FILE]: `ကြာချိန်သည်`,
  [k.TO1]: `ကြာချိန်သည်`,
  [k.ADD_MORE]: `ကြာချိန်သည်`,
  [k.OPTIONAL_COMMENT]: `ကြာချိန်သည်`,
  [k.FILES_NOT_FOUND]: `ကြာချိန်သည်`,
  [k.NO_RESULT]: `ကြာချိန်သည်`,
  [k.UPLOAD_FILE]: `ကြာချိန်သည်`,
  [k.SORT_BY_ALPHABET]: `ကြာချိန်သည်`,
  [k.LAST_MODIFY]: `ကြာချိန်သည်`,
  [k.RECENTLY_VIEWED]: `ကြာချိန်သည်`,
  [k.UPLOAD_A_FILE]: `ကြာချိန်သည်`,
  [k.UPLOAD_FILE1]: `ကြာချိန်သည်`,
  [k.UPLOAD_NEW_VERSION1]: `ကြာချိန်သည်`,
  [k.THIS_FILE_IS_SHARED_ON_A_FOLDE]: `ကြာချိန်သည်`,
  [k.IT_LOOKS_LIKE_YOU_ARE_UPLOADIN]: `ကြာချိန်သည်`,
  [k.IS_THAT_CORRECT]: `ကြာချိန်သည်`,
  [k.ENTER_VERSION_NOTES_COMMENTS]: `ကြာချိန်သည်`,
  [k.CONTINUE]: `ကြာချိန်သည်`,
  [k.NO_ORGS_WITH_GIVEN_NAME]: `ကြာချိန်သည်`,
  [k.DASHBOARD1]: `ကြာချိန်သည်`,
  [k.MANAGE1]: `ကြာချိန်သည်`,
  [k.CRASH]: `ကြာချိန်သည်`,
  [k.DISPLAYNAME_ASC]: `ကြာချိန်သည်`,
  [k.ACTIVE]: `ကြာချိန်သည်`,
  [k.CLONE_ORG]: `ကြာချိန်သည်`,
  [k.COPY_LINK]: `ကြာချိန်သည်`,
  [k.CREATE_NEW_ORG]: `ကြာချိန်သည်`,
  [k.TEAM_NAME]: `ကြာချိန်သည်`,
  [k.INVITE_YOUR_TEAM_MEMBERS]: `ကြာချိန်သည်`,
  [k.TEAM_MEMBER_OPTIONAL]: `ကြာချိန်သည်`,
  [k.DOMAIN_NAME]: `ကြာချိန်သည်`,
  [k.OPTIONAL1]: `ကြာချိန်သည်`,
  [k.ALLOW_ANYONE_WITH]: `ကြာချိန်သည်`,
  [k.EMAIL_TO_JOIN_THIS_TEAM]: `ကြာချိန်သည်`,
  [k.ALLOW_ANYONE_WITH_GIVEN_DOMAIN]: `ကြာချိန်သည်`,
  [k.ORGDARK]: `ကြာချိန်သည်`,
  [k.ORG2]: `ကြာချိန်သည်`,
  [k.CHANGE_PASSWORD]: `ကြာချိန်သည်`,
  [k.CIRCLECHECK]: `ကြာချိန်သည်`,
  [k.PASSWORD_DOES_NOT_MATCH]: `ကြာချိန်သည်`,
  [k.PARENTS]: `မိဘများ`,
  [k.CHILDREN]: `ကလေးများ`,
  [k.OVERDUE2]: `ကျော်လွန်သည် (`,
  [k.COMPLETED2]: `ပြီးစီးသည် (`,
  [k.I]: `ကျွန်ုပ်`,
  [k.M_OWNER]: `m ပိုင်ရှင် (`,
  [k.RELATED_CHILDREN]: `ဆက်စပ်နေသည့် ကလေးများ (`,
  [k.RELATED_PARENTS]: `ဆက်စပ်နေသည့် မိဘများ (`,
  [k.SHOWING]: `ပြသနေသည်`,
  [k.OPTION]: `ရွေးချယ်မှု`,
  [k.I_M_THE_OWNER]: `ကျွန်ုပ်သည် ပိုင်ရှင်ဖြစ်သည်`,
  [k.RELATED]: `ဆက်စပ်နေသည်`,
  [k.DATEWARNING]: `ရက်စွဲသတိပေးခြင်း`,
  [k.COMPLETED3]: `ပြီးစီးသည်`,
  [k.INCOMPLETE1]: `မပြီးစီးသေး`,
  [k.RELATED1]: `ဆက်စပ်နေသည်`,
  [k.NO_LONGER_MATCHES_THE_LIST_F]: `ထိုစာရင်း/ဖီလ်တာနှင့် တိုတောင်းပြီ`,
  [k.SEND_A_DIRECT_MESSAGE]: `တိုက်ရိုက်သော စာတိုပေးပို့ပါ`,
  [k.START_WITH_THIS_SOLUTION]: `ဤဖြေရှင်းနှင့် စတင်ပါ`,
  [k.NO_MATCHING_RESULTS1]: `တူညီသည့် ရလဒ်များ မရှိပါ`,
  [k.THERE_WEREN_T_ANY_CONVERSATION]: `သင့်ထက်မြန်သည့် ဆွေးနွေးမှုများ မရှိပါ`,
  [k.TRY_WIDENING_YOUR_SEARCH]: `သင့်ထက်မြန်သည့် ရှာဖွေမှုကို ကျယ်ပြန့်စေပါ`,
  [k.CONGRATULATIONS]: `ဂုဏ်ပြုပါ`,
  [k.YOU_HAVE_UNREAD_CONVERSATION]: `သင့်တွင် ဖတ်မရသေးသည့် ဆွေးနွေးမှု ၀ ခု ရှိပါ`,
  [k.TRY_APPLYING_OTHER_FILTERS]: `အခြားဖီလ်တာများကို ကျင့်သုံးပါ`,
  [k.EDIT_FILTER]: `ဖီလ်တာကို ပြင်ဆင်ပါ`,
  [k.SAVE_FILTER]: `ဖီလ်တာကို သိမ်းပါ`,
  [k.ERROR_EDITING_FILTER]: `ဖီလ်တာကို ပြင်ဆင်နေစဉ် အမှားတက်ပါ`,
  [k.FILTER_CANNOT_BE_SAVED]: `ဖီလ်တာကို သိမ်းပါမရပါ`,
  [k.SORT_BY3]: `အမျိုးအစားအလိုက် စီရန်`,
  [k.CUSTOM]: `ကိုယ်ပိုင်`,
  [k.VIEW_AND_SELECT_FROM_ALL_STATU]: `အားလုံးသော အခြေအနေများမှ ကြည့်ပါမှုကို ရွေးချယ်ပါ`,
  [k.STATUS2]: `အခြေအနေ`,
  [k.CLOSEFILTER]: `closeFilter`,
  [k.CLEAR]: `ပြန်လည်ဖြေရှင်း`,
  [k.ALL_TYPES]: `အမျိုးအစားအားလုံး`,
  [k.SAVED_FILTERS]: `သိမ်းဆည်းထားသည့် ဖီလ်တာများ`,
  [k.QUICK_FILTERED_LISTS]: `အမြန်ဖီလ်တာလုပ်ထားသည့် စာရင်းများ`,
  [k.SUGGESTED]: `အကြံပြုထားသည်`,
  [k.ALL_CONVERSATIONS]: `အားလုံးသော ဆွေးနွေးမှုများ`,
  [k.ALL_CONVERSATIONS1]: `အားလုံးသော ဆွေးနွေးမှုများ`,
  [k.FAVOURITES]: `အကြိုက်ဆုံးများ`,
  [k.FAVOURITES1]: `အကြိုက်ဆုံးများ`,
  [k.STAR]: `ကြယ်`,
  [k.ACTIVEQUICKFILTER]: `activeQuickFilter`,
  [k.DEFAULTQUICKFILTER]: `defaultQuickFilter`,
  [k.BACKARROW]: `backArrow`,
  [k.CHANGE]: `ပြောင်းလဲ`,
  [k.CONVERSATION_TYPE_NOT_FOUND]: `ဆွေးနွေးမှုအမျိုးအစား တွေ့ရှိမရပါ`,
  [k.ALL_PROCESSES]: `အားလုံးသော လုပ်ငန်းများ`,
  [k.ALL_TASKS]: `အားလုံးသော တာဝန်များ`,
  [k.ALL_APPROVALS]: `အားလုံးသော အတည်ပြုမှုများ`,
  [k.SEARCH_CONVERSATION]: `ဆွေးနွေးမှုကို ရှာပါ`,
  [k.ADD_A_DEPARTMENT]: `ဌာနတစ်ခုကို ထပ်မံပါ`,
  [k.SEARCH_FOR_DEPARTMENTS]: `ဌာနများကို ရှာပါ`,
  [k.NO_DEPARTMENT]: `ဌာနမရှိပါ`,
  [k.CREATE_NEW_DEPARTMENT]: `ဌာနသစ်တစ်ခုကို ဖန်တီးပါ`,
  [k.ENTER_YOUR_DEPARTMENT]: `သင့်ဌာနကို ထည့်ပါ`,
  [k.OBJECT1]: `အရာ`,
  [k.CLONE1]: `ကူးပြောင်း`,
  [k.ORGANISE]: `စီစဉ်`,
  [k.CREATE_NEW_FOLDER]: `ဖိုလ်သစ်တစ်ခုကို ဖန်တီးပါ`,
  [k.NEW_FOLDER]: `ဖိုလ်သစ်`,
  [k.MEDIUM]: `အလယ်`,
  [k.MOVE_HERE]: `ဒီနေရာသို့ ပြောင်းပါ`,
  [k.ALL_ORG_FILES]: `အားလုံးသော အဖွဲ့အစည်းဖိုင်များ`,
  [k.MY_DRIVE]: `ကျွန်ုပ်တို့ရဲ့ ဒရိုက်`,
  [k.V1]: `v`,
  [k.CURRENT_VERSION]: `လက်ရှိဗားရှင်`,
  [k.MAKE_CURRENT1]: `လက်ရှိဗားရှင်အဖြစ် ပြုပါ`,
  [k.VERSION_HISTORY]: `ဗားရှင်သမိုင်း`,
  [k.PIN]: `ကပ်`,
  [k.TO_ACTIVE_CONVERSATION]: `လုပ်ငန်းဆွေးနွေးမှုသို့`,
  [k.PIN1]: `ကပ်`,
  [k.PIN_TO_ACTIVE_CONVERSATION]: `လုပ်ငန်းဆွေးနွေးမှုသို့ ကပ်`,
  [k.ORGANISE1]: `စီစဉ်`,
  [k.TRASH]: `ကြာချိန်`,
  [k.SEE_RELATED_CONVERSATIONS]: `ဆက်စပ်နေသည့် ဆွေးနွေးမှုများကို ကြည့်ပါ`,
  [k.FILE_NAME]: `ဖိုင်နာမည်`,
  [k.SIZE]: `အရွယ်`,
  [k.LAST_MODIFIED]: `နောက်ဆုံးပြင်ဆင်သည့်နေ့`,
  [k.SENT_THIS_MESSAGE_FROM]: `ဤစာတိုကို မှတ်ပုံတင်သည့်နေရာမှ`,
  [k.THREAD]: `သီးရိုက်`,
  [k.DUE_ON]: `ပြီးဆုံးရန်နေ့`,
  [k.UPDATED1]: `ပြင်ဆင်ပြီ`,
  [k.TITLE_TO]: `ခေါင်းစဉ်သို့`,
  [k.FROM1]: `မှ`,
  [k.ADDED]: `ထပ်မံပါ`,
  [k.THE]: `ဤ`,
  [k.INVITED]: `ဖိတ်ကြားပါ`,
  [k.TO_THE_CHATROOM]: `ဆွေးနွေးခန်းသို့`,
  [k.JOINED_THE_CONVERSATION]: `ဆွေးနွေးမှုသို့ ပါဝင်ပါ`,
  [k.TODAY]: `ယနေ့`,
  [k.LOADMORE]: `ပိုမိုတင်ပါ`,
  [k.LOADING_MORE_CONVERSATIONS]: `ပိုမိုဆွေးနွေးမှုများ တင်ပါ . . .`,
  [k.SIGNATORIES]: `လက်မှတ်ရေးထိုးသူများ`,
  [k._40]: `@`,
  [k.MESSAGEWITHMENTION]: `ဖော်ပြချက်ပါသည့် စာတို`,
  [k.MESSAGEWITHOUTMENTION]: `ဖော်ပြချက်မပါသည့် စာတို`,
  [k.REPLY_AS_EMAIL]: `အီးမေးလ်အဖြစ် အဖြေပြန်`,
  [k.FORWARD_AS_EMAIL]: `အီးမေးလ်အဖြစ် ပြန်လည်ပို့`,
  [k.START1]: `စတင်`,
  [k.STEP_DISMISSED]: `အဆင့် ပယ်ဖျက်`,
  [k.UNDO]: `ပြန်လည်ဖြေ`,
  [k.HEY]: `ဟယ်`,
  [k.CAN_YOU_COMPLETE_THIS_STEP]: `, ဤအဆင့်ကို ပြီးစီးပါမလား?`,
  [k.DISMISS]: `ပယ်ဖျက်`,
  [k.CHECKLIST_FIELD_FILL]: `စာရင်းဖြည့်စွက်`,
  [k.YOU_CAN_ACCESS_THE_CONVERSATIO]: `သင့်သည် ပါဝင်သူတစ်ဦးက သင့်အား အခွင့်ပြုပေးပြီးနောက် ဆွေးနွေးမှုကို အခွင့်ရရှိပါမည်`,
  [k.REQUEST_SENT]: `တောင်းဆိုမှု ပို့ပါ`,
  [k.REQUEST_ACCESS]: `အခွင့်ပြုချက် တောင်းဆို`,
  [k.THANK_YOU_FOR_YOUR_INTEREST]: `သင့်တို့၏ စိတ်ဝင်စားမှုကို ကျေးဇူးပြုပါ`,
  [k.OUR_SALES_TEAM_WILL_GET_IN_TOU]: `ကျွန်ုပ်တို့၏ ရောင်းအားတိုးမြှင့်ရေးအဖွဲ့သည် မကြာမီ ဆက်သွယ်ပါမည်`,
  [k.VALIDATING_YOUR_EMAIL]: `သင့်အီးမေးလ် အတည်ပြုနေပါ`,
  [k.SET_UP_NEW_ORG_ON_UNIFIZE]: `Unifize တွင် အဖွဲ့အစည်းသစ်တစ်ခု ဖွဲ့စည်းပါ`,
  [k.PLEASE_ENTER_YOUR_WORK_EMAIL_S]: `ကျွန်ုပ်တို့၏ အဖွဲ့အစည်း၏ ပုဂ္ဂလိက အခန်းကဏ္ဍသို့ ဆက်သွယ်ပါရန် သင့်အလုပ်အီးမေးလ် ထည့်ပါ`,
  [k.TRY_SIGNING_IN]: `အကြိုက်ဆုံးဖြစ်ပါ`,
  [k.BY_CLICKING_SIGN_UP_YOU_ACC]: `"Sign Up" ကို နှိပ်လိုက်သည့်အခါ ကျွန်ုပ်တို့၏`,
  [k.TERMS_OF_SERVICE]: `ဝန်ဆောင်မှုစည်းမျဉ်း`,
  [k.AND_OUR]: `, နှင့် ကျွန်ုပ်တို့၏`,
  [k.PRIVACY_POLICY]: `ပုဂ္ဂလိကဆိုင်ရာ မူဝါဒ`,
  [k.SENDING_VERIFICATION_MAIL]: `အတည်ပြုချက် အီးမေးလ် ပို့နေပါ`,
  [k.ERROR_SENDING_VERIFICATION_MAI]: `အတည်ပြုချက် အီးမေးလ် ပို့မှု အမှား`,
  [k.CLICK_HERE_TO_RESEND]: `ဤနေရာကို နှိပ်လိုက်ပါ ပြန်လည်ပို့ပါ`,
  [k.PLEASE_VERIFY_YOUR_EMAIL]: `သင့်အီးမေးလ် အတည်ပြုပါ`,
  [k.PLEASE_OPEN_YOUR]: `.
            သင့်အီးမေးလ် ဖွင့်ပါ နှင့် ကျွန်ုပ်တို့၏ အီးမေးလ်မှ ပို့လိုက်သည့် လင့်ကို နှိပ်လိုက်ပါ ကျွန်ုပ်တို့၏ အဖွဲ့အစည်း၏ ပုဂ္ဂလိက အခန်းကဏ္ဍသို့ ဆက်သွယ်ပါ`,
  [k.DIDN_T_GET_YOUR_EMAIL]: `သင့်အီးမေးလ် မရပါ?`,
  [k.ERROR_VERIFYING_YOUR_LINK]: `သင့်လင့် အတည်ပြုမှု အမှား`,
  [k.CHECK_YOUR_INBOX_FOR_THE_LATES]: `ကျွန်ုပ်တို့၏ နောက်ဆုံး အီးမေးလ် ကို သင့်အင်းဘောက်တွင် စစ်ပါ`,
  [k.ENTER_EMAIL_ADDRESS_TO_SIGN_UP]: `အီးမေးလ် လိပ်စာ ထည့်ပါ စာရင်းသွင်းရန်`,
  [k.YOU_WILL_RECEIVE_A_VERIFICATIO]: `သင့်သည် အတည်ပြုချက် အီးမေးလ် တစ်ခု နောက်ဆုံး နှစ်နာရီအတွင်း ရရှိပါမည်`,
  [k.DEPARTMENT]: `ဌာန`,
  [k.NUM_PENDING_TASKS]: "ဥပမာ၊ သင့်အလုပ်များ #num ရှိပါ",
  [k.TAKE_ME_THERE]: "ဒီမှာရှိပါ",
  [k.REFRESHED_CHART_DATA_NOT_AVAILABLE]:
    "အပြင်အဆင်ပြီး ချက်အားဖွင့်မရှိပါ။ ကျေးဇူးပြုပြီး နောက်ဆုံးအတွင်း ထိုးနောက်ပါမည်။",
  [k.AVAILABLE_CHARTS]: "ရရှိနိုင်ငံ့ချက်များ",
  [k.SEARCH_CHARTS]: "ချက်အားရှာပါ",
  [k.CHART_ALREADY_EXISTS_IN_DASHBOARD]:
    "ဒီချက်အား ဤနောက်ဆုံးအတွင်းတွင် ရှိပြီးပါပြီ",
  [k.FAILED_TO_LOAD_CHART]:
    "ချက်အားအခြေအနေကို တင်ပြီး အခြေအနေကို အလုပ်များကို ရှိပါမည်။ ကျေးဇူးပြုပြီး နောက်ဆုံးအတွင်း ထိုးနောက်ပါမည်",
  [k.FAILED_TO_LOAD_CHART_DATA]:
    "ချက်အားအခြေအနေကို တင်ပြီး အခြေအနေကို အလုပ်များကို ရှိပါမည်။ ကျေးဇူးပြုပြီး နောက်ဆုံးအတွင်း ထိုးနောက်ပါမည်",
  [k.NO_DATA_TO_DISPLAY]: "ရလဒ်များကို ရှာမရှိပါ",
  [k.DATE_UPDATED_SORT]: "နောက်ဆုံးအတွင်းကို အပြီးအလုပ်များကို ရှာပါ",
  [k.PRIORITY_SORT]: "အတည်ပြုများကို ရှာပါ",
  [k.STATUS_SORT]: "အခြေအနေကို ရှာပါ",
  [k.DATE_CREATED_SORT]: "နောက်ဆုံးအတွင်းကို အလုပ်များကို ရှာပါ",
  [k.DUE_DATE_SORT]: "အခြေအနေကို ရှာပါ",
  [k.RECENT_SORT]: "နောက်ဆုံးအတွင်းကို အပြီးအလုပ်များကို ရှာပါ",
  [k.STALE_SORT]: "နောက်ဆုံးအတွင်းကို အလုပ်များကို ရှာပါ",
  [k.CRITICAL_SORT]: "အတည်ပြုများကို ရှာပါ",
  [k.LOW_SORT]: "အတည်ပြုများကို ရှာပါ",
  [k.PENDING_SORT]: "အတည်ပြုများကို ရှာပါ",
  [k.COMPLETE_SORT]: "အတည်ပြုများကို ရှာပါ",
  [k.NEWEST_SORT]: "နောက်ဆုံးအတွင်းကို အပြီးအလုပ်များကို ရှာပါ",
  [k.OLDEST_SORT]: "နောက်ဆုံးအတွင်းကို အလုပ်များကို ရှာပါ",
  [k.DUE_SOON_SORT]: "အခြေအနေကို ရှာပါ",
  [k.DUE_LATER_SORT]: "အခြေအနေကို ရှာပါ",
  [k.ENTER_FILTER_NAME]: "ချက်အားအမည်ရှိပါ",
  [k.ENTER_GROUP_NAME]: "အုပ်စုပ်အမည်ရှိပါ",
  [k.ADD_OWNER]: "အားလုံးထည့်ပါ",
  [k.ADD_CONTACTS]: "အဆက်ပြန်ထည့်ပါ",
  [k.ADD_TO_GROUP]: "အုပ်စုပ်ထည့်ပါ",
  [k.APPROVAL_CAN_ONLY_BE_SIGNED_BY]: "အခြေအနေကို ရှာပါ",
  [k.ENTER_PASSWORD]: "စကားဝှက်ရှိပ်ပါ",
  [k.ENTER_COMMENT_HERE]: "ဤနေရာကို ရှာပါ",
  [k.RESENDING_OTP_TO_YOUR_EMAIL]: "အတည်ပြုချက်အားအီးမေးလ်ကို ထပ်ဖြင့်ပါ",
  [k.OTP_SENT_TO_EMAIL]: `အတည်ပြုချက်အားအီးမေးလ်ကို ထပ်ဖြင့်ပါ`,
  [k.FAILED_TO_SEND_OTP]: `အတည်ပြုချက်အားအီးမေးလ်ကို ထပ်ဖြင့်ပါ`,
  [k.ENTER_OTP]: `6-ဂဏန်းအတည်ပြုပါ`,
  [k.INVITE_RECIPIENTS_TO_UNIFIZE]: `သင့်အလုပ်များကို Unifize သို့ အားလုံးထည့်ပါ`,
  [k.SEARCH_PEOPLE_OR_GROUPS]: `လူအားသို့ အုပ်စုပ်ထည့်ပါ`,
  [k.SELECT_ROLE_FOR_NEW_PARTICIPANT]: `အလုပ်များကို အားလုံးထည့်ပါ`,
  [k.ALL_COMMENTS_AND_MESSAGES]: `အခြေအနေကို ရှာပါ`,
  [k.SEARCH_PICKLIST]: `အရွက်အားရှာပါ`,
  [k.ENTER_TITLE_FOR_NEW_ITEM]: `အသစ်ဖန်တီးအမည်ရှိပါ`,
  [k.MARK_AS_FAVOURITE]: `အသစ်ဖန်တီးအမည်ရှိပါ`,
  [k.REVISION_PERMISSIONS]: `အသစ်ဖန်တီးအမည်ရှိပါ`,
  [k.REVISIONS_CAN_BE_CREATED_BY]: `အသစ်ဖန်တီးအမည်ရှိပါ`,
  [k.REVISION_SETTINGS_NOT_CONFIGURED]: `အသစ်ဖန်တီးအမည်ရှိပါ`,
  [k.ENTER_YOUR_NAME]: `အသစ်ဖန်တီးအမည်ရှိပါ`,
  [k.NEW_PASSWORD]: `အသစ်ဖန်တီးအမည်ရှိပါ`,
  [k.GENERATE_PDF]: `အသစ်ဖန်တီးအမည်ရှိပါ`,
  [k.MS_ADMIN_NOT_ENABLED]: `အသစ်ဖန်တီးအမည်ရှိပါ`,
  [k.UNABLE_TO_CREATE_FILE]: `အသစ်ဖန်တီးအမည်ရှိပါ`,
  [k.MS_NOT_ENABLED]: `အသစ်ဖန်တီးအမည်ရှိပါ`,
  [k.BLANK]: `အသစ်ဖန်တီးအမည်ရှိပါ`,
  [k.NON_BLANK]: `အသစ်ဖန်တီးအမည်ရှိပါ`,
  [k.CANCEL_REQUEST]: `အသစ်ဖန်တီးအမည်ရှိပါ`,
  [k.CANCEL_APPROVAL]: `အသစ်ဖန်တီးအမည်ရှိပါ`,
  [k.OPEN]: `အသစ်ဖန်တီးအမည်ရှိပါ`,
  [k.ENTER_OPTIONAL_TITLE]: `အသစ်ဖန်တီးအမည်ရှိပါ`,
  [k.ENTER_ADDITIONAL_COMMENTS]: `အသစ်ဖန်တီးအမည်ရှိပါ`,
  [k.PENDING_INQUIRIES_FOR_STEAM]: `အသစ်ဖန်တီးအမည်ရှိပါ`,
  [k.GRAPHICAL_REPRESENTATION_THE_PENDING_ENQUIRIES]: `အသစ်ဖန်တီးအမည်ရှိပါ`,
  [k.SELECT_A_CHART_FOR]: `အသစ်ဖန်တီးအမည်ရှိပါ`,
  [k.COUNT_OF_CONVERSATIONS]: `အသစ်ဖန်တီးအမည်ရှိပါ`,
  [k.FOLLOWING_CHARTS_REPRESENT_CONVERSATIONS]: `အသစ်ဖန်တီးအမည်ရှိပါ`,
  [k.COUNT_OF_FORMS]: `အသစ်ဖန်တီးအမည်ရှိပါ`,
  [k.FOLLOWING_CHARTS_REPRESENT_FORMS]: `အသစ်ဖန်တီးအမည်ရှိပါ`,
  [k.SUM_OF_NUMERIC_FIELD]: `နှစ်ဂဏန်းတန်ဖိုးစု`,
  [k.USE_CHARTS_FOR_TOTALS]: `စုစုပေါင်းအသုံးပြုရန် ဤအချက်များကို အသုံးပြုပါ`,
  [k.TIME_TRENDS]: `အချိန်ကာလပုံသဏ္ဌာန်`,
  [k.USE_CHARTS_FOR_TRENDS]: `အချိန်ကာလအတွင်း အရေအတွက်များ သို့မဟုတ် တန်ဖိုးများ၏ ပုံသဏ္ဌာန်ကို ကြည့်ရန် ဤအချက်များကို အသုံးပြုပါ`,
  [k.COMPARISON_CHART]: `နှိုင်းယှဉ်ချက်`,
  [k.USE_CHARTS_FOR_COMPARISON]: `နှစ်ခု သို့မဟုတ် နှစ်ခုထက်ပိုသော အချက်အလက်စုများကို နှိုင်းယှဉ်ရန် ဤအချက်များကို အသုံးပြုပါ`,
  [k.PIE_CHART]: `ပိုင်ချက်`,
  [k.BAR_CHART]: `ဘာချက်`,
  [k.CHECKLIST_FIELDS]: `စစ်ဆေးစာရင်းများ`,
  [k.CONVERSATION_ATTRIBUTES]: `ဆွေးနွေးချက်အရည်အသွေး`,
  [k.REFRESHED_PROCESS_TABLE]: `ပြန်လည်ပြင်ဆင်ထားသော လုပ်ငန်းစာရင်း`,
  [k.NEW_PROCESS_TEMPLATE]: `အသစ်ဖန်တီးလုပ်ငန်းစာရင်း`,
  [k.IMPORT]: `တင်သွင်း`,
  [k.DISPLAY_NAME]: `ပြသမည်`,
  [k.EMAIL_ID]: `အီးမေးလ်အမည်`,
  [k.ROLE1]: `အခန်းကဏ္ဍ`,
  [k.DEPARTMENT]: `ဌာန`,
  [k.PHONE_NUMBER]: `ဖုန်းနံပါတ်`,
  [k.GROUPS]: `အဖွဲ့အစည်း`,
  [k.LAST_LOGGED_IN]: `နောက်ဆုံးအကြိမ်လက်ချက်ဝင်`,
  [k.DATE_INVITED]: `ဖိတ်ကြားသောနေ့`,
  [k.DATE_JOINED]: `ပူးပေါင်းသောနေ့`,
  [k.SEARCH_FOR_ANYTHING]: `အရာရာကို ရှာပါ`,
  [k.DATE_UPDATED]: `နောက်ဆုံးပြင်ဆင်သောနေ့`,
  [k.PRIORITY]: `အရေးပါများ`,
  [k.STATUS]: `အခြေအနေ`,
  [k.DATE_CREATED]: `ဖန်တီးသောနေ့`,
  [k.ALL_RELATED]: `အားလုံးပတ်သက်ဆက်နွယ်`,
  [k.OPEN_REVISIONS]: `ဖွင့်ထားသော ပြင်ဆင်မှုများ`,
  [k.EXPORT]: `ထုတ်ပို့`,
  [k.REMOVE_CHART_FROM_DASHBOARD]: `အချက်ပြပုံကို ဒါရှ်ဘုတ်မှ ဖယ်ရှား`,
  [k.REMOVE_CHART]: `အချက်ပြပုံကို ဖယ်ရှား`,
  [k.ARE_YOU_SURE_YOU_WANT_TO_REMOVE_CHART]: `ဤအချက်ပြပုံကို ဒါရှ်ဘုတ်မှ ဖယ်ရှားမည်မှန်ပါသလား`,
  [k.TOMORROW]: `မနက်ဖန်`,
  [k.YESTERDAY]: `မနေ့`,
  [k.ALL_EMBEDDED_RECORDS]: `အားလုံးပါဝင်သော မှတ်တမ်း`,
  [k.ERROR_MODIFYING_GROUP]: `အဖွဲ့အစည်းကို ပြင်ဆင်ရာတွင် အမှား`,
  [k.SEARCH_ORG]: `အဖွဲ့အစည်းကို ရှာပါ`,
  [k.ERROR_CREATING_CONVERSATION]: `ဆွေးနွေးချက်ကို ဖန်တီးရာတွင် အမှား`,
  [k.DISABLE_AND_CLEAR_ALL_DATA]: `ပိတ်ပင်ပြီး အားလုံးအချက်အလက်များကို ဖယ်ရှား`,
  [k.INVITE_SENT]: `ဖိတ်ကြားခဲ့သော`,
  [k.INVITE_CLICKED]: `ဖိတ်ကြားခဲ့သောကို နှိပ်ခဲ့`,
  [k.EMAIL_PASSWORD_REGISTRATION]: `အီးမေးလ်အမည် နှင့် စကားဝှက် မှတ်ပုံတင်`,
  [k.PHONE_DEPT_REGISTRATION]: `ဖုန်း နှင့် ဌာန မှတ်ပုံတင်`,
  [k.SIGNIN_MOBILE]: `ဖုန်းဖြင့် ဝင်ရောက်`,
  [k.OTP_SENT_TO_EMAIL]: "အတည်ပြုချက်အားအီးမေးလ်ကို ထပ်ဖြင့်ပါ",
  [k.FAILED_TO_SEND_OTP]: "အတည်ပြုချက်အားအီးမေးလ်ကို ထပ်ဖြင့်ပါ",
  [k.ENTER_OTP]: "6-ဂဏန်းအတည်ပြုပါ",
  [k.INVITE_RECIPIENTS_TO_UNIFIZE]:
    "သင့်အလုပ်များကို Unifize သို့ အားလုံးထည့်ပါ",
  [k.SEARCH_PEOPLE_OR_GROUPS]: "လူအားသို့ အုပ်စုပ်ထည့်ပါ",
  [k.SELECT_ROLE_FOR_NEW_PARTICIPANT]: "အလုပ်များကို အားလုံးထည့်ပါ",
  [k.ALL_COMMENTS_AND_MESSAGES]: "အခြေအနေကို ရှာပါ",
  [k.SEARCH_PICKLIST]: "အရွက်အားရှာပါ",
  [k.ENTER_TITLE_FOR_NEW_ITEM]: "အသစ်ဖန်တီးအမည်ရှိပါ",
  [k.MARK_AS_FAVOURITE]: "အသစ်ဖန်တီးအမည်ရှိပါ",
  [k.REVISION_PERMISSIONS]: "အသစ်ဖန်တီးအမည်ရှိပါ",
  [k.REVISIONS_CAN_BE_CREATED_BY]: "အသစ်ဖန်တီးအမည်ရှိပါ",
  [k.REVISION_SETTINGS_NOT_CONFIGURED]: "အသစ်ဖန်တီးအမည်ရှိပါ",
  [k.ENTER_YOUR_NAME]: "အသစ်ဖန်တီးအမည်ရှိပါ",
  [k.NEW_PASSWORD]: "အသစ်ဖန်တီးအမည်ရှိပါ",
  [k.GENERATE_PDF]: "အသစ်ဖန်တီးအမည်ရှိပါ",
  [k.MS_ADMIN_NOT_ENABLED]: "အသစ်ဖန်တီးအမည်ရှိပါ",
  [k.UNABLE_TO_CREATE_FILE]: "အသစ်ဖန်တီးအမည်ရှိပါ",
  [k.MS_NOT_ENABLED]: "အသစ်ဖန်တီးအမည်ရှိပါ",
  [k.BLANK]: "အသစ်ဖန်တီးအမည်ရှိပါ",
  [k.NON_BLANK]: "အသစ်ဖန်တီးအမည်ရှိပါ",
  [k.CANCEL_REQUEST]: "အသစ်ဖန်တီးအမည်ရှိပါ",
  [k.CANCEL_APPROVAL]: "အသစ်ဖန်တီးအမည်ရှိပါ",
  [k.OPEN]: "အသစ်ဖန်တီးအမည်ရှိပါ",
  [k.ENTER_OPTIONAL_TITLE]: "အသစ်ဖန်တီးအမည်ရှိပါ",
  [k.ENTER_ADDITIONAL_COMMENTS]: "အသစ်ဖန်တီးအမည်ရှိပါ",
  [k.PENDING_INQUIRIES_FOR_STEAM]: "အသစ်ဖန်တီးအမည်ရှိပါ",
  [k.GRAPHICAL_REPRESENTATION_THE_PENDING_ENQUIRIES]: "အသစ်ဖန်တီးအမည်ရှိပါ",
  [k.SELECT_A_CHART_FOR]: "အသစ်ဖန်တီးအမည်ရှိပါ",
  [k.COUNT_OF_CONVERSATIONS]: "အသစ်ဖန်တီးအမည်ရှိပါ",
  [k.FOLLOWING_CHARTS_REPRESENT_CONVERSATIONS]: "အသစ်ဖန်တီးအမည်ရှိပါ",
  [k.COUNT_OF_FORMS]: "အသစ်ဖန်တီးအမည်ရှိပါ",
  [k.FOLLOWING_CHARTS_REPRESENT_FORMS]: "အသစ်ဖန်တီးအမည်ရှိပါ",
  [k.SUM_OF_NUMERIC_FIELD]: "နှစ်ဂဏန်းတန်ဖိုးစု",
  [k.USE_CHARTS_FOR_TOTALS]: "စုစုပေါင်းအသုံးပြုရန် ဤအချက်များကို အသုံးပြုပါ",
  [k.TIME_TRENDS]: "အချိန်ကာလပုံသဏ္ဌာန်",
  [k.USE_CHARTS_FOR_TRENDS]:
    "အချိန်ကာလအတွင်း အရေအတွက်များ သို့မဟုတ် တန်ဖိုးများ၏ ပုံသဏ္ဌာန်ကို ကြည့်ရန် ဤအချက်များကို အသုံးပြုပါ",
  [k.COMPARISON_CHART]: "နှိုင်းယှဉ်ချက်",
  [k.USE_CHARTS_FOR_COMPARISON]:
    "နှစ်ခု သို့မဟုတ် နှစ်ခုထက်ပိုသော အချက်အလက်စုများကို နှိုင်းယှဉ်ရန် ဤအချက်များကို အသုံးပြုပါ",
  [k.PIE_CHART]: "ပိုင်ချက်",
  [k.BAR_CHART]: "ဘာချက်",
  [k.CHECKLIST_FIELDS]: "စစ်ဆေးစာရင်းများ",
  [k.CONVERSATION_ATTRIBUTES]: "ဆွေးနွေးချက်အရည်အသွေး",
  [k.REFRESHED_PROCESS_TABLE]: "ပြန်လည်ပြင်ဆင်ထားသော လုပ်ငန်းစာရင်း",
  [k.NEW_PROCESS_TEMPLATE]: "အသစ်ဖန်တီးလုပ်ငန်းစာရင်း",
  [k.IMPORT]: "တင်သွင်း",
  [k.DISPLAY_NAME]: "ပြသမည်",
  [k.EMAIL_ID]: "အီးမေးလ်အမည်",
  [k.ROLE1]: "အခန်းကဏ္ဍ",
  [k.DEPARTMENT]: "ဌာန",
  [k.PHONE_NUMBER]: "ဖုန်းနံပါတ်",
  [k.GROUPS]: "အဖွဲ့အစည်း",
  [k.LAST_LOGGED_IN]: "နောက်ဆုံးအကြိမ်လက်ချက်ဝင်",
  [k.DATE_INVITED]: "ဖိတ်ကြားသောနေ့",
  [k.DATE_JOINED]: "ပူးပေါင်းသောနေ့",
  [k.SEARCH_FOR_ANYTHING]: "အရာရာကို ရှာပါ",
  [k.DATE_UPDATED]: "နောက်ဆုံးပြင်ဆင်သောနေ့",
  [k.PRIORITY]: "အရေးပါများ",
  [k.STATUS]: "အခြေအနေ",
  [k.DATE_CREATED]: "ဖန်တီးသောနေ့",
  [k.ALL_RELATED]: "အားလုံးပတ်သက်ဆက်နွယ်",
  [k.OPEN_REVISIONS]: "ဖွင့်ထားသော ပြင်ဆင်မှုများ",
  [k.EXPORT]: "ထုတ်ပို့",
  [k.REMOVE_CHART_FROM_DASHBOARD]: "အချက်ပြပုံကို ဒါရှ်ဘုတ်မှ ဖယ်ရှား",
  [k.REMOVE_CHART]: "အချက်ပြပုံကို ဖယ်ရှား",
  [k.ARE_YOU_SURE_YOU_WANT_TO_REMOVE_CHART]:
    "ဤအချက်ပြပုံကို ဒါရှ်ဘုတ်မှ ဖယ်ရှားမည်မှန်ပါသလား",
  [k.TOMORROW]: "မနက်ဖန်",
  [k.YESTERDAY]: "မနေ့",
  [k.ALL_EMBEDDED_RECORDS]: "အားလုံးပါဝင်သော မှတ်တမ်း",
  [k.ERROR_MODIFYING_GROUP]: "အဖွဲ့အစည်းကို ပြင်ဆင်ရာတွင် အမှား",
  [k.SEARCH_ORG]: "အဖွဲ့အစည်းကို ရှာပါ",
  [k.ERROR_CREATING_CONVERSATION]: "ဆွေးနွေးချက်ကို ဖန်တီးရာတွင် အမှား",
  [k.DISABLE_AND_CLEAR_ALL_DATA]: "ပိတ်ပင်ပြီး အားလုံးအချက်အလက်များကို ဖယ်ရှား",
  [k.INVITE_SENT]: "ဖိတ်ကြားခဲ့သော",
  [k.INVITE_CLICKED]: "ဖိတ်ကြားခဲ့သောကို နှိပ်ခဲ့",
  [k.EMAIL_PASSWORD_REGISTRATION]: "အီးမေးလ်အမည် နှင့် စကားဝှက် မှတ်ပုံတင်",
  [k.PHONE_DEPT_REGISTRATION]: "ဖုန်း နှင့် ဌာန မှတ်ပုံတင်",
  [k.SIGNIN_MOBILE]: "ဖုန်းဖြင့် ဝင်ရောက်",
  [k.SIGNIN_WEB]: "ဝက်ဘ်ဖြင့် ဝင်ရောက်",
  [k.USE_THIS_SECTION_UPCOMING_TASKS]:
    "နောက်ဆုံးလုပ်ငန်းများကို ပြသရန် ဤအပိုင်းကို အသုံးပြုပါ",
  [k.HAS_USED_PLATFORM]: "ပလက်ဖောင်ကို အသုံးပြုခဲ့",
  [k.IS_PART_OF_GROUP]: "အဖွဲ့အစည်း၏ အစိတ်အပိုင်း",
  [k.IS_NOT_PART_OF_GROUP]: "အဖွဲ့အစည်း၏ အစိတ်အပိုင်း မဟုတ်",
  [k.UNTITLED_USER_SEGMENT]: "အမည်မပြုထားသော အသုံးပြုသူအုပ်စု",
  [k.SEARCH_DOMAINS]: "ဒိုမိန်းများကို ရှာပါ",
  [k.APPS]: "အက်ပ်များ",
  [k.APPS_DESCRIPTION]:
    "သင့်အကြိုက်ဆုံး အက်ပ်များနှင့် ပူးပေါင်းပြီး သင့်လုပ်ငန်းစဉ်ကို အားကောင်းစေပါ",
  [k.NO_APPS_FOUND]: "အက်ပ်များ တွေ့ရှိခဲ့သည်",
  [k.UNABLE_FETCH_INTEGRATIONS]: "ပူးပေါင်းမှုများကို ရယူနိုင်ခဲ့သည်",
  [k.UPDATE_INTEGRATION_FAILED]: "ပူးပေါင်းမှုကို ပြင်ဆင်ရာတွင် အမှား",
  [k.DISCONNECT_INTEGRATION_FAILED]: "ပူးပေါင်းမှုကို ဖယ်ရှားရာတွ် အမှား",
  [k.ENTER_TEXT]: "စာသားရိုက်ပါ",
  [k.ENTER_NUMBER]: "နံပါတ်ရိုက်ပါ",
  [k.NEW_FORM_TEMPLATE]: "အသစ်ဖန်တီးဖောင်စာရင်း",
  [k.SELECT_CHECKLIST_FIELD]: "စစ်ဆေးစာရင်းများကို ရွေးချယ်",
  [k.ENTER_CONVERSATION_TITLE]: "ဆွေးနွေးချက်အမည်ရိုက်ပါ",
  [k.TURN_OFF_REMINDERS_CONTENT]: "အမှတ်ရန်များကို ပိတ်ပင်မည်မှန်ပါသလား",
  [k.ENTER_LABEL]: "အမည်ရိုက်ပါ",
  [k.THIS_WILL_BE_X_AXIS_SERIES]: "ဤသည် x-ဝင်ရိုးအုပ်စုဖြစ်ပါ",
  [k.UNTITLED_SERIES]: "အမည်မပြုထားသော အုပ်စု",
  [k.AREA]: "ဧရိယာ",
  [k.RATE]: "နှုန်း",
  [k.LINE]: "လိုင်",
  [k.ENTER_TRENDLINE_LABEL]: "ပုံသဏ္ဌာန်အမည်ရိုက်ပါ",
  [k.USE_CHARTS_FOR_COMPARISON]:
    "နှစ်ခု သို့မဟုတ် နှစ်ခုထက်ပိုသော အချက်အလက်စုများကို နှိုင်းယှဉ်ရန် ဤအချက်များကို အသုံးပြုပါ",
  [k.PIE_CHART]: "ပိုင်ချက်",
  [k.BAR_CHART]: "ဘာချက်",
  [k.CHECKLIST_FIELDS]: "စစ်ဆေးစာရင်းများ",
  [k.CONVERSATION_ATTRIBUTES]: "ဆွေးနွေးချက်အရည်အသွေး",
  [k.REFRESHED_PROCESS_TABLE]: "ပြန်လည်ပြင်ဆင်ထားသော လုပ်ငန်းစာရင်း",
  [k.NEW_PROCESS_TEMPLATE]: "အသစ်ဖန်တီးလုပ်ငန်းစာရင်း",
  [k.IMPORT]: "တင်သွင်း",
  [k.DISPLAY_NAME]: "ပြသမည်",
  [k.EMAIL_ID]: "အီးမေးလ်အမည်",
  [k.ROLE1]: "အဖွဲ့အစည်း",
  [k.DEPARTMENT]: "ဌာန",
  [k.PHONE_NUMBER]: "ဖုန်းနံပါတ်",
  [k.GROUPS]: "အဖွဲ့အစည်း",
  [k.LAST_LOGGED_IN]: "နောက်ဆုံးဝင်ရောက်သည်",
  [k.DATE_INVITED]: "ဖိတ်ကြားခဲ့သောနှစ်ရက်",
  [k.DATE_JOINED]: "နှစ်ရက်တွင် ဝင်ရောက်ခဲ့သည်",
  [k.SEARCH_FOR_ANYTHING]: "အချက်အလက်ရှာပါ",
  [k.DATE_UPDATED]: "ပြင်ဆင်ထားသောနှစ်ရက်",
  [k.PRIORITY]: "အရေအတွက်",
  [k.STATUS]: "အခြေအနေ",
  [k.DATE_CREATED]: "ဖန်တီးထားသောနှစ်ရက်",
  [k.ALL_RELATED]: "အကုန်လုံးကို ဆက်စပ်ထားသည်",
  [k.OPEN_REVISIONS]: "ပြင်ဆင်ထားသောအကြောင်းအရာ",
  [k.EXPORT]: "အကူအညီ",
  [k.REMOVE_CHART_FROM_DASHBOARD]: "ချက်အားကို ဒိုင်ခြောက်မှ ဖယ်ရှားရန်",
  [k.REMOVE_CHART]: "ချက်အားကို ဖယ်ရှားရန်",
  [k.ARE_YOU_SURE_YOU_WANT_TO_REMOVE_CHART]:
    "ဤချက်အား ဒိုင်ခြောက်မှ ဖယ်ရှားရန် သင့်သဘောထားသည်ကို သိချို့ပါသလား",
  [k.TOMORROW]: "မနက်နှစ်ရက်",
  [k.YESTERDAY]: "မနက်နှစ်ရက်",
  [k.ALL_EMBEDDED_RECORDS]: "အကုန်လုံးအတွင်းပါသောမှတ်တမ်းများ",
  [k.ERROR_MODIFYING_GROUP]: "အဖွဲ့အစည်းကို ပြင်ဆင်ရာတွင် အမှား",
  [k.SEARCH_ORG]: "အဖွဲ့အစည်းရှာပါ",
  [k.ERROR_CREATING_CONVERSATION]: "ဆွေးနွေးချက်ကို ဖန်တီးရာတွင် အမှား",
  [k.DISABLE_AND_CLEAR_ALL_DATA]:
    "အကုန်လုံးအချက်အလက်များကို ပိတ်ပင်ပြီး ဖျက်ပါ",
  [k.INVITE_SENT]: "ဖိတ်ကြားခဲ့သည်",
  [k.INVITE_CLICKED]: "ဖိတ်ကြားခဲ့သောကို နှိပ်ခဲ့သည်",
  [k.EMAIL_PASSWORD_REGISTRATION]: "အီးမေးလ်အမည်နှင့် စကားဝှက်မှတ်ပုံတင်ခြင်း",
  [k.PHONE_DEPT_REGISTRATION]: "ဖုန်းနံပါတ်နှင့် ဌာနမှတ်ပုံတင်ခြင်း",
  [k.SIGNIN_MOBILE]: "ဖုန်းဖြင့် ဝင်ရောက်",
  [k.SIGNIN_WEB]: "ဝက်ဘ်ဖြင့် ဝင်ရောက်",
  [k.USE_THIS_SECTION_UPCOMING_TASKS]:
    "နောက်လာမည့်တာဝန်များကို ပြသရန် ဤအပိုင်းကို အသုံးပြုပါ",
  [k.HAS_USED_PLATFORM]: "ပလက်ဖောင်းကို အသုံးပြုခဲ့သည်",
  [k.IS_PART_OF_GROUP]: "အဖွဲ့အစည်း၏ အစိတ်အပိုင်းဖြစ်သည်",
  [k.IS_NOT_PART_OF_GROUP]: "အဖွဲ့အစည်း၏ အစိတ်အပိုင်းမဟုတ်",
  [k.UNTITLED_USER_SEGMENT]: "အမည်မပြုထားသော အသုံးပြုသူအုပ်စု",
  [k.SEARCH_DOMAINS]: "ဒိုမိန်းများရှာပါ",
  [k.APPS]: "အက်ပ်များ",
  [k.APPS_DESCRIPTION]:
    "သင့်အကြိုက်ဆုံး အက်ပ်များနှင့် ပူးပေါင်းပြီး သင့်လုပ်ငန်းစဉ်ကို အားကောင်းစေပါ",
  [k.NO_APPS_FOUND]: "အက်ပ်များ တွေ့ရှိခဲ့သည်",
  [k.UNABLE_FETCH_INTEGRATIONS]: "ပူးပေါင်းမှုများကို ရယူနိုင်ခဲ့သည်",
  [k.UPDATE_INTEGRATION_FAILED]: "ပူးပေါင်းမှုကို ပြင်ဆင်ရာတွင် အမှား",
  [k.DISCONNECT_INTEGRATION_FAILED]: "ပူးပေါင်းမှုကို ဖယ်ရှားရာတွင် အမှား",
  [k.ENTER_TEXT]: "စာသားရိုက်ပါ",
  [k.ENTER_NUMBER]: "နံပါတ်ရိုက်ပါ",
  [k.NEW_FORM_TEMPLATE]: "အသစ်ဖန်တီးဖောင်စာရင်း",
  [k.SELECT_CHECKLIST_FIELD]: "စစ်ဆေးစာရင်းများကို ရွေးချယ်",
  [k.ENTER_CONVERSATION_TITLE]: "ဆွေးနွေးချက်အမည်ရိုက်ပါ",
  [k.TURN_OFF_REMINDERS_CONTENT]: "အမှတ်ရန်များကို ပိတ်ပင်မည်မှန်ပါသလား",
  [k.ENTER_LABEL]: "အမည်ရိုက်ပါ",
  [k.THIS_WILL_BE_X_AXIS_SERIES]: "ဤသည် x-ဝင်ရိုးအုပ်စုဖြစ်ပါ",
  [k.UNTITLED_SERIES]: "အမည်မပြုထားသော အုပ်စု",
  [k.AREA]: "ဧရိယာ",
  [k.RATE]: "နှုန်း",
  [k.LINE]: "လိုင်",
  [k.ENTER_TRENDLINE_LABEL]: "ပုံသဏ္ဌာန်အမည်ရိုက်ပါ",
  [k.USE_CHARTS_FOR_COMPARISON]:
    "နှစ်ခု သို့မဟုတ် နှစ်ခုထက်ပိုသော အချက်အလက်စုများကို နှိုင်းယှဉ်ရန် ဤအချက်များကို အသုံးပြုပါ",
  [k.PIE_CHART]: "ပိုင်ချက်",
  [k.BAR_CHART]: "ဘာချက်",
  [k.CHECKLIST_FIELDS]: "စစ်ဆေးစာရင်းများ",
  [k.CONVERSATION_ATTRIBUTES]: "ဆွေးနွေးချက်အရည်အသွေး",
  [k.REFRESHED_PROCESS_TABLE]: "ပြန်လည်ပြင်ဆင်ထားသော လုပ်ငန်းစာရင်း",
  [k.NEW_PROCESS_TEMPLATE]: "အသစ်ဖန်တီးလုပ်ငန်းစာရင်း",
  [k.IMPORT]: "တင်သွင်း",
  [k.DISPLAY_NAME]: "ပြသမည်",
  [k.EMAIL_ID]: "အီးမေးလ်အမည်",
  [k.ROLE1]: "အဖွဲ့အစည်း",
  [k.DEPARTMENT]: "ဌာန",
  [k.PHONE_NUMBER]: "ဖုန်းနံပါတ်",
  [k.GROUPS]: "အဖွဲ့အစည်း",
  [k.LAST_LOGGED_IN]: "နောက်ဆုံးဝင်ရောက်သည်",
  [k.DATE_INVITED]: "ဖိတ်ကြားခဲ့သောနှစ်ရက်",
  [k.DATE_JOINED]: "နှစ်ရက်တွင် ဝင်ရောက်ခဲ့သည်",
  [k.SEARCH_FOR_ANYTHING]: "အချက်အလက်ရှာပါ",
  [k.DATE_UPDATED]: "ပြင်ဆင်ထားသောနှစ်ရက်",
  [k.PRIORITY]: "အရေအတွက်",
  [k.STATUS]: "အခြေအနေ",
  [k.DATE_CREATED]: "ဖန်တီးထားသောနှစ်ရက်",
  [k.ALL_RELATED]: "အကုန်လုံးကို ဆက်စပ်ထားသည်",
  [k.OPEN_REVISIONS]: "ပြင်ဆင်ထားသောအကြောင်းအရာ",
  [k.EXPORT]: "အကူအညီ",
  [k.REMOVE_CHART_FROM_DASHBOARD]: "ချက်အားကို ဒိုင်ခြောက်မှ ဖယ်ရှားရန်",
  [k.REMOVE_CHART]: "ချက်အားကို ဖယ်ရှားရန်",
  [k.ARE_YOU_SURE_YOU_WANT_TO_REMOVE_CHART]:
    "ဤချက်အား ဒိုင်ခြောက်မှ ဖယ်ရှားရန် သင့်သဘောထားသည်ကို သိချို့ပါသလား",
  [k.TOMORROW]: "မနက်နှစ်ရက်",
  [k.YESTERDAY]: "မနက်နှစ်ရက်",
  [k.ALL_EMBEDDED_RECORDS]: "အကုန်လုံးအတွင်းပါသောမှတ်တမ်းများ",
  [k.ERROR_MODIFYING_GROUP]: "အဖွဲ့အစည်းကို ပြင်ဆင်ရာတွင် အမှား",
  [k.SEARCH_ORG]: "အဖွဲ့အစည်းရှာပါ",
  [k.ERROR_CREATING_CONVERSATION]: "ဆွေးနွေးချက်ကို ဖန်တီးရာတွင် အမှား",
  [k.DISABLE_AND_CLEAR_ALL_DATA]:
    "အကုန်လုံးအချက်အလက်များကို ပိတ်ပင်ပြီး ဖျက်ပါ",
  [k.INVITE_SENT]: "ဖိတ်ကြားခဲ့သည်",
  [k.INVITE_CLICKED]: "ဖိတ်ကြားခဲ့သောကို နှိပ်ခဲ့သည်",
  [k.EMAIL_PASSWORD_REGISTRATION]: "အီးမေးလ်အမည်နှင့် စကားဝှက်မှတ်ပုံတင်ခြင်း",
  [k.PHONE_DEPT_REGISTRATION]: "ဖုန်းနံပါတ်နှင့် ဌာနမှတ်ပုံတင်ခြင်း",
  [k.SIGNIN_MOBILE]: "ဖုန်းဖြင့် ဝင်ရောက်",
  [k.SIGNIN_WEB]: "ဝက်ဘ်ဖြင့် ဝင်ရောက်",
  [k.USE_THIS_SECTION_UPCOMING_TASKS]:
    "နောက်လာမည့်တာဝန်များကို ပြသရန် ဤအပိုင်းကို အသုံးပြုပါ",
  [k.HAS_USED_PLATFORM]: "ပလက်ဖောင်းကို အသုံးပြုခဲ့သည်",
  [k.IS_PART_OF_GROUP]: "အဖွဲ့အစည်း၏ အစိတ်အပိုင်းဖြစ်သည်",
  [k.IS_NOT_PART_OF_GROUP]: "အဖွဲ့အစည်း၏ အစိတ်အပိုင်းမဟုတ်",
  [k.UNTITLED_USER_SEGMENT]: "အမည်မပြုထားသော အသုံးပြုသူအုပ်စု",
  [k.SEARCH_DOMAINS]: "ဒိုမိန်းများရှာပါ",
  [k.APPS]: "အက်ပ်များ",
  [k.APPS_DESCRIPTION]:
    "သင့်အကြိုက်ဆုံး အက်ပ်များနှင့် ပူးပေါင်းပြီး သင့်လုပ်ငန်းစဉ်ကို အားကောင်းစေပါ",
  [k.NO_APPS_FOUND]: "အက်ပ်များ တွေ့ရှိခဲ့သည်",
  [k.UNABLE_FETCH_INTEGRATIONS]: "ပူးပေါင်းမှုများကို ရယူနိုင်ခဲ့သည်",
  [k.UPDATE_INTEGRATION_FAILED]: "ပူးပေါင်းမှုကို ပြင်ဆင်ရာတွင် အမှား",
  [k.DISCONNECT_INTEGRATION_FAILED]: "ပူးပေါင်းမှုကို ဖယ်ရှားရာတွင် အမှား",
  [k.ENTER_TEXT]: "စာသားရိုက်ပါ",
  [k.ENTER_NUMBER]: "နံပါတ်ရိုက်ပါ",
  [k.NEW_FORM_TEMPLATE]: "အသစ်ဖန်တီးဖောင်စာရင်း",
  [k.SELECT_CHECKLIST_FIELD]: "စစ်ဆေးစာရင်းများကို ရွေးချယ်",
  [k.ENTER_CONVERSATION_TITLE]: "ဆွေးနွေးချက်အမည်ရိုက်ပါ",
  [k.TURN_OFF_REMINDERS_CONTENT]: "အမှတ်ရန်များကို ပိတ်ပင်မည်မှန်ပါသလား",
  [k.ENTER_LABEL]: "အမည်ရိုက်ပါ",
  [k.THIS_WILL_BE_X_AXIS_SERIES]: "ဤသည် x-ဝင်ရိုးအုပ်စုဖြစ်ပါ",
  [k.UNTITLED_SERIES]: "အမည်မပြုထားသော အုပ်စု",
  [k.AREA]: "ဧရိယာ",
  [k.RATE]: "နှုန်း",
  [k.LINE]: "လိုင်",
  [k.ENTER_TRENDLINE_LABEL]: "ပုံသဏ္ဌာန်အမည်ရိုက်ပါ",
  [k.USE_CHARTS_FOR_COMPARISON]:
    "နှစ်ခု သို့မဟုတ် နှစ်ခုထက်ပိုသော အချက်အလက်စုများကို နှိုင်းယှဉ်ရန် ဤအချက်များကို အသုံးပြုပါ",
  [k.PIE_CHART]: "ပိုင်ချက်",
  [k.BAR_CHART]: "ဘာချက်",
  [k.CHECKLIST_FIELDS]: "စစ်ဆေးစာရင်းများ",
  [k.CONVERSATION_ATTRIBUTES]: "ဆွေးနွေးချက်အရည်အသွေး",
  [k.REFRESHED_PROCESS_TABLE]: "ပြန်လည်ပြင်ဆင်ထားသော လုပ်ငန်းစာရင်း",
  [k.NEW_PROCESS_TEMPLATE]: "အသစ်ဖန်တီးလုပ်ငန်းစာရင်း",
  [k.IMPORT]: "တင်သွင်း",
  [k.DISPLAY_NAME]: "ပြသမည်",
  [k.EMAIL_ID]: "အီးမေးလ်အမည်",
  [k.ROLE1]: "အဖွဲ့အစည်း",
  [k.DEPARTMENT]: "ဌာန",
  [k.PHONE_NUMBER]: "ဖုန်းနံပါတ်",
  [k.GROUPS]: "အဖွဲ့အစည်း",
  [k.LAST_LOGGED_IN]: "နောက်ဆုံးဝင်ရောက်သည်",
  [k.DATE_INVITED]: "ဖိတ်ကြားခဲ့သောနှစ်ရက်",
  [k.DATE_JOINED]: "နှစ်ရက်တွင် ဝင်ရောက်ခဲ့သည်",
  [k.SEARCH_FOR_ANYTHING]: "အချက်အလက်ရှာပါ",
  [k.DATE_UPDATED]: "ပြင်ဆင်ထားသောနှစ်ရက်",
  [k.PRIORITY]: "အရေအတွက်",
  [k.STATUS]: "အခြေအနေ",
  [k.DATE_CREATED]: "ဖန်တီးထားသောနှစ်ရက်",
  [k.ALL_RELATED]: "အကုန်လုံးကို ဆက်စပ်ထားသည်",
  [k.OPEN_REVISIONS]: "ပြင်ဆင်ထားသောအကြောင်းအရာ",
  [k.EXPORT]: "အကူအညီ",
  [k.REMOVE_CHART_FROM_DASHBOARD]: "ချက်အားကို ဒိုင်ခြောက်မှ ဖယ်ရှားရန်",
  [k.ENTER_TRENDLINE_LABEL]: "တက်န်းလိုင်းအမည်ရိုက်ပါ",
  [k.TOTAL_OF_NUMERICAL_FIELD]: "သင်္ချာပုံစံဖီလ်၏ စုစုပေါင်း",
  [k.AVERAGE_OF_NUMERICAL_FIELD]: "သင်္ချာပုံစံဖီလ်၏ ပျမ်းမ",
  [k.NESTED_FIELDS_DESCRIPTION]:
    "အတွင်းပါဖီလ်များအတွက် ဖောင်/လိုင်းဖီလ်အတွင်း ပထမဦးစားပေါင်းပြီး ထို့နောက် ရလဒ်များကို ပျမ်းမယူပါ",
  [k.RECORD_COUNT]: "မှတ်တမ်းပေါင်း",
  [k.SUM]: "စုစုပေါင်း",
  [k.AVERAGE]: "ပျမ်းမ",
  [k.AVERAGE_OF_SUM]: "စုစုပေါင်း၏ ပျမ်းမ",
  [k.ALL_RECORDS_FILTER]: "အကုန်လုံးမှတ်တမ်းများ ဖီလ်တာ",
  [k.ALL_RECORDS_FILTER_DESCRIPTION]:
    " - ဤအရာကို ပိတ်ထားသည် (အများဆုံး): အဓိကလုပ်ငန်းမှတ်တမ်းများသာ ဖီလ်တာမည် - အများဆုံးပြင်ပလည်း တစ်ခုတည်းသောအဖြစ်များပါ - ဤအရာကို ဖွင့်ထားသည်: အကုန်လုံးမှတ်တမ်းများကို ဖီလ်တာမည် - သင့်အဖြစ်များကို ပြသပါ",
  [k.SEARCH_TYPE]: "ရှာဖွေနည်း",
  [k.SUBTITLE]: "အမည်ပြောင်",
  [k.YOU_HAVE_PENDING_TASKS]: "ဥပမာ သင့်တွင် လုပ်ငန်းများ ကြန့်ကြာနေသည်",
  [k.YOU_HAVE_NUM_PENDING_TASKS]:
    "ဥပမာ သင့်တွင် #num လုပ်ငန်းများ ကြန့်ကြာနေသည်",
  [k.SEARCH_TILES]: "ရှာဖွေတိုင်း",
  [k.SELECT_ITEMS]: "အရာများကို ရွေးပါ",
  [k.WRONG_PASSWORD_MESSAGE]:
    "(အနည်းဆုံး 8 လုံးရှိရပြီး 1 လုံးသေး 1 လုံးကြီး 1 လုံးနံပါတ်)",
  [k.CONFIRM_PASSWORD]: "စကားဝှက်ကို အတည်ပြုပါ",
  [k.UNTITLED]: "အမည်မပြုထားသော",
  [k.CREATE_REPORT_TILE]: "အစီရင်ခံစာတိုင်း ဖန်တီးပါ",
  [k.TILE_TITLE]: "တိုင်းအမည်",
  [k.SELECT_REPORT]: "အစီရင်ခံစာ ရွေးပါ",
  [k.ADD_REPORT]: "အစီရင်ခံစာ ထပ်မံပါ",
  [k.SEARCH_ROLES]: "အခန်းကဏ္ဍ ရှာဖွေပါ",
  [k.SEARCH_DEPARTMENTS]: "ဌာနများ ရှာဖွေပါ",
  [k.SEARCH_GROUPS]: "အဖွဲ့အစည်းများ ရှာဖွေပါ",
  [k.NO_FILTERS_APPLIED]: "ဖီလ်တာများ မပြုလုပ်သေး",
  [k.A_FEW_SECONDS_AGO]: "အချိန်နည်းနည်းကြာပြီ",
  [k.A_FEW_MINUTES_AGO]: "အချိန်နည်းနည်းကြာပြီ",
  [k.ABOUT]: "အကြောင်း",
  [k.SERIES]: "အဖွဲ့အစည်း",
  [k.CHART]: "အချက်အလက်ပြမှု",
  [k.ENABLED]: "ဖွင့်ထားသည်",
  [k.DISABLED]: "ပိတ်ထားသည်",
  [k.PLEASE_CONTACT_SUPPORT_TO_ADD_REMOVE_DOMAINS]:
    "အဖွဲ့အစည်းများကို ဖြည့်စွက်ရန် သို့မဟုတ် ဖယ်ရှားရန် အကူအညီကို ဆက်သွယ်ပါ",
  [k.MESSAGES]: "မှာကြောင်း",
  [k.ENTER_TRENDLINE_LABEL]: "တက်န်းလိုင်းအမည်ရိုက်ပါ",
  [k.TOTAL_OF_NUMERICAL_FIELD]: "သင်္ချာပုံစံဖီလ်၏ စုစုပေါင်း",
  [k.AVERAGE_OF_NUMERICAL_FIELD]: "သင်္ချာပုံစံဖီလ်၏ ပျမ်းမ",
  [k.NESTED_FIELDS_DESCRIPTION]:
    "အတွင်းပါဖီလ်များအတွက် ဖောင်/လိုင်းဖီလ်အတွင်း ပထမဦးစားပေါင်းပြီး ထို့နောက် ရလဒ်များကို ပျမ်းမယူပါ",
  [k.RECORD_COUNT]: "မှတ်တမ်းပေါင်း",
  [k.SUM]: "စုစုပေါင်း",
  [k.AVERAGE]: "ပျမ်းမ",
  [k.AVERAGE_OF_SUM]: "စုစုပေါင်း၏ ပျမ်းမ",
  [k.ALL_RECORDS_FILTER]: "အကုန်လုံးမှတ်တမ်းများ ဖီလ်တာ",
  [k.ALL_RECORDS_FILTER_DESCRIPTION]:
    " - ဤအရာကို ပိတ်ထားသည် (အများဆုံး): အဓိကလုပ်ငန်းမှတ်တမ်းများသာ ဖီလ်တာမည် - အများဆုံးပြင်ပလည်း တစ်ခုတည်းသောအဖြစ်များပါ - ဤအရာကို ဖွင့်ထားသည်: အကုန်လုံးမှတ်တမ်းများကို ဖီလ်တာမည် - သင့်အဖြစ်များကို ပြသပါ",
  [k.SEARCH_TYPE]: "ရှာဖွေနည်း",
  [k.SUBTITLE]: "အမည်ပြောင်",
  [k.YOU_HAVE_PENDING_TASKS]: "ဥပမာ သင့်တွင် လုပ်ငန်းများ ကြန့်ကြာနေသည်",
  [k.YOU_HAVE_NUM_PENDING_TASKS]:
    "ဥပမာ သင့်တွင် #num လုပ်ငန်းများ ကြန့်ကြာနေသည်",
  [k.SEARCH_TILES]: "ရှာဖွေတိုင်း",
  [k.SELECT_ITEMS]: "အရာများကို ရွေးပါ",
  [k.WRONG_PASSWORD_MESSAGE]:
    "(အနည်းဆုံး 8 လုံးရှိရပြီး 1 လုံးသေး 1 လုံးကြီး 1 လုံးနံပါတ်)",
  [k.CONFIRM_PASSWORD]: "စကားဝှက်ကို အတည်ပြုပါ",
  [k.UNTITLED]: "အမည်မပြုထားသော",
  [k.CREATE_REPORT_TILE]: "အစီရင်ခံစာတိုင်း ဖန်တီးပါ",
  [k.TILE_TITLE]: "တိုင်းအမည်",
  [k.SELECT_REPORT]: "အစီရင်ခံစာ ရွေးပါ",
  [k.ADD_REPORT]: "အစီရင်ခံစာ ထပ်မံပါ",
  [k.SEARCH_ROLES]: "အခန်းကဏ္ဍ ရှာဖွေပါ",
  [k.SEARCH_DEPARTMENTS]: "ဌာနများ ရှာဖွေပါ",
  [k.SEARCH_GROUPS]: "အဖွဲ့အစည်းများ ရှာဖွေပါ",
  [k.NO_FILTERS_APPLIED]: "ဖီလ်တာများ မပြုလုပ်သေး",
  [k.A_FEW_SECONDS_AGO]: "အချိန်နည်းနည်းကြာပြီ",
  [k.A_FEW_MINUTES_AGO]: "အချိန်နည်းနည်းကြာပြီ",
  [k.ABOUT]: "အကြောင်း",
  [k.SERIES]: "အဖွဲ့အစည်း",
  [k.CHART]: "အချက်အလက်ပြမှု",
  [k.ENABLED]: "ဖွင့်ထားသည်",
  [k.DISABLED]: "ပိတ်ထားသည်",
  [k.PLEASE_CONTACT_SUPPORT_TO_ADD_REMOVE_DOMAINS]:
    "အဖွဲ့အစည်းများကို ဖြည့်စွက်ရန် သို့မဟုတ် ဖယ်ရှားရန် အကူအညီကို ဆက်သွယ်ပါ",
  [k.ENTER_TRENDLINE_LABEL]: "တက်န်းလိုင်းအမည်ရိုက်ပါ",
  [k.TOTAL_OF_NUMERICAL_FIELD]: "သင်္ချာပုံစံဖီလ်၏ စုစုပေါင်း",
  [k.AVERAGE_OF_NUMERICAL_FIELD]: "သင်္ချာပုံစံဖီလ်၏ ပျမ်းမ",
  [k.NESTED_FIELDS_DESCRIPTION]:
    "အတွင်းပါဖီလ်များအတွက် ဖောင်/လိုင်းဖီလ်အတွင်း ပထမဦးစားပေါင်းပြီး ထို့နောက် ရလဒ်များကို ပျမ်းမယူပါ",
  [k.RECORD_COUNT]: "မှတ်တမ်းပေါင်း",
  [k.SUM]: "စုစုပေါင်း",
  [k.AVERAGE]: "ပျမ်းမ",
  [k.AVERAGE_OF_SUM]: "စုစုပေါင်း၏ ပျမ်းမ",
  [k.ALL_RECORDS_FILTER]: "အကုန်လုံးမှတ်တမ်းများ ဖီလ်တာ",
  [k.ALL_RECORDS_FILTER_DESCRIPTION]:
    " - ဤအရာကို ပိတ်ထားသည် (အများဆုံး): အဓိကလုပ်ငန်းမှတ်တမ်းများသာ ဖီလ်တာမည် - အများဆုံးပြင်ပလည်း တစ်ခုတည်းသောအဖြစ်များပါ - ဤအရာကို ဖွင့်ထားသည်: အကုန်လုံးမှတ်တမ်းများကို ဖီလ်တာမည် - သင့်အဖြစ်များကို ပြသပါ",
  [k.SEARCH_TYPE]: "ရှာဖွေနည်း",
  [k.SUBTITLE]: "အမည်ပြောင်",
  [k.YOU_HAVE_PENDING_TASKS]: "ဥပမာ သင့်တွင် လုပ်ငန်းများ ကြန့်ကြာနေသည်",
  [k.YOU_HAVE_NUM_PENDING_TASKS]:
    "ဥပမာ သင့်တွင် #num လုပ်ငန်းများ ကြန့်ကြာနေသည်",
  [k.SEARCH_TILES]: "ရှာဖွေတိုင်း",
  [k.SELECT_ITEMS]: "အရာများကို ရွေးပါ",
  [k.WRONG_PASSWORD_MESSAGE]:
    "(အနည်းဆုံး 8 လုံးရှိရပြီး 1 လုံးသေး 1 လုံးကြီး 1 လုံးနံပါတ်)",
  [k.CONFIRM_PASSWORD]: "စကားဝှက်ကို အတည်ပြုပါ",
  [k.UNTITLED]: "အမည်မပြုထားသော",
  [k.CREATE_REPORT_TILE]: "အစီရင်ခံစာတိုင်း ဖန်တီးပါ",
  [k.TILE_TITLE]: "တိုင်းအမည်",
  [k.SELECT_REPORT]: "အစီရင်ခံစာ ရွေးပါ",
  [k.ADD_REPORT]: "အစီရင်ခံစာ ထပ်မံပါ",
  [k.SEARCH_ROLES]: "အခန်းကဏ္ဍ ရှာဖွေပါ",
  [k.SEARCH_DEPARTMENTS]: "ဌာနများ ရှာဖွေပါ",
  [k.SEARCH_GROUPS]: "အဖွဲ့အစည်းများ ရှာဖွေပါ",
  [k.NO_FILTERS_APPLIED]: "ဖီလ်တာများ မပြုလုပ်သေး",
  [k.A_FEW_SECONDS_AGO]: "အချိန်နည်းနည်းကြာပြီ",
  [k.A_FEW_MINUTES_AGO]: "အချိန်နည်းနည်းကြာပြီ",
  [k.ABOUT]: "အကြောင်း",
  [k.SERIES]: "အဖွဲ့အစည်း",
  [k.CHART]: "အချက်အလက်ပြမှု",
  [k.ENABLED]: "ဖွင့်ထားသည်",
  [k.DISABLED]: "ပိတ်ထားသည်",
  [k.PLEASE_CONTACT_SUPPORT_TO_ADD_REMOVE_DOMAINS]:
    "အဖွဲ့အစည်းများကို ဖြည့်စွက်ရန် သို့မဟုတ် ဖယ်ရှားရန် အကူအညီကို ဆက်သွယ်ပါ",
  [k.MESSAGES]: "မှာကြောင်း",
  [k.CHECKLIST_UPDATES]: "စာရင်းအပြောင်းအလဲများ",
  [k.METADATA_UPDATES]: "မက်တာဒေတာအပြောင်းအလဲများ",
  [k.NO_FILTERED_RESULTS_FOUND]:
    "ရလဒ်များ မတွေ့ရပါ။ သင့်လိုအပ်သော အချက်အလက်များကို မြင်ရန် ဖီလ်တာတစ်ခုကို ရွေးပါ။",
  [k.DELETED]: "ဖျက်ပြီ",
  [k.HIDDEN]: "ဖုံးကွယ်ထားသည်",
  [k.MESSAGES]: "မှာကြောင်း",
  [k.METADATA_UPDATES]: "မက်တာဒေတာအပြောင်းအလဲများ",
  [k.MY_INBOX]: "ကျွန်ုပ်၏ အင်းဘောက်",
  [k.NO_LINKED_RECORDS]: "ဆက်စပ်ထားသော မှတ်တမ်းများ မရှိ",
  [k.APPROVAL_REQUESTED]: "အတည်ပြုချက် တောင်းပန်ထားသည်",
  [k.APPROVAL_CANCELLED]: "အတည်ပြုချက် ပယ်ဖျက်ထားသည်",
  [k.STARTED_THIS_CONVERSATION]: `ဆွေးနွေးချက်ကို စတင်ခဲ့သည်`,
  [k.SET_THE_DUE_DATE_TO]: `နောက်ဆုံးနေ့စွဲသို့ သတ်မှတ်ပါ`,
  [k.UPDATE_NAME]: `အမည်ပြောင်းရန်`,
  [k.CHANGE_PROFILE_PICTURE]: `ပရိုဖိုင်ပုံကို ပြောင်းပါ`,
  [k.CHANGE_PASSWORD1]: `စကားဝှက်ကို ပြောင်းပါ`,
  [k.PREFERENCES]: "ရွေးချယ်မှုများ",
  [k.ORG_SETTINGS1]: `အဖွဲ့အစည်းအပြင်အဆင်များ`,
  [k.CHANGE_ORG]: `အဖွဲ့အစည်းပြောင်းရန်`,
  [k.TOOLTIP_HOMESCREEN]: "ပင်မစာရင်း",
  [k.TOOLTIP_DASHBOARD]: "ဒိုင်ခြောက်",
  [k.TOOLTIP_CONTACTS]: "ဆက်သွယ်ရန်အချက်အလက်များ",
  [k.TOOLTIP_MANAGE]: "အကူအညီ",
  [k.TOOLTIP_DIRECT_MESSAGES]: "ဆွေးနွေးချက်များ",
  [k.SEND_RESPONSE_FROM_HERE]: "အချက်အလက်များကို အကူအညီကို ဆက်သွယ်ပါ",
  [k.APPROVAL_PERMISSIONS]: "အတည်ပြုချက်အချက်အလက်များ",
  [k.APPROVAL_CAN_BE_CANCELLED_BY]: "အတည်ပြုချက်ကို ပယ်ဖျက်နိုင်သည်",
  [k.MORE_OPTIONS]: `ပိုမိုအချက်အလက်များ`,
  [k.DUE]: `နောက်ဆုံးနေ့စွဲ`,
  [k.DUE_DATE]: `နောက်ဆုံးနေ့စွဲ`,
  [k.EMAIL_PLACEHOLDER]: `ဥပမာ john.doe@unifize.com`,
  [k.PENDING_CONVERSATIONS]: "အပြင်အဆင်မပြုထားသော ဆွေးနွေးချက်များ",
  [k.SEARCH_PROCESS]: `အကြောင်းအရာများကို ရှာဖွေပါ`,
  [k.LANGUAGE]: "ဘာသာစကား",
  [k.LANGUAGE_SWITCHING_HINT]: "ဘာသာစကားများကို ပြောင်းရန် အကူအညီကို ဆက်သွယ်ပါ",
  [k.LANGUAGE_SUPPORT_HINT]: "ဘာသာစကားများကို ပြောင်းရန် အကူအညီကို ဆက်သွယ်ပါ",
  [k.FIELD_NAME]: "ဖီလ်အမည်",
  [k.ADD_NEW_FIELD]: "ဖီလ်အမည်ထပ်မံပါ",
  [k.SETTINGS]: "အပြင်အဆင်များ",
  [k.SHOW_HIDE_FIELD]: "ဖီလ်အမည်ပြသပါ",
  [k.TRANSLATIONS]: `ဘာသာစကားများ`,
  [k.SUPPORTED_LANGUAGES]: `ဘာသာစကားများ`,
  [k.FULL_NAME]: "အကုန်လုံးအမည်",
  [k.UPDATED]: "ပြင်ဆင်ထားသည်",
  [k.MY_INBOX]: "ကျွန်ုပ်၏ အင်းဘောက်",
  [k.SEARCH_PEOPLE]: `အသုံးပြုသူများကို ရှာဖွေပါ`,
  [k.A_NEW_VERSION_OF_UNIFIZE_HAS_B]: `Unifize အသစ်တစ်ခုကို ပြန်လည်စမ်းသပ်ပါ`,
  [k.WRONG_PASSWORD_MESSAGE]:
    "(အနည်းဆုံး 8 လုံး, 1 အောက်ပါသုံးစွဲကိုယ်စားလှယ်ကိုယ်စားလှယ်, 1 အောက်ပါသုံးစွဲကိုယ်စားလှယ်, 1 အောက်ပါသုံးစွဲကိုယ်စားလှယ်)",

  [k.CHANGED_THE_OWNER_FROM]: `အဆင့်ကို ပြောင်းလဲထားသည်`,
  [k.AS_THE_OWNER]: `ပိုင်ရှင်အဖြစ်`,
  [k.TURNED_OFF_REMINDERS_FOR_THIS]: `ဤဆွေးနွေးချက်များအတွက် အတိပ်ချမှုများကို ပိတ်ပါ`,
  [k.TURNED_ON_REMINDERS_FOR_THIS_C]: `ဤဆွေးနွေးချက်များအတွက် အတိပ်ချမှုများကို အပြင်ပါ`,
  [k.TURN_ON]: `အပြင်ပါ`,
  [k.TURN_OFF]: `ပိတ်ပါ`,
  [k.SELECT_ALL_PENDING]: "အပြင်အဆင်မပြုထားသော အားလုံးကို ရွေးချယ်ပါ",
  [k.SELECT_ALL_COMPLETE]: "ပြီးစီးသော အားလုံးကို ရွေးချယ်ပါ",
  [k.CAN_T_FIND_SOMEONE]: `မည်သူကို မတွေ့နိုင်ပါ?`,
  [k.INVITE_THEM_TO_UNIFIZE_VIA_EMA]: `အီးမေးလ်ဖြင့် Unifize သို့ ဖိတ်ကြားပါ`,
  [k.MEMBERS2]: `အသုံးပြုသူများ`,
  [k.SEARCH_PEOPLE_OR_GROUPS]: `အသုံးပြုသူများသို့ အဖွဲ့အစည်းများကို ရှာဖွေပါ`,
  [k.NO_RESULTS_FOR]: `ရလဒ်များ မတွေ့ရပါ။`,
  [k.THIS_CONVERSATION_IS_PRIVATE]: `ဤဆွေးနွေးချက်သည် ကိုယ်ရေးကိုယ်တာဖြစ်သည်`,
  [k.UPDATED_STATUS_OF_THIS_CONVERS]: `ဤဆွေးနွေးချက်အတွက် အဆင့်ကို ပြောင်းလဲထားသည်`,
  [k.UPDATED_STATUS_OF_THE_CONVERSA]: `ဆွေးနွေးချက်အတွက် အဆင့်ကို ပြောင်းလဲထားသည်`,
  [k.UPDATED_THE_DUE_DATE_TO]: `နောက်ဆုံးနေ့စွဲသို့ သတ်မှတ်ထားသည်`,
  [k.ENTER_OPTIONAL_COMMENT_HERE]: "အတိုင်းအတာပြုစာတန်းကို ထည့်ပါ",
  [k.TURN_OFF_REMINDERS]: `အတိပ်ချမှုများကို ပိတ်ပါ`,
  [k.THIS_IS_YOUR_DIRECT_MESSAGE_WI]: `@ နှင့် သင့်ရဲ့ တိုက်ရိုက်ဆက်သွယ်မှုဖြစ်သည်`,
  [k.PEOPLE1]: `လူများ`,
  [k.CREATE_GROUP]: `အဖွဲ့အစည်းတစ်ခုကို ဖန်တီးပါ`,
  [k.CREATE_NEW_GROUP]: `အဖွဲ့အစည်းသစ်တစ်ခုကို ဖန်တီးပါ`,
  [k.GROUP_NAME]: `အဖွဲ့အစည်းအမည်`,
  [k.ADD_PARTICIPANTS1]: `ပါဝင်သူများကို ထပ်မံပါ`,
  [k.GROUP_OWNERS]: `အဖွဲ့အစည်းပိုင်ရှင်များ`,
  [k.GROUP_NAME1]: `အဖွဲ့အစည်းအမည်`,
  [k.LOCK_GROUP]: `အဖွဲ့အစည်းကို ပိတ်ပါ`,
  [k.GROUP_OWNERS1]: `အဖွဲ့အစည်းပိုင်ရှင်များ`,
  [k.ONLY_THE_GROUP_OWNER_CAN_MAKE]: `အဖွဲ့အစည်းပိုင်ရှင်သာ ပိတ်ထားသော အဖွဲ့အစည်းတွင် ပြောင်းလဲမှုများ ပြုလုပ်နိုင်သည်`,
  [k.ACTIVE_INSTANCES]: `အသုံးပြုထားသည်`,
  [k.TOTAL_INSTANCES]: `အားလုံး`,
  [k.CREATED_BY1]: `ဖန်တီးသည်`,
  [k.CREATED_BY2]: `ဖန်တီးသည်`,
  [k.UPDATED_THE_PRIORITY_FROM]: `အဆင့်ကို ပြောင်းလဲထားသည်`,
  [k.CHANGED_THE_PRIVACY_SETTING_TO]: `အကူအညီကို ဆက်သွယ်ပါ`,
  [k.TURN_ON]: `အပြင်ပါ`,
  [k.TURN_OFF]: `ပိတ်ပါ`,
  [k.UNIFIZE_ASSISTANT]: `Unifize Assistant`,
  [k.TURN_OFF_REMINDERS]: `အတိပ်ချမှုများကို ပိတ်ပါ`,
  [k.REMINDERS_HAVE_BEEN_TURNED_OFF]: `အတိပ်ချမှုများကို ပိတ်ထားသည်`,
  [k.OF_THIS_CONVERSATION]: `ဤဆွေးနွေးချက်အတွက်`,
  [k.CANCELLED1]: `ပယ်ဖျက်ပြီးသည်`,
  [k.DELETED_A_FILE]: `ဖိုင်တစ်ခုကို ပယ်ဖျက်ပြီးသည်။`,
  [k.DELETED_FIELD]: `ဖျက်ပြီးသော ဖီးလ်`,
  [k.DELETED_FIELD1]: `(ဖျက်ပြီးသော ဖီးလ်)!`,
  [k.DELETED_USER]: `ဖျက်ပြီးသော အသုံးပြုသူ`,
  [k.DELETED_FIELDS]: `ဖျက်ပြီးသော ဖီးလ်များ`,
  [k.DELETED_A]: `ဖျက်ပြီးသော`,
  [k.REMOVED]: `removed`,
  [k.ASSIGNED]: `assigned`,
  [k.UPDATED_STATUS_OF_THIS_CONVERS]: `အဆင့်ကို ပြောင်းလဲထားသည်`,
  [k.UPDATED_STATUS_OF_THE_CONVERSA]: `ဆွေးနွေးချက်အတွက် အဆင့်ကို ပြောင်းလဲထားသည်`,
  [k.UPDATED_THE_DUE_DATE_TO]: `နောက်ဆုံးနေ့စွဲသို့ သတ်မှတ်ထားသည်`,
  [k.SET_THE_DUE_DATE_TO]: `နောက်ဆုံးနေ့စွဲသို့ သတ်မှတ်ထားသည်`,
  [k.REMOVED_THE_DUE_DATE]: `နောက်ဆုံးနေ့စွဲကို ပယ်ဖျက်ပြီးသည်`,
  [k.TO2]: `အားလုံးကို ပေးပို့ထားသည်`,
  [k.CC1]: `CC:`,
  [k.BCC1]: `BCC:`,
  [k.NO_CONTENT]: `မရှိပါ`,
  [k.ATTACHMENTS]: `မှတ်ချက်များ`,
  [k.HID_A_MESSAGE]: `မှတ်ချက်တစ်ခုကို ဖုံးလွှမ်းပါ`,
  [k.UNHIDE]: `ဖုံးလွှမ်းမှုကို ဖျက်ပါ`,
  [k.UPLOADED_A_FILE]: `ဖိုင်တစ်ခုကို ထည့်ပါ`,
  [k.SENT_AN_EMAIL]: `အီးမေးလ်တစ်ခုကို ပေးပို့ထားသည်`,
  [k.ADDED_A_FORM]: `ဖီးလ်တစ်ခုကို ထည့်ပါ`,
  [k.TO_THE_CHECKLIST]: `ဖီးလ်တစ်ခုကို ထည့်ပါ`,
  [k.REMOVED_A_FORM]: `ဖီးလ်တစ်ခုကို ဖျက်ပါ`,
  [k.FROM_THE_CHECKLIST1]: `ဖီးလ်တစ်ခုကို ဖျက်ပါ`,
  [k.USER]: `အသုံးပြုသူ-`,
  [k.RICH_TEXT]: `အသုံးပြုသူ စာသား`,
  [k.TEXT]: `စာသား`,
  [k.NUMBER]: `အမှတ်`,
  [k.DATE]: `နေ့စွဲ`,
  [k.USER]: `အသုံးပြုသူ`,
  [k.SECTION]: `အဖွဲ့အစည်း`,
  [k.SUBSECTION]: `အဖွဲ့အစည်း`,
  [k.CONVERSATION2]: `ဆွေးနွေးချက်`,
  [k.PARENT_CONVERSATION]: `ဆွေးနွေးချက်`,
  [k.CHILD_CONVERSATION]: `ဆွေးနွေးချက်`,
  [k.PDF]: `ဖိုင်တစ်ခုကို ထည့်ပါ`,
  [k.FILE_UPLOAD]: `ဖိုင်တစ်ခုကို ထည့်ပါ`,
  [k.FORM]: `ဖီးလ်တစ်ခုကို ထည့်ပါ`,
  [k.REVISION]: `ဖီးလ်တစ်ခုကို ထည့်ပါ`,
  [k.LINKED_FIELD]: `ဖီးလ်တစ်ခုကို ထည့်ပါ`,
  [k.UPLOAD_FIELDS_FROM_CSV]: `ဖီးလ်တစ်ခုကို ထည့်ပါ`,
  [k.UPLOAD_FIELDS_JSON]: `ဖီးလ်တစ်ခုကို ထည့်ပါ`,
  [k.UPDATE_NOW]: `အသစ်ပြောင်းလဲပါ`,
  [k.AND_REJECTED]: "ပယ်ချခဲ့သည်။",
  [k.AI_SUGGESTED_CHECKLIST_VALUES_FOR]:
    "AI ဖြင့် အကြံပြုထားသော စာရင်းတန်ဖိုးများ အတွက်",
  [k.AI_CHECKLIST_PREPARATION]:
    "Unifize AI သည် သင့်စာရင်းစစ်အကြံပြုချက်များကို ပြင်ဆင်နေသည်။ မကြာခင်မှာ ပြီးပါလိမ့်မယ်...",
  [k.INVALID_VALUE]: "မမှန်ကန်သော တန်ဖိုး",
  [k.BUILD_WITH_AI]: "AI ဖြင့်တည်ဆောက်ခြင်း။",
  [k.ADD_TO_CHECKLIST]: "စစ်ဆေးရန်စာရင်းသို့ထည့်ပါ။",
  [k.SELECT_DATA_TO_COPY_TO_NEW]:
    "အသစ်ပြင်ဆင်မှုသို့ ကူးယူရန် အချက်အလက်များကို ရွေးချယ်ပါ",
  [k.REQUESTED]: "တောင်းဆိုထားသည်",
  [k.CANCELLED]: "ပယ်ဖျက်ထားသည်",
  [k.UPDATED_CHECKLIST]: "စာရင်းကို ပြောင်းလဲထားသည်",
  [k.APPROVAL_PASSWORD_INFO]:
    "လျှို့ဝှက်နံပါတ်အခြေခံ အတည်ပြုမှုများကို အသုံးပြုရန်၊ မိမိစကားဝှက်ကို Profile → Change Password သို့ သွားပြီး သတ်မှတ်ပါ။",
  [k.SQUARE_BRACKETS_NOT_ALLOWED]:
    "စတုရန်းကွင်းများ '[' နှင့် ']' ကို ခွင့်ပြုမထားပါ",
};
